var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceMangIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93,
    height: 70,
    viewBox: "0 0 93 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: 0.4;\r\n      }\r\n\r\n      .cls-203, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        stroke: #5a7996;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-6, .cls-8 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-7, .cls-8 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #1d354e;\r\n      }\r\n\r\n      .cls-10 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-11 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #6585a5;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #6283a3;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #6282a2;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #6182a2;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #6182a1;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #6181a1;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #6081a0;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #6080a0;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #60809f;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #5f809f;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #5f7f9f;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #5f7f9e;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #5f7f9d;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #5e7e9d;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #5e7e9c;\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #5e7d9c;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #5d7d9b;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #5d7c9b;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: #5d7c9a;\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #5c7c9a;\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: #5c7b99;\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: #5c7a98;\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: #5b7a98;\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: #5b7a97;\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: #5b7997;\r\n      }\r\n\r\n      .cls-37 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: #344657;\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: #354657;\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: #354758;\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: #354759;\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: #364859;\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: #36485a;\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: #384c5e;\r\n      }\r\n\r\n      .cls-45 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: #36495a;\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: #37495b;\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: #374a5b;\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: #374a5c;\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: #384a5d;\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: #384b5d;\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: #384b5e;\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: #394c5e;\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: #394c5f;\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: #394d5f;\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: #394d60;\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: #3a4d60;\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: #3a4e61;\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: #3b4e61;\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: #3b4e62;\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: #3b4f62;\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: #3b4f63;\r\n      }\r\n\r\n      .cls-63 {\r\n        fill: #3c5063;\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: #3c5064;\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: #3c5164;\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: #3c5165;\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: #3d5165;\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: #3d5266;\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: #3e5266;\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: #3e5367;\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: #3e5368;\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: #3f5468;\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: #3f5469;\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: #3f5569;\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: #40556a;\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: #40566b;\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: #41566b;\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: #41566c;\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: #41576c;\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: #41576d;\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: #41586d;\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: #42586d;\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: #42586e;\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: #42596e;\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: #42596f;\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: #43596f;\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: #435a70;\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: #445a70;\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: #445b71;\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: #445b72;\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: #455c72;\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: #455c73;\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: #455d73;\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: #465d74;\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: #465e74;\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: #465e75;\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: #475e75;\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: #475f76;\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: #475f77;\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: #476077;\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: #486077;\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: #486078;\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: #486178;\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: #496179;\r\n      }\r\n\r\n      .cls-105 {\r\n        fill: #49627a;\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: #4a627a;\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: #4a637b;\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: #4a637c;\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: #4b647c;\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: #4b647d;\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: #4b657d;\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: #4b657e;\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: #4c657e;\r\n      }\r\n\r\n      .cls-114 {\r\n        fill: #4c667e;\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: #4c667f;\r\n      }\r\n\r\n      .cls-116 {\r\n        fill: #4d667f;\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: #4d6780;\r\n      }\r\n\r\n      .cls-118 {\r\n        fill: #4d6781;\r\n      }\r\n\r\n      .cls-119 {\r\n        fill: #4e6881;\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: #4e6882;\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: #4e6982;\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: #4f6983;\r\n      }\r\n\r\n      .cls-123 {\r\n        fill: #4f6a83;\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: #4f6a84;\r\n      }\r\n\r\n      .cls-125 {\r\n        fill: #506a84;\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: #506a85;\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: #506b85;\r\n      }\r\n\r\n      .cls-128 {\r\n        fill: #506b86;\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: #506c86;\r\n      }\r\n\r\n      .cls-130 {\r\n        fill: #516c86;\r\n      }\r\n\r\n      .cls-131 {\r\n        fill: #516c87;\r\n      }\r\n\r\n      .cls-132 {\r\n        fill: #516d87;\r\n      }\r\n\r\n      .cls-133 {\r\n        fill: #526d88;\r\n      }\r\n\r\n      .cls-134 {\r\n        fill: #526e88;\r\n      }\r\n\r\n      .cls-135 {\r\n        fill: #526e89;\r\n      }\r\n\r\n      .cls-136 {\r\n        fill: #536e89;\r\n      }\r\n\r\n      .cls-137 {\r\n        fill: #536f8a;\r\n      }\r\n\r\n      .cls-138 {\r\n        fill: #536f8b;\r\n      }\r\n\r\n      .cls-139 {\r\n        fill: #54708b;\r\n      }\r\n\r\n      .cls-140 {\r\n        fill: #54708c;\r\n      }\r\n\r\n      .cls-141 {\r\n        fill: #54718c;\r\n      }\r\n\r\n      .cls-142 {\r\n        fill: #55718d;\r\n      }\r\n\r\n      .cls-143 {\r\n        fill: #55728d;\r\n      }\r\n\r\n      .cls-144 {\r\n        fill: #55728e;\r\n      }\r\n\r\n      .cls-145 {\r\n        fill: #56728e;\r\n      }\r\n\r\n      .cls-146 {\r\n        fill: #56738f;\r\n      }\r\n\r\n      .cls-147 {\r\n        fill: #567390;\r\n      }\r\n\r\n      .cls-148 {\r\n        fill: #567490;\r\n      }\r\n\r\n      .cls-149 {\r\n        fill: #577490;\r\n      }\r\n\r\n      .cls-150 {\r\n        fill: #577491;\r\n      }\r\n\r\n      .cls-151 {\r\n        fill: #577591;\r\n      }\r\n\r\n      .cls-152 {\r\n        fill: #587592;\r\n      }\r\n\r\n      .cls-153 {\r\n        fill: #587692;\r\n      }\r\n\r\n      .cls-154 {\r\n        fill: #587693;\r\n      }\r\n\r\n      .cls-155 {\r\n        fill: #597693;\r\n      }\r\n\r\n      .cls-156 {\r\n        fill: #597794;\r\n      }\r\n\r\n      .cls-157 {\r\n        fill: #597795;\r\n      }\r\n\r\n      .cls-158 {\r\n        fill: #5a7895;\r\n      }\r\n\r\n      .cls-159 {\r\n        fill: #5a7896;\r\n      }\r\n\r\n      .cls-160 {\r\n        fill: #5a7996;\r\n      }\r\n\r\n      .cls-161 {\r\n        fill: #6888a7;\r\n      }\r\n\r\n      .cls-162 {\r\n        fill: #6a8aa8;\r\n      }\r\n\r\n      .cls-163 {\r\n        fill: #6c8ba9;\r\n      }\r\n\r\n      .cls-164 {\r\n        fill: #6e8caa;\r\n      }\r\n\r\n      .cls-165 {\r\n        fill: #6f8dab;\r\n      }\r\n\r\n      .cls-166 {\r\n        fill: #708eab;\r\n      }\r\n\r\n      .cls-167 {\r\n        fill: #718fac;\r\n      }\r\n\r\n      .cls-168 {\r\n        fill: #7290ac;\r\n      }\r\n\r\n      .cls-169 {\r\n        fill: #7390ad;\r\n      }\r\n\r\n      .cls-170 {\r\n        fill: #7491ad;\r\n      }\r\n\r\n      .cls-171 {\r\n        fill: #7592ae;\r\n      }\r\n\r\n      .cls-172 {\r\n        fill: #7692ae;\r\n      }\r\n\r\n      .cls-173 {\r\n        fill: #7693af;\r\n      }\r\n\r\n      .cls-174 {\r\n        fill: #7794af;\r\n      }\r\n\r\n      .cls-175 {\r\n        fill: #7894b0;\r\n      }\r\n\r\n      .cls-176 {\r\n        fill: #7895b0;\r\n      }\r\n\r\n      .cls-177 {\r\n        fill: #7995b1;\r\n      }\r\n\r\n      .cls-178 {\r\n        fill: #7a96b1;\r\n      }\r\n\r\n      .cls-179 {\r\n        fill: #7b97b2;\r\n      }\r\n\r\n      .cls-180 {\r\n        fill: #7c97b2;\r\n      }\r\n\r\n      .cls-181 {\r\n        fill: #7c98b2;\r\n      }\r\n\r\n      .cls-182 {\r\n        fill: #7d98b3;\r\n      }\r\n\r\n      .cls-183 {\r\n        fill: #7d99b3;\r\n      }\r\n\r\n      .cls-184 {\r\n        fill: #7e99b3;\r\n      }\r\n\r\n      .cls-185 {\r\n        fill: #7f9ab4;\r\n      }\r\n\r\n      .cls-186 {\r\n        fill: #809ab4;\r\n      }\r\n\r\n      .cls-187 {\r\n        fill: #809bb5;\r\n      }\r\n\r\n      .cls-188 {\r\n        fill: #819bb5;\r\n      }\r\n\r\n      .cls-189 {\r\n        fill: #819cb5;\r\n      }\r\n\r\n      .cls-190 {\r\n        fill: #829cb6;\r\n      }\r\n\r\n      .cls-191 {\r\n        fill: #839db6;\r\n      }\r\n\r\n      .cls-192 {\r\n        fill: #849eb7;\r\n      }\r\n\r\n      .cls-193 {\r\n        fill: #859fb7;\r\n      }\r\n\r\n      .cls-194 {\r\n        fill: #859fb8;\r\n      }\r\n\r\n      .cls-195 {\r\n        fill: #869fb8;\r\n      }\r\n\r\n      .cls-196 {\r\n        fill: #86a0b8;\r\n      }\r\n\r\n      .cls-197 {\r\n        fill: #87a0b8;\r\n      }\r\n\r\n      .cls-198 {\r\n        fill: #87a0b9;\r\n      }\r\n\r\n      .cls-199 {\r\n        fill: #88a1b9;\r\n      }\r\n\r\n      .cls-200 {\r\n        fill: #89a2ba;\r\n      }\r\n\r\n      .cls-201 {\r\n        fill: #8aa2ba;\r\n      }\r\n\r\n      .cls-202 {\r\n        fill: #344556;\r\n      }\r\n\r\n      .cls-204 {\r\n        clip-path: url(#clip-path-4);\r\n      }\r\n\r\n      .cls-205 {\r\n        clip-path: url(#clip-path-5);\r\n      }\r\n\r\n      .cls-206 {\r\n        clip-path: url(#clip-path-6);\r\n      }\r\n\r\n      .cls-207 {\r\n        fill: #2d4e71;\r\n      }\r\n\r\n      .cls-208 {\r\n        fill: #294b6e;\r\n      }\r\n\r\n      .cls-209 {\r\n        fill: #294b6d;\r\n      }\r\n\r\n      .cls-210 {\r\n        fill: #294a6d;\r\n      }\r\n\r\n      .cls-211 {\r\n        fill: #284a6d;\r\n      }\r\n\r\n      .cls-212 {\r\n        fill: #284a6c;\r\n      }\r\n\r\n      .cls-213 {\r\n        fill: #28496c;\r\n      }\r\n\r\n      .cls-214 {\r\n        fill: #28496b;\r\n      }\r\n\r\n      .cls-215 {\r\n        fill: #28496a;\r\n      }\r\n\r\n      .cls-216 {\r\n        fill: #28486a;\r\n      }\r\n\r\n      .cls-217 {\r\n        fill: #27486a;\r\n      }\r\n\r\n      .cls-218 {\r\n        fill: #274869;\r\n      }\r\n\r\n      .cls-219 {\r\n        fill: #274769;\r\n      }\r\n\r\n      .cls-220 {\r\n        fill: #274768;\r\n      }\r\n\r\n      .cls-221 {\r\n        fill: #274667;\r\n      }\r\n\r\n      .cls-222 {\r\n        fill: #264667;\r\n      }\r\n\r\n      .cls-223 {\r\n        fill: #264666;\r\n      }\r\n\r\n      .cls-224 {\r\n        fill: #264566;\r\n      }\r\n\r\n      .cls-225 {\r\n        clip-path: url(#clip-path-7);\r\n      }\r\n\r\n      .cls-226 {\r\n        clip-path: url(#clip-path-8);\r\n      }\r\n\r\n      .cls-227 {\r\n        fill: #325274;\r\n      }\r\n\r\n      .cls-228 {\r\n        fill: #345576;\r\n      }\r\n\r\n      .cls-229 {\r\n        fill: #375777;\r\n      }\r\n\r\n      .cls-230 {\r\n        fill: #395879;\r\n      }\r\n\r\n      .cls-231 {\r\n        fill: #3a5a7a;\r\n      }\r\n\r\n      .cls-232 {\r\n        fill: #3c5b7b;\r\n      }\r\n\r\n      .cls-233 {\r\n        fill: #3e5c7c;\r\n      }\r\n\r\n      .cls-234 {\r\n        fill: #3f5d7d;\r\n      }\r\n\r\n      .cls-235 {\r\n        fill: #405e7e;\r\n      }\r\n\r\n      .cls-236 {\r\n        fill: #415f7f;\r\n      }\r\n\r\n      .cls-237 {\r\n        fill: #43607f;\r\n      }\r\n\r\n      .cls-238 {\r\n        fill: #446180;\r\n      }\r\n\r\n      .cls-239 {\r\n        fill: #456281;\r\n      }\r\n\r\n      .cls-240 {\r\n        fill: #466381;\r\n      }\r\n\r\n      .cls-241 {\r\n        fill: #476482;\r\n      }\r\n\r\n      .cls-242 {\r\n        fill: #486583;\r\n      }\r\n\r\n      .cls-243 {\r\n        fill: #496683;\r\n      }\r\n\r\n      .cls-244 {\r\n        fill: #496684;\r\n      }\r\n\r\n      .cls-245 {\r\n        fill: #4a6785;\r\n      }\r\n\r\n      .cls-246 {\r\n        fill: #4b6885;\r\n      }\r\n\r\n      .cls-247 {\r\n        fill: #4c6886;\r\n      }\r\n\r\n      .cls-248 {\r\n        fill: #4d6986;\r\n      }\r\n\r\n      .cls-249 {\r\n        fill: #4e6a87;\r\n      }\r\n\r\n      .cls-250 {\r\n        fill: #4f6b88;\r\n      }\r\n\r\n      .cls-251 {\r\n        fill: #506c88;\r\n      }\r\n\r\n      .cls-252 {\r\n        fill: #516c89;\r\n      }\r\n\r\n      .cls-253 {\r\n        fill: #516d89;\r\n      }\r\n\r\n      .cls-254 {\r\n        fill: #526e8a;\r\n      }\r\n\r\n      .cls-255 {\r\n        fill: #536e8a;\r\n      }\r\n\r\n      .cls-256 {\r\n        fill: #546f8b;\r\n      }\r\n\r\n      .cls-257 {\r\n        fill: #55708c;\r\n      }\r\n\r\n      .cls-258 {\r\n        fill: #56718d;\r\n      }\r\n\r\n      .cls-259 {\r\n        fill: #57718d;\r\n      }\r\n\r\n      .cls-260 {\r\n        fill: #57728d;\r\n      }\r\n\r\n      .cls-261 {\r\n        fill: #58738e;\r\n      }\r\n\r\n      .cls-262 {\r\n        fill: #59738e;\r\n      }\r\n\r\n      .cls-263 {\r\n        fill: #59748f;\r\n      }\r\n\r\n      .cls-264 {\r\n        fill: #5a748f;\r\n      }\r\n\r\n      .cls-265 {\r\n        fill: #5a758f;\r\n      }\r\n\r\n      .cls-266 {\r\n        fill: #5b7590;\r\n      }\r\n\r\n      .cls-267 {\r\n        fill: #5c7690;\r\n      }\r\n\r\n      .cls-268 {\r\n        fill: #5c7691;\r\n      }\r\n\r\n      .cls-269 {\r\n        fill: #5d7691;\r\n      }\r\n\r\n      .cls-270 {\r\n        fill: #5d7791;\r\n      }\r\n\r\n      .cls-271 {\r\n        fill: #5e7792;\r\n      }\r\n\r\n      .cls-272 {\r\n        fill: #5e7892;\r\n      }\r\n\r\n      .cls-273 {\r\n        fill: #5f7892;\r\n      }\r\n\r\n      .cls-274 {\r\n        clip-path: url(#clip-path-9);\r\n      }\r\n\r\n      .cls-275 {\r\n        clip-path: url(#clip-path-10);\r\n      }\r\n\r\n      .cls-276 {\r\n        clip-path: url(#clip-path-11);\r\n      }\r\n\r\n      .cls-277 {\r\n        clip-path: url(#clip-path-12);\r\n      }\r\n\r\n      .cls-278 {\r\n        fill: #16283a;\r\n      }\r\n\r\n      .cls-279 {\r\n        fill: #16283b;\r\n      }\r\n\r\n      .cls-280 {\r\n        fill: #16293c;\r\n      }\r\n\r\n      .cls-281 {\r\n        fill: #17293c;\r\n      }\r\n\r\n      .cls-282 {\r\n        fill: #17293d;\r\n      }\r\n\r\n      .cls-283 {\r\n        fill: #172a3d;\r\n      }\r\n\r\n      .cls-284 {\r\n        fill: #172a3e;\r\n      }\r\n\r\n      .cls-285 {\r\n        fill: #172b3e;\r\n      }\r\n\r\n      .cls-286 {\r\n        fill: #172b3f;\r\n      }\r\n\r\n      .cls-287 {\r\n        fill: #182b3f;\r\n      }\r\n\r\n      .cls-288 {\r\n        fill: #182b40;\r\n      }\r\n\r\n      .cls-289 {\r\n        fill: #182c40;\r\n      }\r\n\r\n      .cls-290 {\r\n        fill: #182c41;\r\n      }\r\n\r\n      .cls-291 {\r\n        fill: #182d41;\r\n      }\r\n\r\n      .cls-292 {\r\n        fill: #182d42;\r\n      }\r\n\r\n      .cls-293 {\r\n        fill: #192d42;\r\n      }\r\n\r\n      .cls-294 {\r\n        fill: #192d43;\r\n      }\r\n\r\n      .cls-295 {\r\n        fill: #192e43;\r\n      }\r\n\r\n      .cls-296 {\r\n        fill: #192e44;\r\n      }\r\n\r\n      .cls-297 {\r\n        fill: #192f44;\r\n      }\r\n\r\n      .cls-298 {\r\n        fill: #1a2f44;\r\n      }\r\n\r\n      .cls-299 {\r\n        fill: #1a2f45;\r\n      }\r\n\r\n      .cls-300 {\r\n        fill: #1a2f46;\r\n      }\r\n\r\n      .cls-301 {\r\n        fill: #1a3046;\r\n      }\r\n\r\n      .cls-302 {\r\n        fill: #1a3047;\r\n      }\r\n\r\n      .cls-303 {\r\n        fill: #1b3147;\r\n      }\r\n\r\n      .cls-304 {\r\n        fill: #1b3148;\r\n      }\r\n\r\n      .cls-305 {\r\n        fill: #1b3149;\r\n      }\r\n\r\n      .cls-306 {\r\n        fill: #1b3249;\r\n      }\r\n\r\n      .cls-307 {\r\n        fill: #1b324a;\r\n      }\r\n\r\n      .cls-308 {\r\n        fill: #1c324a;\r\n      }\r\n\r\n      .cls-309 {\r\n        fill: #1c334a;\r\n      }\r\n\r\n      .cls-310 {\r\n        fill: #1c334b;\r\n      }\r\n\r\n      .cls-311 {\r\n        fill: #1c344c;\r\n      }\r\n\r\n      .cls-312 {\r\n        fill: #1d344d;\r\n      }\r\n\r\n      .cls-313 {\r\n        fill: #1d354d;\r\n      }\r\n\r\n      .cls-314 {\r\n        fill: #1d364f;\r\n      }\r\n\r\n      .cls-315 {\r\n        fill: #1e364f;\r\n      }\r\n\r\n      .cls-316 {\r\n        fill: #1e3650;\r\n      }\r\n\r\n      .cls-317 {\r\n        fill: #1e3750;\r\n      }\r\n\r\n      .cls-318 {\r\n        fill: #1e3751;\r\n      }\r\n\r\n      .cls-319 {\r\n        fill: #1e3851;\r\n      }\r\n\r\n      .cls-320 {\r\n        fill: #1e3852;\r\n      }\r\n\r\n      .cls-321 {\r\n        fill: #1f3852;\r\n      }\r\n\r\n      .cls-322 {\r\n        fill: #1f3853;\r\n      }\r\n\r\n      .cls-323 {\r\n        fill: #1f3953;\r\n      }\r\n\r\n      .cls-324 {\r\n        fill: #1f3954;\r\n      }\r\n\r\n      .cls-325 {\r\n        fill: #1f3a54;\r\n      }\r\n\r\n      .cls-326 {\r\n        fill: #203a55;\r\n      }\r\n\r\n      .cls-327 {\r\n        fill: #203a56;\r\n      }\r\n\r\n      .cls-328 {\r\n        fill: #203b56;\r\n      }\r\n\r\n      .cls-329 {\r\n        fill: #203b57;\r\n      }\r\n\r\n      .cls-330 {\r\n        fill: #213b57;\r\n      }\r\n\r\n      .cls-331 {\r\n        fill: #213c57;\r\n      }\r\n\r\n      .cls-332 {\r\n        fill: #213c58;\r\n      }\r\n\r\n      .cls-333 {\r\n        fill: #213c59;\r\n      }\r\n\r\n      .cls-334 {\r\n        fill: #213d59;\r\n      }\r\n\r\n      .cls-335 {\r\n        fill: #213d5a;\r\n      }\r\n\r\n      .cls-336 {\r\n        fill: #223d5a;\r\n      }\r\n\r\n      .cls-337 {\r\n        fill: #223e5a;\r\n      }\r\n\r\n      .cls-338 {\r\n        fill: #223e5b;\r\n      }\r\n\r\n      .cls-339 {\r\n        fill: #223e5c;\r\n      }\r\n\r\n      .cls-340 {\r\n        fill: #223f5c;\r\n      }\r\n\r\n      .cls-341 {\r\n        fill: #233f5d;\r\n      }\r\n\r\n      .cls-342 {\r\n        fill: #23405d;\r\n      }\r\n\r\n      .cls-343 {\r\n        fill: #23405e;\r\n      }\r\n\r\n      .cls-344 {\r\n        fill: #23415f;\r\n      }\r\n\r\n      .cls-345 {\r\n        fill: #24415f;\r\n      }\r\n\r\n      .cls-346 {\r\n        fill: #244160;\r\n      }\r\n\r\n      .cls-347 {\r\n        fill: #244260;\r\n      }\r\n\r\n      .cls-348 {\r\n        fill: #244261;\r\n      }\r\n\r\n      .cls-349 {\r\n        fill: #244362;\r\n      }\r\n\r\n      .cls-350 {\r\n        fill: #254362;\r\n      }\r\n\r\n      .cls-351 {\r\n        fill: #254363;\r\n      }\r\n\r\n      .cls-352 {\r\n        fill: #254463;\r\n      }\r\n\r\n      .cls-353 {\r\n        fill: #254464;\r\n      }\r\n\r\n      .cls-354 {\r\n        fill: #264565;\r\n      }\r\n\r\n      .cls-355 {\r\n        clip-path: url(#clip-path-13);\r\n      }\r\n\r\n      .cls-356 {\r\n        clip-path: url(#clip-path-14);\r\n      }\r\n\r\n      .cls-357 {\r\n        clip-path: url(#clip-path-15);\r\n      }\r\n\r\n      .cls-358 {\r\n        clip-path: url(#clip-path-16);\r\n      }\r\n\r\n      .cls-359 {\r\n        fill: #43617f;\r\n      }\r\n\r\n      .cls-360 {\r\n        fill: #4d6a87;\r\n      }\r\n\r\n      .cls-361 {\r\n        fill: #627b95;\r\n      }\r\n\r\n      .cls-362 {\r\n        fill: #688099;\r\n      }\r\n\r\n      .cls-363 {\r\n        fill: #6d849c;\r\n      }\r\n\r\n      .cls-364 {\r\n        fill: #72889f;\r\n      }\r\n\r\n      .cls-365 {\r\n        fill: #768ca2;\r\n      }\r\n\r\n      .cls-366 {\r\n        fill: #7a8fa5;\r\n      }\r\n\r\n      .cls-367 {\r\n        fill: #7e93a8;\r\n      }\r\n\r\n      .cls-368 {\r\n        fill: #8296aa;\r\n      }\r\n\r\n      .cls-369 {\r\n        fill: #8699ad;\r\n      }\r\n\r\n      .cls-370 {\r\n        fill: #899caf;\r\n      }\r\n\r\n      .cls-371 {\r\n        clip-path: url(#clip-path-17);\r\n      }\r\n\r\n      .cls-372 {\r\n        fill: #8c9fb1;\r\n      }\r\n\r\n      .cls-373 {\r\n        fill: #90a1b4;\r\n      }\r\n\r\n      .cls-374 {\r\n        fill: #93a4b6;\r\n      }\r\n\r\n      .cls-375 {\r\n        fill: #96a7b8;\r\n      }\r\n\r\n      .cls-376 {\r\n        fill: #99a9ba;\r\n      }\r\n\r\n      .cls-377 {\r\n        clip-path: url(#clip-path-18);\r\n      }\r\n\r\n      .cls-378 {\r\n        clip-path: url(#clip-path-19);\r\n      }\r\n\r\n      .cls-379 {\r\n        clip-path: url(#clip-path-20);\r\n      }\r\n\r\n      .cls-380 {\r\n        clip-path: url(#clip-path-21);\r\n      }\r\n\r\n      .cls-381 {\r\n        clip-path: url(#clip-path-22);\r\n      }\r\n\r\n      .cls-382 {\r\n        clip-path: url(#clip-path-23);\r\n      }\r\n\r\n      .cls-383 {\r\n        clip-path: url(#clip-path-24);\r\n      }\r\n\r\n      .cls-384 {\r\n        filter: url(#Path_2504);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-1",
    d: "M-90.522,45.612l1.816.445a.305.305,0,0,0-.16.005l-1.816-.445A.319.319,0,0,1-90.522,45.612Z",
    transform: "translate(90.682 -45.604)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M-113.716,54.953l-1.816-.444a.459.459,0,0,1-.283-.48l1.816.444A.461.461,0,0,0-113.716,54.953Z",
    transform: "translate(115.816 -54.029)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-1",
    d: "M-114.006,53.881l-1.816-.444a.742.742,0,0,1,.422-.721l1.816.445A.74.74,0,0,0-114.006,53.881Z",
    transform: "translate(115.822 -52.716)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-1",
    d: "M-97.847,30.751a4.183,4.183,0,0,0-.767-.267l1.816.444a4.246,4.246,0,0,1,.767.267l-.908-.222-.238-.058-.118-.029C-97.478,30.841-97.668,30.814-97.847,30.751Z",
    transform: "translate(98.614 -30.484)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    className: "cls-1",
    d: "M-93.663,9.138l1.818.444a.933.933,0,0,0-.483.015l-1.818-.445A.946.946,0,0,1-93.663,9.138Z",
    transform: "translate(94.146 -9.113)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    className: "cls-1",
    d: "M-98.292,30.511l1.816.444a4.5,4.5,0,0,0-1.592-.1l-1.818-.445A4.562,4.562,0,0,1-98.292,30.511Z",
    transform: "translate(99.885 -30.379)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    className: "cls-1",
    d: "M-100.661,38.239l-1.818-.445a31.446,31.446,0,0,0,8.206-3.575l1.816.444A31.424,31.424,0,0,1-100.661,38.239Z",
    transform: "translate(102.479 -34.219)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    className: "cls-1",
    d: "M-102.368,34.006l-1.818-.444a3.8,3.8,0,0,0,1.967-.034A6.157,6.157,0,0,0-98.8,30.4l1.818.445a6.162,6.162,0,0,1-3.423,3.126A3.781,3.781,0,0,1-102.368,34.006Z",
    transform: "translate(104.185 -30.401)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    className: "cls-1",
    d: "M-101.968,33.579l-1.818-.444a4.745,4.745,0,0,1-1.978-1.05l1.816.444A4.724,4.724,0,0,0-101.968,33.579Z",
    transform: "translate(105.763 -32.085)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    className: "cls-1",
    d: "M-101.151,18l1.818.444a3.067,3.067,0,0,0-1.587.061l-1.818-.445A3.066,3.066,0,0,1-101.151,18Z",
    transform: "translate(102.738 -17.922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    className: "cls-1",
    d: "M-107.429,38.718l-1.816-.444a30,30,0,0,0,8.481-1.2l1.818.445A30.008,30.008,0,0,1-107.429,38.718Z",
    transform: "translate(109.245 -37.071)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    className: "cls-1",
    d: "M-100.969,34.311l-1.816-.445c-2.1-.511-3.4-4.42-3.431-7.7-.03-3.8,1.655-7.364,4.36-8.139l1.818.445c-2.7.775-4.39,4.342-4.36,8.139C-104.372,29.891-103.065,33.8-100.969,34.311Z",
    transform: "translate(106.216 -18.032)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    className: "cls-1",
    d: "M-107.423,39.982l-1.816-.444a7.308,7.308,0,0,1,4.365-7.453l1.816.444A7.311,7.311,0,0,0-107.423,39.982Z",
    transform: "translate(109.267 -32.085)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    className: "cls-1",
    d: "M-111.874,17.17l-1.816-.444a2.37,2.37,0,0,1,1.344-2.293l1.818.444A2.372,2.372,0,0,0-111.874,17.17Z",
    transform: "translate(113.69 -14.434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    className: "cls-1",
    d: "M-74.277,38.687l.82.256a5.167,5.167,0,0,0-2.013-.206l-.82-.255A5.178,5.178,0,0,1-74.277,38.687Z",
    transform: "translate(76.29 -38.457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    className: "cls-1",
    d: "M-80.81,41.921l-.82-.255a4.361,4.361,0,0,0,2.418.063,6.826,6.826,0,0,0,3.845-3.252l.82.255a6.821,6.821,0,0,1-3.845,3.252A4.34,4.34,0,0,1-80.81,41.921Z",
    transform: "translate(81.63 -38.478)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    className: "cls-1",
    d: "M-86.687,48.363l-.82-.255a7.8,7.8,0,0,1,5.014-7.818l.82.254A7.8,7.8,0,0,0-86.687,48.363Z",
    transform: "translate(87.521 -40.29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    className: "cls-1",
    d: "M-77.332,24.453l.82.255a3.412,3.412,0,0,0-1.9,0l-.819-.255A3.408,3.408,0,0,1-77.332,24.453Z",
    transform: "translate(79.229 -24.318)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    className: "cls-1",
    d: "M-79.291,41.4l-.82-.255c-2.214-.688-3.48-4.759-3.412-8.161.08-4.025,2.031-7.775,5.036-8.558l.819.255c-3,.785-4.955,4.533-5.036,8.558C-82.771,36.645-81.505,40.716-79.291,41.4Z",
    transform: "translate(83.525 -24.431)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2427-2",
    "data-name": "Path 2427",
    className: "cls-1",
    d: "M-73.841,38.737l1,.311a6.287,6.287,0,0,0-2.449-.251l-1-.31A6.3,6.3,0,0,1-73.841,38.737Z",
    transform: "translate(76.29 -38.457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460-2",
    "data-name": "Path 2460",
    className: "cls-1",
    d: "M-80.632,42.669l-1-.31a5.308,5.308,0,0,0,2.943.077c1.469-.384,3.1-1.493,4.679-3.958l1,.31c-1.582,2.467-3.21,3.574-4.679,3.958A5.282,5.282,0,0,1-80.632,42.669Z",
    transform: "translate(81.63 -38.478)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2503-2",
    "data-name": "Path 2503",
    className: "cls-1",
    d: "M-86.506,50.115l-1-.31a9.492,9.492,0,0,1,6.1-9.515l1,.31A9.492,9.492,0,0,0-86.506,50.115Z",
    transform: "translate(87.521 -40.29)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2504",
    x: 45.167,
    y: 43.917,
    width: 31.476,
    height: 21.14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2518-2",
    "data-name": "Path 2518",
    className: "cls-1",
    d: "M-76.921,24.482l1,.31a4.152,4.152,0,0,0-2.31,0l-1-.31A4.147,4.147,0,0,1-76.921,24.482Z",
    transform: "translate(79.229 -24.318)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2587-2",
    "data-name": "Path 2587",
    className: "cls-1",
    d: "M-78.372,45.088l-1-.31c-2.695-.838-4.235-5.792-4.152-9.932.1-4.9,2.472-9.462,6.129-10.416l1,.31c-3.656.955-6.031,5.517-6.129,10.416C-82.607,39.3-81.067,44.25-78.372,45.088Z",
    transform: "translate(83.525 -24.431)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Device_Management",
    "data-name": "Device Management",
    transform: "translate(-185.226 -688.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    className: "cls-2",
    transform: "translate(185 689)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    className: "cls-3",
    y1: 13,
    transform: "translate(44.226 8.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    className: "cls-4",
    d: "M-57-12.383l3.737-2.748V-17",
    transform: "translate(101.778 31.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    className: "cls-4",
    d: "M-55.263-14.383-59-17.131V-19",
    transform: "translate(100.041 29.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    className: "cls-5",
    d: "M-55-8.657l5.606-5.606V-18",
    transform: "translate(103.515 30.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    className: "cls-4",
    d: "M-53-1.577l4.671-4.671h2.8V-24",
    transform: "translate(105.252 24.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    className: "cls-4",
    d: "M-49-16.7h5.606l2.8-2.8",
    transform: "translate(108.726 28.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    className: "cls-6",
    d: "M-51-7.526h5.606l3.737-3.737v0h3.737",
    transform: "translate(106.989 32.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    className: "cls-7",
    d: "M-49-2.354h7.474L-29.38-14.5h8.409",
    transform: "translate(108.726 33.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    className: "cls-6",
    d: "M-49-2.526h9.343L-32.183-10h9.343",
    transform: "translate(108.726 37.145)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    className: "cls-6",
    x2: 2.803,
    y2: 2.803,
    transform: "translate(70.938 32.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    className: "cls-4",
    d: "M-49-3h9.343l5.606,5.606h5.606",
    transform: "translate(108.726 43.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    className: "cls-8",
    d: "M-43,1.474-35.526-6h9.343l3.737,3.737",
    transform: "translate(113.938 40.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    className: "cls-4",
    d: "M-50-1h5.606l5.606,5.606",
    transform: "translate(107.858 44.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    className: "cls-7",
    d: "M-51,1l7.474,7.474h11.212l9.343,9.343",
    transform: "translate(106.989 46.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    className: "cls-4",
    d: "M-53,2l1.869,1.869v7.474l9.343,9.343",
    transform: "translate(105.252 47.567)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    className: "cls-8",
    x1: 4,
    y2: 4,
    transform: "translate(50.226 58.935)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    className: "cls-8",
    y2: 14,
    transform: "translate(44.226 51.935)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    className: "cls-8",
    x2: 2.803,
    y2: 2.803,
    transform: "translate(44.778 57.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    className: "cls-4",
    d: "M-55.657,2l-1.869,1.869v7.474L-65,18.817",
    transform: "translate(94.829 47.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    className: "cls-4",
    d: "M-53.314,1l-7.474,7.474h-7.474L-72,12.212",
    transform: "translate(88.749 46.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    className: "cls-8",
    d: "M-50.84-1h-7.474l-9.343,9.343H-77",
    transform: "translate(84.406 44.962)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    className: "cls-8",
    x1: 2.803,
    y1: 2.803,
    transform: "translate(17.683 46.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    className: "cls-4",
    d: "M-50.1-3H-70.657l-5.606,5.606H-80",
    transform: "translate(81.8 43.225)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    className: "cls-4",
    x1: 4.671,
    y1: 4.671,
    transform: "translate(6.472 35.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    className: "cls-4",
    d: "M-57.183-4.263h-13.08L-74-8",
    transform: "translate(87.012 38.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    className: "cls-6",
    d: "M-50.1-5.394h-9.343L-65.051-11H-80",
    transform: "translate(81.8 36.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    className: "cls-4",
    d: "M-50.708-8.394h-5.606l-3.737-3.737h-13.08L-75-14",
    transform: "translate(86.143 33.67)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    className: "cls-4",
    y1: 4,
    transform: "translate(25.226 17.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    className: "cls-4",
    d: "M-57.526-3.314l-3.737-3.737H-65V-22",
    transform: "translate(94.829 26.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    className: "cls-4",
    d: "M-65-12.526l5.606-5.606V-20",
    transform: "translate(94.829 28.459)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    className: "cls-7",
    x1: 4,
    y1: 5,
    transform: "translate(25.226 5.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    className: "cls-6",
    d: "M-57.263-9.526-61-13.263V-17",
    transform: "translate(98.303 31.064)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1.226 43.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0.226 23.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    className: "cls-9",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(4.226 32.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(9.226 17.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(22.226 3.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    className: "cls-9",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(34.226 6.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    className: "cls-9",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(36.226 11.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(23.226 16.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(11.226 28.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    className: "cls-9",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(58.226 -0.065)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(66.226 7.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(63.226 15.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(86.226 16.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(90.226 36.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    className: "cls-9",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(84.226 24.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(78.226 44.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(82.226 62.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    className: "cls-9",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(66.226 46.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    className: "cls-9",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(62.226 65.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    className: "cls-9",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(49.226 61.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(43.226 65.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(28.226 64.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    className: "cls-9",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(15.226 56.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(15.226 44.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    className: "cls-9",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(5.226 51.935)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(208.53 692.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    className: "cls-10",
    transform: "translate(0 45.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    className: "cls-10",
    transform: "translate(31.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    className: "cls-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-12",
    d: "M-88.866,46.061l-1.816-.445.04-.009,1.816.445a.257.257,0,0,0-.04.009",
    transform: "translate(90.682 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-13",
    d: "M-88.833,46.052l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(90.69 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-13",
    d: "M-88.828,46.051l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(90.691 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-14",
    d: "M-88.824,46.05l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(90.692 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-15",
    d: "M-88.819,46.049l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(90.694 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-15",
    d: "M-88.814,46.049l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(90.695 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-16",
    d: "M-88.81,46.049l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.696 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-16",
    d: "M-88.807,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.697 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-17",
    d: "M-88.805,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.697 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-17",
    d: "M-88.8,46.048-90.62,45.6h0l1.817.444h0",
    transform: "translate(90.698 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-18",
    d: "M-88.8,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.698 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-18",
    d: "M-88.8,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.699 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-19",
    d: "M-88.8,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.699 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-19",
    d: "M-88.795,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.7 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-20",
    d: "M-88.792,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.701 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-20",
    d: "M-88.79,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.701 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-21",
    d: "M-88.788,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.701 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-22",
    d: "M-88.786,46.048-90.6,45.6h0l1.817.444h0",
    transform: "translate(90.702 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-23",
    d: "M-88.784,46.048-90.6,45.6h0l1.817.444h0",
    transform: "translate(90.703 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-23",
    d: "M-88.782,46.048-90.6,45.6h0l1.817.444h0",
    transform: "translate(90.703 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-23",
    d: "M-88.78,46.048-90.6,45.6h0l1.817.444h0",
    transform: "translate(90.704 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-24",
    d: "M-88.778,46.048-90.6,45.6h0l1.817.444h0",
    transform: "translate(90.704 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-25",
    d: "M-88.777,46.048l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.704 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-25",
    d: "M-88.775,46.049l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.705 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-25",
    d: "M-88.773,46.049-90.59,45.6h0l1.817.444h0",
    transform: "translate(90.705 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-26",
    d: "M-88.772,46.049l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.706 -45.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-27",
    d: "M-88.77,46.049l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.706 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-27",
    d: "M-88.768,46.049l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.707 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-27",
    d: "M-88.767,46.049l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.707 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-28",
    d: "M-88.765,46.05l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.707 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-28",
    d: "M-88.763,46.05l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.708 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-29",
    d: "M-88.761,46.05l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.708 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-30",
    d: "M-88.76,46.05l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.709 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-30",
    d: "M-88.758,46.051l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.709 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-30",
    d: "M-88.756,46.051l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.71 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-31",
    d: "M-88.755,46.051l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.71 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-32",
    d: "M-88.753,46.051l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.71 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-32",
    d: "M-88.752,46.051l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.711 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-32",
    d: "M-88.75,46.052l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.711 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-32",
    d: "M-88.749,46.052l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.712 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-33",
    d: "M-88.747,46.052l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.712 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-34",
    d: "M-88.746,46.053l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.712 -45.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-34",
    d: "M-88.744,46.053l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.713 -45.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-34",
    d: "M-88.743,46.053l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.713 -45.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-35",
    d: "M-88.742,46.054l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.713 -45.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-36",
    d: "M-88.74,46.054l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.714 -45.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-36",
    d: "M-88.739,46.054l-1.817-.444h0l1.817.444h0",
    transform: "translate(90.714 -45.602)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(28.909 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-13",
    d: "M-90.943,46.8l-1.817-.444,2.6-.746,1.817.444Z",
    transform: "translate(92.76 -45.614)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(3.034 0.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-13",
    d: "M-111.585,54.062l-1.817-.444,25.874-7.409,1.817.444Z",
    transform: "translate(113.402 -46.209)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0.423 8.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-13",
    d: "M-113.668,53.312l-1.817-.444,2.612-.748,1.817.444Z",
    transform: "translate(115.485 -52.12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    className: "cls-10",
    transform: "translate(0.008 10.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    className: "cls-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-38",
    d: "M-113.718,54.934l-1.816-.444a.423.423,0,0,1-.277-.386l1.816.444a.422.422,0,0,0,.277.386",
    transform: "translate(115.818 -54.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-38",
    d: "M-113.994,54.55l-1.817-.444V54.1l1.817.444v.01",
    transform: "translate(115.817 -54.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-38",
    d: "M-114,54.542l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(115.817 -54.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-39",
    d: "M-114,54.534l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(115.817 -54.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-40",
    d: "M-114,54.526l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(115.817 -54.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-40",
    d: "M-114,54.518l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(115.817 -54.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-40",
    d: "M-114,54.51l-1.817-.444V54.06L-114,54.5v.006",
    transform: "translate(115.817 -54.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-41",
    d: "M-114,54.506l-1.817-.444v-.006L-114,54.5v.006",
    transform: "translate(115.817 -54.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-41",
    d: "M-114,54.5l-1.817-.444v-.006L-114,54.5V54.5",
    transform: "translate(115.816 -54.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-42",
    d: "M-114,54.5l-1.817-.444v-.006l1.817.444V54.5",
    transform: "translate(115.817 -54.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-42",
    d: "M-114,54.492l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(115.816 -54.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-43",
    d: "M-114,54.487l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(115.816 -54.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-43",
    d: "M-114,54.483l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(115.816 -54.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-43",
    d: "M-114,54.478l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.816 -54.029)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 9.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-44",
    d: "M-114,54.66l-1.817-.444-.007-.925,1.817.444Z",
    transform: "translate(115.822 -53.291)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    className: "cls-10",
    transform: "translate(0 8.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    className: "cls-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-43",
    d: "M-114.005,53.736l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.822 -52.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-46",
    d: "M-114.005,53.736l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-47",
    d: "M-114.005,53.732l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-47",
    d: "M-114.005,53.728l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-47",
    d: "M-114.005,53.725l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-48",
    d: "M-114.005,53.721l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-49",
    d: "M-114.005,53.718l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "cls-49",
    d: "M-114.005,53.714l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-49",
    d: "M-114.005,53.711l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.822 -52.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-50",
    d: "M-114.005,53.707l-1.817-.444v0L-114,53.7v0",
    transform: "translate(115.823 -52.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-51",
    d: "M-114,53.7l-1.817-.444v0L-114,53.7v0",
    transform: "translate(115.822 -52.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-51",
    d: "M-114,53.7l-1.817-.444v0L-114,53.7v0",
    transform: "translate(115.823 -52.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-51",
    d: "M-114,53.7l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-52",
    d: "M-114,53.694l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-52",
    d: "M-114,53.691l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-53",
    d: "M-114,53.688l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-53",
    d: "M-114,53.686l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-54",
    d: "M-114,53.683l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-54",
    d: "M-114,53.681l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-55",
    d: "M-114,53.678l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-56",
    d: "M-114,53.676l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-57",
    d: "M-114,53.673l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-57",
    d: "M-114,53.671l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-57",
    d: "M-114,53.668l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-58",
    d: "M-114,53.666l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-58",
    d: "M-114,53.663l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-58",
    d: "M-114,53.66l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-59",
    d: "M-114,53.658l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-60",
    d: "M-114,53.655l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-61",
    d: "M-114,53.653l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.823 -52.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-61",
    d: "M-114,53.651l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-61",
    d: "M-114,53.649l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-62",
    d: "M-114,53.647l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-63",
    d: "M-114,53.645l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-63",
    d: "M-114,53.643l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-64",
    d: "M-114,53.64l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-64",
    d: "M-114,53.638l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-64",
    d: "M-114,53.636l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-65",
    d: "M-114,53.634l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-66",
    d: "M-114,53.632l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-67",
    d: "M-114,53.63l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-67",
    d: "M-114,53.628l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-67",
    d: "M-114,53.626l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-68",
    d: "M-114,53.623l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-68",
    d: "M-114,53.621l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.824 -52.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-68",
    d: "M-114,53.619l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-69",
    d: "M-114,53.617l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-70",
    d: "M-114,53.615l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-70",
    d: "M-114,53.613l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-70",
    d: "M-114,53.612l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-71",
    d: "M-114,53.61l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-71",
    d: "M-113.995,53.608l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-72",
    d: "M-113.995,53.606l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-72",
    d: "M-113.994,53.6l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-73",
    d: "M-113.994,53.6l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-73",
    d: "M-113.994,53.6l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "cls-74",
    d: "M-113.993,53.6l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.825 -52.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-74",
    d: "M-113.993,53.6l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-75",
    d: "M-113.993,53.6l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-75",
    d: "M-113.992,53.594l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-75",
    d: "M-113.992,53.592l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-76",
    d: "M-113.992,53.59l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-76",
    d: "M-113.991,53.589l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-76",
    d: "M-113.991,53.587l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-77",
    d: "M-113.991,53.585l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-78",
    d: "M-113.99,53.583l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-79",
    d: "M-113.99,53.582l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-79",
    d: "M-113.989,53.58l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-79",
    d: "M-113.989,53.578l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.826 -52.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-80",
    d: "M-113.989,53.576l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-81",
    d: "M-113.988,53.575l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-82",
    d: "M-113.988,53.573l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-82",
    d: "M-113.988,53.572l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-83",
    d: "M-113.987,53.57l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-83",
    d: "M-113.987,53.569l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-84",
    d: "M-113.987,53.567l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-85",
    d: "M-113.986,53.566l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-86",
    d: "M-113.986,53.564l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-86",
    d: "M-113.986,53.563l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-86",
    d: "M-113.985,53.561l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.827 -52.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-87",
    d: "M-113.985,53.56l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-87",
    d: "M-113.985,53.558l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-87",
    d: "M-113.984,53.557l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-88",
    d: "M-113.984,53.555l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-89",
    d: "M-113.983,53.554l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-89",
    d: "M-113.983,53.552l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-89",
    d: "M-113.983,53.551l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-89",
    d: "M-113.982,53.549l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.828 -52.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-90",
    d: "M-113.982,53.548-115.8,53.1v0l1.817.444v0",
    transform: "translate(115.828 -52.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-91",
    d: "M-113.982,53.546-115.8,53.1v0l1.817.444v0",
    transform: "translate(115.828 -52.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-91",
    d: "M-113.981,53.545-115.8,53.1v0l1.817.444v0",
    transform: "translate(115.828 -52.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-92",
    d: "M-113.981,53.543-115.8,53.1v0l1.817.444v0",
    transform: "translate(115.829 -52.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-92",
    d: "M-113.98,53.542-115.8,53.1v0l1.817.444v0",
    transform: "translate(115.829 -52.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-92",
    d: "M-113.98,53.54-115.8,53.1v0l1.817.444v0",
    transform: "translate(115.829 -52.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-93",
    d: "M-113.979,53.539l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.829 -52.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-94",
    d: "M-113.979,53.538l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.829 -52.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-94",
    d: "M-113.979,53.536l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.829 -52.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "cls-94",
    d: "M-113.978,53.535l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.829 -52.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "cls-95",
    d: "M-113.978,53.534l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.829 -52.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "cls-96",
    d: "M-113.978,53.532l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.829 -52.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "cls-96",
    d: "M-113.977,53.531l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.829 -52.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "cls-96",
    d: "M-113.977,53.53l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    className: "cls-97",
    d: "M-113.977,53.528l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    className: "cls-98",
    d: "M-113.976,53.527l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    className: "cls-98",
    d: "M-113.976,53.526l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    className: "cls-98",
    d: "M-113.976,53.525l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "cls-99",
    d: "M-113.975,53.523l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "cls-100",
    d: "M-113.975,53.522l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    className: "cls-101",
    d: "M-113.974,53.521l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "cls-101",
    d: "M-113.974,53.519l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-102",
    d: "M-113.973,53.518l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.83 -52.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-102",
    d: "M-113.973,53.517l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-103",
    d: "M-113.973,53.515l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-103",
    d: "M-113.972,53.514l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-104",
    d: "M-113.972,53.513l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "cls-104",
    d: "M-113.972,53.512l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "cls-104",
    d: "M-113.971,53.51l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    className: "cls-105",
    d: "M-113.971,53.509l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-105",
    d: "M-113.97,53.508l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-105",
    d: "M-113.97,53.506l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.831 -52.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    className: "cls-106",
    d: "M-113.969,53.505l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.832 -52.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    className: "cls-107",
    d: "M-113.969,53.5l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.832 -52.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    className: "cls-107",
    d: "M-113.969,53.5l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    className: "cls-107",
    d: "M-113.968,53.5l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    className: "cls-107",
    d: "M-113.968,53.5l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    className: "cls-108",
    d: "M-113.967,53.5l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    className: "cls-109",
    d: "M-113.967,53.5l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    className: "cls-109",
    d: "M-113.967,53.5l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    className: "cls-109",
    d: "M-113.966,53.5l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    className: "cls-110",
    d: "M-113.966,53.494l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.832 -52.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    className: "cls-110",
    d: "M-113.965,53.493l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    className: "cls-111",
    d: "M-113.965,53.492l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    className: "cls-112",
    d: "M-113.965,53.491l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    className: "cls-113",
    d: "M-113.964,53.49l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    className: "cls-113",
    d: "M-113.964,53.488l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    className: "cls-114",
    d: "M-113.963,53.487l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    className: "cls-115",
    d: "M-113.963,53.486l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    className: "cls-115",
    d: "M-113.962,53.485l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    className: "cls-115",
    d: "M-113.962,53.484l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    className: "cls-116",
    d: "M-113.962,53.483l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.833 -52.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    className: "cls-117",
    d: "M-113.961,53.482l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    className: "cls-117",
    d: "M-113.961,53.48l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    className: "cls-117",
    d: "M-113.961,53.479l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    className: "cls-117",
    d: "M-113.96,53.478l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    className: "cls-118",
    d: "M-113.96,53.477l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    className: "cls-119",
    d: "M-113.959,53.476l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    className: "cls-119",
    d: "M-113.959,53.475l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    className: "cls-120",
    d: "M-113.958,53.473l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    className: "cls-120",
    d: "M-113.958,53.472l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    className: "cls-121",
    d: "M-113.957,53.471l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.834 -52.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    className: "cls-121",
    d: "M-113.957,53.47l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    className: "cls-122",
    d: "M-113.957,53.469l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    className: "cls-122",
    d: "M-113.956,53.468l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    className: "cls-122",
    d: "M-113.956,53.467l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    className: "cls-123",
    d: "M-113.955,53.465l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    className: "cls-124",
    d: "M-113.955,53.464l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    className: "cls-124",
    d: "M-113.954,53.463l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    className: "cls-125",
    d: "M-113.954,53.462l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    className: "cls-126",
    d: "M-113.953,53.461l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.835 -52.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    className: "cls-127",
    d: "M-113.953,53.46l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    className: "cls-127",
    d: "M-113.953,53.459l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    className: "cls-127",
    d: "M-113.952,53.458l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    className: "cls-128",
    d: "M-113.952,53.457l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    className: "cls-129",
    d: "M-113.951,53.456l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    className: "cls-130",
    d: "M-113.951,53.455l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    className: "cls-130",
    d: "M-113.95,53.454l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    className: "cls-131",
    d: "M-113.95,53.453l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    className: "cls-131",
    d: "M-113.949,53.451l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.836 -52.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    className: "cls-132",
    d: "M-113.949,53.45l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.837 -52.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    className: "cls-132",
    d: "M-113.949,53.449l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.837 -52.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    className: "cls-133",
    d: "M-113.948,53.448-115.765,53h0l1.817.444h0",
    transform: "translate(115.837 -52.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    className: "cls-133",
    d: "M-113.948,53.447-115.765,53h0l1.817.444h0",
    transform: "translate(115.837 -52.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    className: "cls-134",
    d: "M-113.947,53.446-115.764,53h0l1.817.444h0",
    transform: "translate(115.837 -52.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    className: "cls-135",
    d: "M-113.947,53.445-115.764,53h0l1.817.444h0",
    transform: "translate(115.837 -52.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    className: "cls-135",
    d: "M-113.946,53.444-115.763,53h0l1.817.444h0",
    transform: "translate(115.837 -52.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    className: "cls-135",
    d: "M-113.946,53.443-115.763,53h0l1.817.444h0",
    transform: "translate(115.837 -52.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    className: "cls-136",
    d: "M-113.945,53.442-115.762,53h0l1.817.444h0",
    transform: "translate(115.838 -52.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    className: "cls-137",
    d: "M-113.945,53.441-115.762,53h0l1.817.444h0",
    transform: "translate(115.838 -52.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    className: "cls-137",
    d: "M-113.945,53.44-115.761,53h0l1.817.444h0",
    transform: "translate(115.838 -52.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    className: "cls-137",
    d: "M-113.944,53.439l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.838 -52.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    className: "cls-137",
    d: "M-113.944,53.438l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.838 -52.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    className: "cls-138",
    d: "M-113.943,53.437l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.838 -52.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    className: "cls-139",
    d: "M-113.943,53.436l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.838 -52.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    className: "cls-139",
    d: "M-113.942,53.434l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.838 -52.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    className: "cls-139",
    d: "M-113.942,53.433l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.838 -52.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    className: "cls-140",
    d: "M-113.941,53.432l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    className: "cls-141",
    d: "M-113.941,53.431l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    className: "cls-141",
    d: "M-113.94,53.43l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    className: "cls-142",
    d: "M-113.94,53.429l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    className: "cls-142",
    d: "M-113.939,53.428l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    className: "cls-142",
    d: "M-113.939,53.427l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    className: "cls-143",
    d: "M-113.938,53.426l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    className: "cls-144",
    d: "M-113.938,53.425l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.839 -52.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    className: "cls-144",
    d: "M-113.937,53.424l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.84 -52.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    className: "cls-144",
    d: "M-113.937,53.423l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.84 -52.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    className: "cls-145",
    d: "M-113.936,53.422l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.84 -52.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    className: "cls-146",
    d: "M-113.936,53.421l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.84 -52.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    className: "cls-146",
    d: "M-113.936,53.42l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.84 -52.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    className: "cls-146",
    d: "M-113.935,53.419l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.84 -52.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    className: "cls-147",
    d: "M-113.934,53.418l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.84 -52.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    className: "cls-148",
    d: "M-113.934,53.417l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    className: "cls-149",
    d: "M-113.933,53.416l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    className: "cls-149",
    d: "M-113.933,53.415l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    className: "cls-150",
    d: "M-113.933,53.414l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    className: "cls-150",
    d: "M-113.932,53.413l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    className: "cls-151",
    d: "M-113.932,53.412l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    className: "cls-151",
    d: "M-113.931,53.411l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    className: "cls-152",
    d: "M-113.931,53.41l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    className: "cls-152",
    d: "M-113.93,53.409l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.841 -52.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    className: "cls-152",
    d: "M-113.929,53.408l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    className: "cls-153",
    d: "M-113.929,53.407l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    className: "cls-154",
    d: "M-113.929,53.406l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    className: "cls-154",
    d: "M-113.928,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    className: "cls-155",
    d: "M-113.927,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    className: "cls-156",
    d: "M-113.927,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    className: "cls-156",
    d: "M-113.926,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    className: "cls-156",
    d: "M-113.926,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.842 -52.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    className: "cls-156",
    d: "M-113.925,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.843 -52.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    className: "cls-157",
    d: "M-113.925,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.843 -52.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    className: "cls-158",
    d: "M-113.924,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.843 -52.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    className: "cls-158",
    d: "M-113.924,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.843 -52.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    className: "cls-158",
    d: "M-113.923,53.4l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.843 -52.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    className: "cls-159",
    d: "M-113.923,53.394l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.843 -52.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    className: "cls-160",
    d: "M-113.922,53.393l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.843 -52.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    className: "cls-160",
    d: "M-113.921,53.392l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.844 -52.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    className: "cls-160",
    d: "M-113.921,53.391l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.844 -52.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    className: "cls-36",
    d: "M-113.92,53.39l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.844 -52.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    className: "cls-36",
    d: "M-113.92,53.389l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.844 -52.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    className: "cls-35",
    d: "M-113.919,53.388l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.844 -52.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    className: "cls-34",
    d: "M-113.919,53.387l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.844 -52.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-34",
    d: "M-113.918,53.386l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.844 -52.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-34",
    d: "M-113.918,53.385l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.845 -52.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-33",
    d: "M-113.917,53.384l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.845 -52.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-32",
    d: "M-113.916,53.383l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.845 -52.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-32",
    d: "M-113.916,53.382l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.845 -52.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-32",
    d: "M-113.915,53.381l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.845 -52.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-32",
    d: "M-113.915,53.38l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.845 -52.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-31",
    d: "M-113.914,53.379l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.845 -52.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-30",
    d: "M-113.914,53.378l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.846 -52.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-30",
    d: "M-113.913,53.377l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.846 -52.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-30",
    d: "M-113.912,53.376l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.846 -52.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-29",
    d: "M-113.912,53.375l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.846 -52.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-28",
    d: "M-113.911,53.374l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.846 -52.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    className: "cls-28",
    d: "M-113.91,53.373l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.846 -52.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    className: "cls-27",
    d: "M-113.91,53.372l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.847 -52.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    className: "cls-27",
    d: "M-113.909,53.371l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.847 -52.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    className: "cls-27",
    d: "M-113.909,53.37l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.847 -52.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    className: "cls-26",
    d: "M-113.908,53.369l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.847 -52.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-25",
    d: "M-113.908,53.368l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.847 -52.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-25",
    d: "M-113.907,53.367l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.847 -52.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    className: "cls-25",
    d: "M-113.906,53.365l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.847 -52.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    className: "cls-24",
    d: "M-113.906,53.364l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.848 -52.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    className: "cls-23",
    d: "M-113.9,53.363l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.848 -52.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    className: "cls-23",
    d: "M-113.9,53.362l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.848 -52.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    className: "cls-23",
    d: "M-113.9,53.361l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.848 -52.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    className: "cls-22",
    d: "M-113.9,53.36l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.848 -52.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-21",
    d: "M-113.9,53.359l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.849 -52.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    className: "cls-20",
    d: "M-113.9,53.357l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.849 -52.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    className: "cls-20",
    d: "M-113.9,53.356l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.849 -52.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    className: "cls-19",
    d: "M-113.9,53.355l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.849 -52.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    className: "cls-19",
    d: "M-113.9,53.354l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.849 -52.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    className: "cls-18",
    d: "M-113.9,53.353l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.849 -52.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    className: "cls-18",
    d: "M-113.9,53.352l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.85 -52.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    className: "cls-17",
    d: "M-113.9,53.351l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.85 -52.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    className: "cls-17",
    d: "M-113.9,53.35l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.85 -52.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    className: "cls-16",
    d: "M-113.9,53.348l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.85 -52.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    className: "cls-16",
    d: "M-113.9,53.347l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.85 -52.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    className: "cls-15",
    d: "M-113.894,53.346l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.85 -52.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    className: "cls-15",
    d: "M-113.894,53.345l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.851 -52.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-14",
    d: "M-113.893,53.344l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.851 -52.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-13",
    d: "M-113.892,53.343l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.851 -52.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    className: "cls-13",
    d: "M-113.891,53.342l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.851 -52.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    className: "cls-12",
    d: "M-113.891,53.341l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.851 -52.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    className: "cls-161",
    d: "M-113.89,53.34l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.852 -52.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    className: "cls-162",
    d: "M-113.889,53.339l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.852 -52.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    className: "cls-163",
    d: "M-113.889,53.338l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.852 -52.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    className: "cls-164",
    d: "M-113.888,53.336l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.852 -52.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    className: "cls-165",
    d: "M-113.887,53.335l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.852 -52.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    className: "cls-166",
    d: "M-113.886,53.334l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.853 -52.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    className: "cls-167",
    d: "M-113.885,53.332l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.853 -52.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    className: "cls-168",
    d: "M-113.884,53.331l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.853 -52.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    className: "cls-169",
    d: "M-113.883,53.329l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.853 -52.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-170",
    d: "M-113.882,53.328l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.854 -52.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    className: "cls-171",
    d: "M-113.881,53.327l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.854 -52.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    className: "cls-172",
    d: "M-113.88,53.325l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.854 -52.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    className: "cls-173",
    d: "M-113.879,53.324l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.854 -52.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-174",
    d: "M-113.878,53.323l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.855 -52.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-175",
    d: "M-113.877,53.321l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.855 -52.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-176",
    d: "M-113.876,53.32l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.855 -52.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-177",
    d: "M-113.875,53.319l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.855 -52.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    className: "cls-178",
    d: "M-113.874,53.317l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.856 -52.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    className: "cls-178",
    d: "M-113.874,53.316l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.856 -52.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    className: "cls-179",
    d: "M-113.873,53.315l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.856 -52.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    className: "cls-180",
    d: "M-113.872,53.313l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.856 -52.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    className: "cls-181",
    d: "M-113.87,53.312l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.856 -52.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    className: "cls-182",
    d: "M-113.87,53.311l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.857 -52.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    className: "cls-183",
    d: "M-113.869,53.31l-1.817-.444v0l1.817.444v0",
    transform: "translate(115.857 -52.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    className: "cls-184",
    d: "M-113.867,53.308l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.857 -52.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    className: "cls-185",
    d: "M-113.866,53.306l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.858 -52.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    className: "cls-185",
    d: "M-113.865,53.3l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.858 -52.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    className: "cls-186",
    d: "M-113.863,53.3l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.858 -52.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    className: "cls-187",
    d: "M-113.862,53.3l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.859 -52.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    className: "cls-188",
    d: "M-113.86,53.3l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.859 -52.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    className: "cls-189",
    d: "M-113.859,53.3l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.86 -52.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    className: "cls-190",
    d: "M-113.857,53.3l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.86 -52.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    className: "cls-190",
    d: "M-113.856,53.293l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.86 -52.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-191",
    d: "M-113.854,53.292l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.861 -52.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    className: "cls-191",
    d: "M-113.853,53.29l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.861 -52.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    className: "cls-192",
    d: "M-113.851,53.288l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.861 -52.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-192",
    d: "M-113.85,53.286l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.862 -52.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    className: "cls-192",
    d: "M-113.848,53.285l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.862 -52.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-193",
    d: "M-113.847,53.283l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.863 -52.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-194",
    d: "M-113.844,53.28l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.863 -52.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-195",
    d: "M-113.842,53.277l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.864 -52.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-196",
    d: "M-113.839,53.274l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.865 -52.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-197",
    d: "M-113.836,53.271l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.865 -52.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-198",
    d: "M-113.834,53.269l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.866 -52.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-199",
    d: "M-113.831,53.266l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.867 -52.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-199",
    d: "M-113.828,53.263l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.867 -52.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-199",
    d: "M-113.826,53.26l-1.817-.444.005-.005,1.817.444-.005.005",
    transform: "translate(115.868 -52.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-200",
    d: "M-113.821,53.257l-1.817-.444.01-.01,1.817.444-.01.01",
    transform: "translate(115.869 -52.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-200",
    d: "M-113.813,53.249l-1.817-.444.011-.01,1.817.444-.011.01",
    transform: "translate(115.871 -52.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-201",
    d: "M-113.8,53.24l-1.817-.444.008-.007,1.817.444-.008.007",
    transform: "translate(115.873 -52.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-200",
    d: "M-113.8,53.234l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.875 -52.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    className: "cls-200",
    d: "M-113.8,53.232l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.876 -52.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    className: "cls-199",
    d: "M-113.793,53.23l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.876 -52.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-199",
    d: "M-113.791,53.228l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.877 -52.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-199",
    d: "M-113.788,53.226l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.877 -52.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-198",
    d: "M-113.786,53.224l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.878 -52.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-197",
    d: "M-113.783,53.222l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.879 -52.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-196",
    d: "M-113.781,53.22l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.879 -52.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-195",
    d: "M-113.778,53.218l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.88 -52.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-194",
    d: "M-113.776,53.216l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.881 -52.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-193",
    d: "M-113.773,53.214l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.881 -52.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-192",
    d: "M-113.771,53.212l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.882 -52.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-192",
    d: "M-113.769,53.211l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.882 -52.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    className: "cls-192",
    d: "M-113.766,53.209l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.883 -52.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-191",
    d: "M-113.764,53.207l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.884 -52.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-191",
    d: "M-113.761,53.206l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.884 -52.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-190",
    d: "M-113.759,53.2l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.885 -52.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    className: "cls-190",
    d: "M-113.757,53.2l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.885 -52.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    className: "cls-189",
    d: "M-113.754,53.2l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.886 -52.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-188",
    d: "M-113.752,53.2l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.887 -52.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    className: "cls-187",
    d: "M-113.75,53.2l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.887 -52.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-186",
    d: "M-113.747,53.2l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.888 -52.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-185",
    d: "M-113.744,53.194l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.889 -52.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-185",
    d: "M-113.741,53.192l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.889 -52.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-184",
    d: "M-113.738,53.191l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.89 -52.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    className: "cls-183",
    d: "M-113.735,53.189l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.891 -52.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    className: "cls-182",
    d: "M-113.732,53.187l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.892 -52.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-181",
    d: "M-113.729,53.186l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.892 -52.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-180",
    d: "M-113.726,53.184l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.893 -52.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "cls-179",
    d: "M-113.723,53.183l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.894 -52.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-178",
    d: "M-113.719,53.181l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.895 -52.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-178",
    d: "M-113.715,53.179l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.896 -52.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    className: "cls-177",
    d: "M-113.711,53.177l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.897 -52.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-176",
    d: "M-113.707,53.175l-1.817-.444,0,0,1.817.444-.005,0",
    transform: "translate(115.898 -52.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-175",
    d: "M-113.7,53.173l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.899 -52.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-174",
    d: "M-113.7,53.172l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(115.9 -52.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-173",
    d: "M-113.7,53.17l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.901 -52.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-172",
    d: "M-113.694,53.169l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.901 -52.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-171",
    d: "M-113.692,53.168l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.902 -52.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-170",
    d: "M-113.69,53.168l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.902 -52.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-169",
    d: "M-113.687,53.167l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.903 -52.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-168",
    d: "M-113.685,53.166l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.903 -52.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-167",
    d: "M-113.683,53.165l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.904 -52.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-166",
    d: "M-113.681,53.165l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.904 -52.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-165",
    d: "M-113.679,53.164l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.905 -52.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-164",
    d: "M-113.677,53.163l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.906 -52.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-163",
    d: "M-113.675,53.163l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.906 -52.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-162",
    d: "M-113.673,53.162l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.907 -52.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-161",
    d: "M-113.671,53.161l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.907 -52.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-12",
    d: "M-113.669,53.161l-1.817-.444h0l1.817.444h0",
    transform: "translate(115.908 -52.716)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(1.817 0.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-160",
    d: "M-82.861,45.972c.241-.069.437.137.44.474l.008.924a.752.752,0,0,1-.43.723l-31.09,8.9c-.233.066-.43-.15-.432-.476l-.008-.925a.74.74,0,0,1,.422-.72l2.612-.748,25.874-7.408Z",
    transform: "translate(114.373 -45.958)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    className: "cls-10",
    transform: "translate(2.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(24.717 31.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-44",
    d: "M-92.136,37.393l-1.817-.444-.019-2.317,1.817.444Z",
    transform: "translate(93.971 -34.631)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(24.591 31.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-202",
    d: "M-92.129,35.1l-1.817-.444-.126-.138,1.817.444Z",
    transform: "translate(94.072 -34.521)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(24.461 31.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M-92.359,35.177l-1.817-.444.131-.212,1.817.444Z",
    transform: "translate(94.176 -34.521)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(24.461 32.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M-92.343,37.081l-1.817-.444-.016-1.947,1.817.444Z",
    transform: "translate(94.176 -34.69)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(23.088 34.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-13",
    d: "M-93.454,37.4l-1.817-.444,1.648-.472,1.817.444Z",
    transform: "translate(95.271 -36.48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(23.085 34.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M-93.457,37.086l-1.817-.444,1.391-.4,1.817.444Z",
    transform: "translate(95.273 -36.243)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(24.771 32.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-203",
    d: "M-92.291,34.875l.126.138.019,2.317-1.648.472-.134-.147.131-.223,1.391-.4-.016-1.947Z",
    transform: "translate(93.928 -34.875)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(22.955 34.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M-93.561,37.228l-1.817-.444.131-.223,1.817.444Z",
    transform: "translate(95.378 -36.561)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(22.955 34.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M-93.427,37.33l-1.817-.444-.134-.147,1.817.444Z",
    transform: "translate(95.378 -36.739)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(24.406 8.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-139",
    d: "M-92.4,16.6l-1.817-.444.123-.21,1.817.444Z",
    transform: "translate(94.22 -15.948)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(24.272 8.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M-92.376,16.587l-1.817-.444-.134-.136,1.817.444Z",
    transform: "translate(94.327 -16.007)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(24.51 6.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-44",
    d: "M-92.3,16.861l-1.817-.444-.019-2.317,1.817.444Z",
    transform: "translate(94.137 -14.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(24.256 6.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M-92.507,16.845l-1.817-.444-.016-1.947,1.817.444Z",
    transform: "translate(94.339 -14.453)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    className: "cls-10",
    transform: "translate(18.898 26.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-38",
    d: "M-93.5,35.107l-1.818-.444c-.444-2.9-2.046-3.873-3.3-4.179l1.816.444c1.252.307,2.854,1.277,3.3,4.179",
    transform: "translate(98.614 -30.484)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(22.865 6.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-13",
    d: "M-93.632,15.3l-1.817-.444,1.391-.4,1.817.444Z",
    transform: "translate(95.449 -14.453)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    className: "cls-10",
    transform: "translate(24.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    className: "cls-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    className: "cls-12",
    d: "M-92.328,9.594l-1.818-.445a1.134,1.134,0,0,1,.123-.026l1.816.444a.89.89,0,0,0-.122.028",
    transform: "translate(94.146 -9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    className: "cls-13",
    d: "M-92.232,9.567l-1.816-.444.016,0,1.816.444-.016,0",
    transform: "translate(94.171 -9.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    className: "cls-13",
    d: "M-92.219,9.565l-1.816-.444.015,0,1.818.444-.016,0",
    transform: "translate(94.174 -9.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    className: "cls-14",
    d: "M-92.206,9.563l-1.818-.444h.016l1.818.444h-.016",
    transform: "translate(94.177 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    className: "cls-15",
    d: "M-92.192,9.562l-1.818-.444.016,0,1.816.445h-.015",
    transform: "translate(94.18 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-15",
    d: "M-92.181,9.561-94,9.116h.015l1.818.445h-.016",
    transform: "translate(94.184 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-16",
    d: "M-92.167,9.56l-1.818-.445h.016l1.816.445h-.015",
    transform: "translate(94.187 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-16",
    d: "M-92.155,9.559l-1.817-.444h.009l1.817.444h-.009",
    transform: "translate(94.19 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-17",
    d: "M-92.148,9.558l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.192 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-17",
    d: "M-92.142,9.558l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.193 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-18",
    d: "M-92.136,9.558l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.195 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-18",
    d: "M-92.13,9.557l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.197 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-19",
    d: "M-92.123,9.557l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.198 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-19",
    d: "M-92.117,9.557l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.2 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-20",
    d: "M-92.111,9.557l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.201 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-20",
    d: "M-92.1,9.557l-1.817-.444h.008l1.817.444H-92.1",
    transform: "translate(94.203 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-21",
    d: "M-92.1,9.557l-1.817-.444h.008l1.817.444H-92.1",
    transform: "translate(94.204 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-22",
    d: "M-92.093,9.557l-1.817-.444h.008l1.817.444h-.008",
    transform: "translate(94.206 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-23",
    d: "M-92.086,9.558-93.9,9.113h.008l1.817.444h-.008",
    transform: "translate(94.207 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-23",
    d: "M-92.08,9.558-93.9,9.114h.008l1.817.444h-.008",
    transform: "translate(94.209 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-23",
    d: "M-92.074,9.558l-1.817-.444h.007l1.817.444h-.007",
    transform: "translate(94.211 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    className: "cls-24",
    d: "M-92.068,9.558l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.212 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-25",
    d: "M-92.063,9.559l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.213 -9.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-25",
    d: "M-92.058,9.559l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.215 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-25",
    d: "M-92.053,9.56l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.216 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-26",
    d: "M-92.048,9.56l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.217 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-27",
    d: "M-92.043,9.56l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.219 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-27",
    d: "M-92.038,9.561l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.22 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-27",
    d: "M-92.032,9.562l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.221 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-28",
    d: "M-92.027,9.562l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.222 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    className: "cls-28",
    d: "M-92.022,9.563l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.224 -9.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    className: "cls-29",
    d: "M-92.017,9.563l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.225 -9.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    className: "cls-30",
    d: "M-92.012,9.564l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.226 -9.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    className: "cls-30",
    d: "M-92.007,9.565l-1.817-.444h.006L-92,9.566h-.006",
    transform: "translate(94.228 -9.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-30",
    d: "M-92,9.566l-1.817-.444h.006L-92,9.567H-92",
    transform: "translate(94.229 -9.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    className: "cls-31",
    d: "M-92,9.566l-1.817-.444h.006l1.817.444H-92",
    transform: "translate(94.23 -9.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    className: "cls-32",
    d: "M-91.992,9.567l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.232 -9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    className: "cls-32",
    d: "M-91.987,9.568-93.8,9.124h.006l1.817.444h-.006",
    transform: "translate(94.233 -9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    className: "cls-32",
    d: "M-91.982,9.569-93.8,9.125h.006l1.817.444h-.006",
    transform: "translate(94.234 -9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    className: "cls-32",
    d: "M-91.978,9.57l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.235 -9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    className: "cls-33",
    d: "M-91.973,9.571l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.236 -9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    className: "cls-34",
    d: "M-91.969,9.571l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.237 -9.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    className: "cls-34",
    d: "M-91.965,9.572l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.238 -9.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    className: "cls-34",
    d: "M-91.96,9.573l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.24 -9.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    className: "cls-35",
    d: "M-91.956,9.574l-1.817-.444h.006l1.817.444h-.006",
    transform: "translate(94.241 -9.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    className: "cls-36",
    d: "M-91.951,9.575l-1.817-.444h.006l1.817.444h-.005",
    transform: "translate(94.242 -9.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    className: "cls-36",
    d: "M-91.947,9.576l-1.817-.444h0l1.817.444h0",
    transform: "translate(94.243 -9.108)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(22.862 6.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M-93.634,15.016l-1.817-.444L-93.8,14.1l1.817.444Z",
    transform: "translate(95.451 -14.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(22.732 6.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M-93.739,15.143l-1.817-.444.131-.223,1.817.444Z",
    transform: "translate(95.556 -14.476)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(22.732 6.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M-93.605,15.245l-1.817-.444-.134-.147,1.817.444Z",
    transform: "translate(95.556 -14.654)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    className: "cls-10",
    transform: "translate(17.305 26.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    className: "cls-10",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    className: "cls-207",
    d: "M-98.067,30.846l-1.818-.445.019,0,1.818.445-.019,0",
    transform: "translate(99.885 -30.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    className: "cls-208",
    d: "M-98.053,30.845-99.87,30.4l.043,0,1.818.444-.043.005",
    transform: "translate(99.889 -30.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    className: "cls-208",
    d: "M-98.019,30.84l-1.818-.444.029,0,1.816.445-.028,0",
    transform: "translate(99.897 -30.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    className: "cls-208",
    d: "M-98,30.838l-1.816-.445.031,0,1.816.444-.031,0",
    transform: "translate(99.903 -30.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    className: "cls-209",
    d: "M-97.972,30.835l-1.816-.444.036,0,1.816.445-.036,0",
    transform: "translate(99.91 -30.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    className: "cls-210",
    d: "M-97.943,30.834l-1.816-.445.035,0,1.818.445-.036,0",
    transform: "translate(99.917 -30.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    className: "cls-210",
    d: "M-97.914,30.831l-1.818-.445h.035l1.816.444-.034,0",
    transform: "translate(99.924 -30.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    className: "cls-210",
    d: "M-97.887,30.829l-1.816-.444.036,0,1.818.444-.038,0",
    transform: "translate(99.931 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    className: "cls-211",
    d: "M-97.857,30.827l-1.818-.444.039,0,1.818.445h-.039",
    transform: "translate(99.939 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    className: "cls-212",
    d: "M-97.825,30.826l-1.818-.445h.041l1.818.445h-.041",
    transform: "translate(99.946 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    className: "cls-212",
    d: "M-97.793,30.825l-1.818-.445h.036l1.816.445h-.035",
    transform: "translate(99.955 -30.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    className: "cls-212",
    d: "M-97.765,30.824l-1.816-.445h.036l1.818.444h-.038",
    transform: "translate(99.962 -30.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    className: "cls-212",
    d: "M-97.734,30.823l-1.818-.444h.039l1.818.444h-.039",
    transform: "translate(99.969 -30.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    className: "cls-213",
    d: "M-97.7,30.823l-1.818-.444h.04l1.816.445H-97.7",
    transform: "translate(99.977 -30.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    className: "cls-213",
    d: "M-97.673,30.823l-1.816-.445h.041l1.816.444h-.041",
    transform: "translate(99.985 -30.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    className: "cls-214",
    d: "M-97.64,30.823l-1.816-.444h.038l1.816.445h-.038",
    transform: "translate(99.994 -30.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    className: "cls-214",
    d: "M-97.61,30.824l-1.816-.445h.035l1.818.444h-.036",
    transform: "translate(100.001 -30.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    className: "cls-214",
    d: "M-97.581,30.824-99.4,30.38h.038l1.816.444h-.036",
    transform: "translate(100.008 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    className: "cls-214",
    d: "M-97.552,30.825l-1.816-.444h.038l1.818.444h-.039",
    transform: "translate(100.016 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    className: "cls-214",
    d: "M-97.52,30.826l-1.818-.444h.039l1.816.445-.038,0",
    transform: "translate(100.024 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    className: "cls-215",
    d: "M-97.491,30.828l-1.816-.445.039,0,1.818.444h-.04",
    transform: "translate(100.032 -30.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    className: "cls-216",
    d: "M-97.458,30.829l-1.818-.444.039,0,1.816.444-.038,0",
    transform: "translate(100.039 -30.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    className: "cls-216",
    d: "M-97.429,30.831l-1.816-.444.034,0,1.816.444-.034,0",
    transform: "translate(100.047 -30.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    className: "cls-217",
    d: "M-97.4,30.833l-1.816-.444.034,0,1.818.444-.035,0",
    transform: "translate(100.054 -30.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    className: "cls-217",
    d: "M-97.373,30.835l-1.818-.444.035,0,1.818.445-.035,0",
    transform: "translate(100.061 -30.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    className: "cls-217",
    d: "M-97.346,30.838l-1.818-.445.035,0,1.818.444-.035,0",
    transform: "translate(100.068 -30.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    className: "cls-218",
    d: "M-97.317,30.84l-1.818-.444.036,0,1.816.444-.035,0",
    transform: "translate(100.075 -30.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    className: "cls-218",
    d: "M-97.29,30.843l-1.816-.444.036,0,1.816.444-.036,0",
    transform: "translate(100.083 -30.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    className: "cls-218",
    d: "M-97.261,30.846l-1.816-.444.036,0,1.818.445-.038-.005",
    transform: "translate(100.09 -30.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    className: "cls-219",
    d: "M-97.23,30.85l-1.818-.445.034.005,1.818.444-.034,0",
    transform: "translate(100.097 -30.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    className: "cls-219",
    d: "M-97.2,30.853l-1.818-.444.031,0,1.818.444-.031,0",
    transform: "translate(100.104 -30.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    className: "cls-220",
    d: "M-97.179,30.856-99,30.412l.031,0,1.818.445-.031-.005",
    transform: "translate(100.11 -30.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    className: "cls-220",
    d: "M-97.154,30.86l-1.818-.445.033.005,1.816.444-.031,0",
    transform: "translate(100.117 -30.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    className: "cls-220",
    d: "M-97.129,30.863l-1.816-.444.031.005,1.818.444-.033-.005",
    transform: "translate(100.123 -30.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    className: "cls-220",
    d: "M-97.1,30.867l-1.818-.444.033.005,1.816.444-.031-.005",
    transform: "translate(100.13 -30.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    className: "cls-220",
    d: "M-97.078,30.871l-1.816-.444.033.005,1.816.445-.033-.006",
    transform: "translate(100.136 -30.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    className: "cls-220",
    d: "M-97.052,30.876l-1.816-.445.033.006,1.818.444-.034-.005",
    transform: "translate(100.143 -30.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    className: "cls-221",
    d: "M-97.024,30.88l-1.818-.444.033.006,1.818.444-.033-.006",
    transform: "translate(100.149 -30.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    className: "cls-222",
    d: "M-97,30.885l-1.818-.444.033.005,1.816.445L-97,30.885",
    transform: "translate(100.156 -30.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    className: "cls-222",
    d: "M-96.974,30.89l-1.816-.445.028.006,1.818.444-.029-.005",
    transform: "translate(100.163 -30.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    className: "cls-222",
    d: "M-96.951,30.894l-1.818-.444.029.005,1.816.445-.028-.006",
    transform: "translate(100.168 -30.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    className: "cls-222",
    d: "M-96.929,30.9l-1.816-.445.028.006,1.818.444-.029-.005",
    transform: "translate(100.174 -30.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    className: "cls-223",
    d: "M-96.906,30.9l-1.818-.444.029.006,1.816.444-.028-.006",
    transform: "translate(100.18 -30.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    className: "cls-223",
    d: "M-96.884,30.908l-1.816-.444.029.006,1.816.444-.029-.006",
    transform: "translate(100.185 -30.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    className: "cls-223",
    d: "M-96.861,30.913l-1.816-.444.029.006,1.816.445-.029-.008",
    transform: "translate(100.191 -30.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    className: "cls-224",
    d: "M-96.838,30.919l-1.816-.445.029.008,1.816.444-.029-.006",
    transform: "translate(100.197 -30.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    className: "cls-224",
    d: "M-96.815,30.924l-1.816-.444.021.005,1.816.444-.021-.005",
    transform: "translate(100.203 -30.352)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    className: "cls-10",
    transform: "translate(14.053 31.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    className: "cls-225",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    className: "cls-12",
    d: "M-100.661,37.517l-1.818-.445.023-.006,1.818.444-.023.008",
    transform: "translate(102.479 -33.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    className: "cls-161",
    d: "M-100.644,37.514l-1.818-.444.079-.023,1.816.444-.078.023",
    transform: "translate(102.484 -33.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    className: "cls-162",
    d: "M-100.582,37.5l-1.816-.444.079-.023,1.816.444-.079.023",
    transform: "translate(102.499 -33.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    className: "cls-163",
    d: "M-100.519,37.479l-1.816-.444.078-.024,1.818.445-.079.023",
    transform: "translate(102.515 -33.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    className: "cls-164",
    d: "M-100.455,37.461l-1.818-.445.078-.023,1.818.444-.078.024",
    transform: "translate(102.531 -33.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    className: "cls-165",
    d: "M-100.393,37.441-102.211,37l.078-.023,1.818.444-.078.023",
    transform: "translate(102.547 -33.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    className: "cls-166",
    d: "M-100.331,37.424l-1.818-.444.078-.024,1.816.444-.076.024",
    transform: "translate(102.563 -33.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    className: "cls-167",
    d: "M-100.271,37.4l-1.816-.444.076-.024,1.818.445-.078.023",
    transform: "translate(102.578 -33.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    className: "cls-168",
    d: "M-100.208,37.387l-1.818-.445.076-.023,1.818.444-.076.024",
    transform: "translate(102.594 -33.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    className: "cls-169",
    d: "M-100.147,37.368l-1.818-.444.076-.024,1.818.444-.076.024",
    transform: "translate(102.609 -33.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    className: "cls-170",
    d: "M-100.087,37.39l-1.818-.444c.241-.074.476-.15.707-.227l1.816.444c-.231.078-.465.153-.706.227",
    transform: "translate(102.625 -33.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    className: "cls-171",
    d: "M-99.524,37.211l-1.816-.444q.357-.118.7-.241l1.818.445q-.342.12-.7.239",
    transform: "translate(102.768 -33.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    className: "cls-172",
    d: "M-98.966,37.018l-1.818-.445c.211-.074.417-.15.618-.226l1.818.444q-.3.115-.618.227",
    transform: "translate(102.909 -33.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    className: "cls-173",
    d: "M-98.472,36.835l-1.818-.444c.194-.074.385-.147.57-.221l1.818.444q-.278.111-.57.221",
    transform: "translate(103.034 -33.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    className: "cls-174",
    d: "M-98.018,36.658l-1.818-.444c.181-.071.357-.144.529-.214l1.818.444c-.172.071-.348.143-.529.214",
    transform: "translate(103.149 -33.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    className: "cls-175",
    d: "M-97.6,36.486l-1.818-.444c.168-.07.332-.14.491-.209l1.818.444c-.16.07-.323.139-.491.209",
    transform: "translate(103.256 -33.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    className: "cls-176",
    d: "M-97.2,36.316l-1.818-.444c.152-.065.3-.132.442-.2l1.816.444c-.143.065-.291.13-.441.2",
    transform: "translate(103.355 -33.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    className: "cls-177",
    d: "M-96.852,36.159l-1.816-.444c.139-.063.276-.125.407-.187l1.816.444c-.132.061-.267.124-.407.187",
    transform: "translate(103.445 -33.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    className: "cls-178",
    d: "M-96.527,36.008l-1.816-.444.38-.18,1.818.444-.381.181",
    transform: "translate(103.527 -33.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    className: "cls-178",
    d: "M-96.222,35.863l-1.818-.444c.122-.059.239-.118.353-.174l1.818.444c-.114.058-.232.115-.353.174",
    transform: "translate(103.604 -33.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    className: "cls-179",
    d: "M-95.94,35.721l-1.818-.444.312-.158,1.818.444c-.1.053-.206.105-.312.158",
    transform: "translate(103.676 -33.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    className: "cls-180",
    d: "M-95.691,35.593l-1.818-.444.291-.15,1.816.444-.29.15",
    transform: "translate(103.739 -34.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    className: "cls-181",
    d: "M-95.461,35.472l-1.816-.444.268-.144,1.818.444c-.087.048-.175.1-.27.144",
    transform: "translate(103.798 -34.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    className: "cls-182",
    d: "M-95.245,35.355l-1.818-.444c.086-.046.168-.092.247-.135l1.816.445c-.078.044-.16.088-.246.134",
    transform: "translate(103.852 -34.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    className: "cls-183",
    d: "M-95.05,35.245l-1.816-.445.214-.12,1.816.445-.214.12",
    transform: "translate(103.902 -34.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    className: "cls-184",
    d: "M-94.879,35.148-96.7,34.7l.2-.112,1.816.444-.2.113",
    transform: "translate(103.945 -34.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    className: "cls-185",
    d: "M-94.723,35.056l-1.816-.444.175-.1,1.818.445-.177.1",
    transform: "translate(103.985 -34.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    className: "cls-185",
    d: "M-94.581,34.972l-1.818-.445c.056-.033.108-.064.155-.093l1.818.444c-.048.03-.1.06-.155.094",
    transform: "translate(104.02 -34.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    className: "cls-186",
    d: "M-94.457,34.893l-1.818-.444.128-.078,1.816.444-.127.078",
    transform: "translate(104.052 -34.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    className: "cls-187",
    d: "M-94.357,34.829l-1.816-.444.108-.068,1.816.445-.108.066",
    transform: "translate(104.077 -34.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    className: "cls-188",
    d: "M-94.271,34.774l-1.816-.445.086-.055,1.818.445-.088.055",
    transform: "translate(104.099 -34.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    className: "cls-189",
    d: "M-94.2,34.727l-1.818-.445.065-.041,1.816.444-.064.043",
    transform: "translate(104.117 -34.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    className: "cls-190",
    d: "M-94.15,34.69l-1.816-.444.043-.028,1.816.444-.043.028",
    transform: "translate(104.13 -34.219)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    className: "cls-10",
    transform: "translate(11.915 26.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    className: "cls-226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    className: "cls-10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    className: "cls-224",
    d: "M-102.368,33.367l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(104.185 -29.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    className: "cls-224",
    d: "M-102.358,33.37l-1.816-.444.026.006,1.816.444-.026-.006",
    transform: "translate(104.188 -29.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    className: "cls-223",
    d: "M-102.337,33.375l-1.816-.444.025.005,1.818.445-.026-.006",
    transform: "translate(104.193 -29.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    className: "cls-223",
    d: "M-102.315,33.38l-1.818-.445.026.006,1.818.445-.026-.006",
    transform: "translate(104.198 -29.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    className: "cls-223",
    d: "M-102.295,33.385l-1.818-.445.028.006,1.816.444-.026-.005",
    transform: "translate(104.203 -29.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    className: "cls-222",
    d: "M-102.274,33.389l-1.816-.444.026.005,1.816.445-.026-.006",
    transform: "translate(104.209 -29.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    className: "cls-222",
    d: "M-102.253,33.394l-1.816-.445.026.005,1.818.445-.028-.005",
    transform: "translate(104.214 -29.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    className: "cls-222",
    d: "M-102.23,33.4l-1.818-.445.026.006,1.818.444-.026-.005",
    transform: "translate(104.22 -29.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    className: "cls-222",
    d: "M-102.21,33.4l-1.818-.444.028.005,1.816.444-.026-.005",
    transform: "translate(104.225 -29.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    className: "cls-221",
    d: "M-102.189,33.406l-1.816-.444.026.005,1.818.444-.028-.005",
    transform: "translate(104.231 -29.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    className: "cls-220",
    d: "M-102.166,33.41l-1.818-.444.028,0,1.816.445-.026-.005",
    transform: "translate(104.236 -29.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    className: "cls-220",
    d: "M-102.146,33.414l-1.816-.445.026.005,1.818.444-.028,0",
    transform: "translate(104.241 -29.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    className: "cls-220",
    d: "M-102.123,33.417l-1.818-.444.028,0,1.818.445-.028-.005",
    transform: "translate(104.247 -29.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    className: "cls-220",
    d: "M-102.1,33.421l-1.818-.445.028.005,1.816.444-.026,0",
    transform: "translate(104.252 -29.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    className: "cls-220",
    d: "M-102.081,33.424l-1.816-.444.028,0,1.816.444-.028,0",
    transform: "translate(104.258 -29.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    className: "cls-220",
    d: "M-102.059,33.427l-1.816-.444.028,0,1.816.444-.028,0",
    transform: "translate(104.264 -29.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    className: "cls-219",
    d: "M-102.037,33.43l-1.816-.444.028,0,1.816.444-.028,0",
    transform: "translate(104.269 -29.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    className: "cls-219",
    d: "M-102.015,33.433l-1.816-.444.029,0,1.816.444-.029,0",
    transform: "translate(104.275 -29.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    className: "cls-218",
    d: "M-101.992,33.436l-1.816-.444.028,0,1.818.445-.029,0",
    transform: "translate(104.28 -29.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    className: "cls-218",
    d: "M-101.968,33.439l-1.818-.445.029,0,1.816.444-.028,0",
    transform: "translate(104.286 -29.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    className: "cls-218",
    d: "M-101.947,33.441-103.763,33l.029,0,1.816.445-.029,0",
    transform: "translate(104.292 -29.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    className: "cls-217",
    d: "M-101.924,33.444-103.74,33l.029,0,1.816.445-.029,0",
    transform: "translate(104.298 -29.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    className: "cls-217",
    d: "M-101.9,33.446-103.717,33l.029,0,1.816.445-.029,0",
    transform: "translate(104.303 -29.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    className: "cls-217",
    d: "M-101.878,33.448-103.694,33l.029,0,1.816.444h-.029",
    transform: "translate(104.309 -29.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    className: "cls-216",
    d: "M-101.855,33.449l-1.816-.444.029,0,1.816.444-.029,0",
    transform: "translate(104.315 -29.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    className: "cls-216",
    d: "M-101.832,33.451l-1.816-.444h.029l1.818.445-.03,0",
    transform: "translate(104.321 -29.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    className: "cls-215",
    d: "M-101.807,33.453l-1.818-.445.03,0,1.816.444h-.029",
    transform: "translate(104.327 -29.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    className: "cls-214",
    d: "M-101.785,33.454l-1.816-.444h.03l1.818.444h-.031",
    transform: "translate(104.333 -29.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    className: "cls-214",
    d: "M-101.759,33.455l-1.818-.444h.031l1.816.444h-.03",
    transform: "translate(104.339 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    className: "cls-214",
    d: "M-101.736,33.456l-1.816-.444h.03l1.818.445h-.031",
    transform: "translate(104.345 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    className: "cls-214",
    d: "M-101.71,33.457l-1.818-.445h.031l1.818.444h-.031",
    transform: "translate(104.351 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    className: "cls-214",
    d: "M-101.686,33.457l-1.818-.444h.031l1.818.445h-.031",
    transform: "translate(104.358 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    className: "cls-213",
    d: "M-101.66,33.458l-1.818-.445h.031l1.818.445h-.031",
    transform: "translate(104.364 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    className: "cls-213",
    d: "M-101.635,33.458l-1.818-.445a.264.264,0,0,0,.031,0l1.818.445h-.031",
    transform: "translate(104.37 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    className: "cls-212",
    d: "M-101.611,33.458l-1.818-.445h.031l1.818.445h-.031",
    transform: "translate(104.377 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    className: "cls-212",
    d: "M-101.586,33.458l-1.818-.445h.031l1.818.444h-.031",
    transform: "translate(104.383 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    className: "cls-212",
    d: "M-101.56,33.457l-1.818-.444h.034l1.818.444h-.034",
    transform: "translate(104.389 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    className: "cls-212",
    d: "M-101.534,33.456l-1.818-.444h.035l1.818.444h-.035",
    transform: "translate(104.396 -29.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    className: "cls-211",
    d: "M-101.505,33.455l-1.818-.444h.035l1.816.444h-.034",
    transform: "translate(104.403 -29.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    className: "cls-210",
    d: "M-101.479,33.454l-1.816-.444.035,0,1.816.444-.035,0",
    transform: "translate(104.41 -29.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    className: "cls-210",
    d: "M-101.451,33.452l-1.816-.444.035,0,1.816.445h-.035",
    transform: "translate(104.418 -29.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    className: "cls-210",
    d: "M-101.423,33.451l-1.816-.445.035,0,1.818.445-.036,0",
    transform: "translate(104.425 -29.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    className: "cls-209",
    d: "M-101.393,33.45-103.211,33l.035,0,1.818.444-.035,0",
    transform: "translate(104.432 -29.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    className: "cls-208",
    d: "M-101.365,33.446-103.183,33l.036,0,1.816.445-.035,0",
    transform: "translate(104.439 -29.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    className: "cls-208",
    d: "M-101.338,33.445-103.154,33l.035,0,1.818.445-.036,0",
    transform: "translate(104.446 -29.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    className: "cls-208",
    d: "M-101.309,33.446-103.126,33c.06-.006.12-.014.182-.024l1.818.444c-.061.01-.122.018-.182.025",
    transform: "translate(104.453 -29.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    className: "cls-207",
    d: "M-101.164,33.442-102.981,33a3.963,3.963,0,0,0,.458-.1h0l1.816.444h0a3.768,3.768,0,0,1-.457.1",
    transform: "translate(104.49 -29.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    className: "cls-227",
    d: "M-100.8,33.34l-1.816-.444.015-.005,1.818.445-.016,0",
    transform: "translate(104.583 -29.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    className: "cls-228",
    d: "M-100.783,33.337l-1.818-.445.016,0,1.816.444-.015.005",
    transform: "translate(104.587 -29.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    className: "cls-229",
    d: "M-100.771,33.333l-1.816-.444.015-.005,1.818.444-.016.005",
    transform: "translate(104.59 -29.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    className: "cls-230",
    d: "M-100.757,33.329l-1.818-.444.016-.005,1.816.444-.015.005",
    transform: "translate(104.593 -29.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    className: "cls-231",
    d: "M-100.746,33.325l-1.816-.444.015-.005,1.818.445-.016,0",
    transform: "translate(104.596 -29.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    className: "cls-232",
    d: "M-100.732,33.322l-1.818-.445.016-.005,1.816.445-.015.005",
    transform: "translate(104.599 -29.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    className: "cls-233",
    d: "M-100.721,33.318l-1.816-.445.015-.005,1.818.445-.016.005",
    transform: "translate(104.603 -29.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    className: "cls-234",
    d: "M-100.707,33.314l-1.818-.445.016-.005,1.818.444-.016.006",
    transform: "translate(104.606 -29.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    className: "cls-235",
    d: "M-100.695,33.309l-1.818-.444.016-.005,1.816.444-.015.005",
    transform: "translate(104.609 -29.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    className: "cls-236",
    d: "M-100.683,33.3l-1.816-.444.015-.005,1.818.444-.016.005",
    transform: "translate(104.612 -29.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    className: "cls-237",
    d: "M-100.67,33.3l-1.818-.444.061-.021,1.818.444-.061.021",
    transform: "translate(104.615 -29.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    className: "cls-238",
    d: "M-100.62,33.288l-1.818-.444.071-.026,1.816.445-.07.025",
    transform: "translate(104.628 -29.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    className: "cls-239",
    d: "M-100.565,33.268l-1.816-.445.064-.025,1.818.445-.065.025",
    transform: "translate(104.642 -29.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    className: "cls-240",
    d: "M-100.512,33.248l-1.818-.445.058-.023,1.818.444-.058.024",
    transform: "translate(104.655 -29.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    className: "cls-241",
    d: "M-100.466,33.229l-1.818-.444.059-.025,1.816.444-.058.025",
    transform: "translate(104.667 -29.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    className: "cls-242",
    d: "M-100.421,33.209l-1.816-.444.053-.024,1.816.445-.053.023",
    transform: "translate(104.679 -29.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    className: "cls-243",
    d: "M-100.379,33.191l-1.816-.445.05-.023,1.816.445-.05.023",
    transform: "translate(104.689 -29.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    className: "cls-244",
    d: "M-100.339,33.173l-1.816-.445.049-.024,1.818.445-.05.024",
    transform: "translate(104.699 -29.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    className: "cls-245",
    d: "M-100.3,33.154l-1.818-.445.048-.024,1.818.445-.048.024",
    transform: "translate(104.709 -29.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    className: "cls-246",
    d: "M-100.26,33.134l-1.818-.445.043-.02,1.816.444-.041.021",
    transform: "translate(104.719 -29.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    className: "cls-247",
    d: "M-100.228,33.117l-1.816-.444.041-.023,1.816.445-.041.021",
    transform: "translate(104.727 -29.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    className: "cls-248",
    d: "M-100.195,33.1l-1.816-.445.041-.021,1.818.444-.043.023",
    transform: "translate(104.736 -29.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    className: "cls-249",
    d: "M-100.16,33.082l-1.818-.444.041-.023,1.818.444-.041.023",
    transform: "translate(104.744 -29.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    className: "cls-249",
    d: "M-100.127,33.064l-1.818-.444.036-.021,1.818.445-.036.02",
    transform: "translate(104.753 -29.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    className: "cls-250",
    d: "M-100.1,33.048l-1.818-.445.038-.02,1.816.444-.036.021",
    transform: "translate(104.76 -29.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    className: "cls-251",
    d: "M-100.07,33.031l-1.816-.444.036-.023,1.816.445-.036.021",
    transform: "translate(104.768 -29.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    className: "cls-252",
    d: "M-100.041,33.014l-1.816-.445.036-.021,1.818.444-.038.023",
    transform: "translate(104.775 -29.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    className: "cls-253",
    d: "M-100.01,33l-1.818-.444.035-.021,1.816.444-.034.021",
    transform: "translate(104.782 -29.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    className: "cls-254",
    d: "M-99.984,32.979l-1.816-.444.033-.02,1.816.444-.033.02",
    transform: "translate(104.789 -29.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    className: "cls-255",
    d: "M-99.958,32.963l-1.816-.444.033-.021,1.816.445-.033.02",
    transform: "translate(104.796 -29.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    className: "cls-138",
    d: "M-99.932,32.947l-1.816-.445.033-.021,1.818.445-.034.021",
    transform: "translate(104.803 -29.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    className: "cls-256",
    d: "M-99.9,32.93l-1.818-.445.033-.021,1.818.445-.033.021",
    transform: "translate(104.809 -29.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    className: "cls-257",
    d: "M-99.879,32.913l-1.818-.445.033-.021,1.816.445-.031.021",
    transform: "translate(104.816 -29.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    className: "cls-257",
    d: "M-99.854,32.9l-1.816-.445.029-.02,1.818.444-.03.021",
    transform: "translate(104.822 -29.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    className: "cls-258",
    d: "M-99.83,32.879l-1.818-.444.03-.021,1.818.445-.03.02",
    transform: "translate(104.828 -29.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    className: "cls-259",
    d: "M-99.805,32.863l-1.818-.445.03-.02,1.818.444-.03.021",
    transform: "translate(104.834 -29.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    className: "cls-260",
    d: "M-99.781,32.846-101.6,32.4l.03-.021,1.818.444-.03.021",
    transform: "translate(104.84 -29.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    className: "cls-261",
    d: "M-99.757,32.829l-1.818-.444.03-.023,1.818.445-.03.021",
    transform: "translate(104.846 -29.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    className: "cls-262",
    d: "M-99.733,32.812l-1.818-.445.029-.021,1.818.445-.029.021",
    transform: "translate(104.852 -29.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    className: "cls-263",
    d: "M-99.711,32.8l-1.818-.445.028-.02,1.818.444-.028.021",
    transform: "translate(104.858 -29.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    className: "cls-264",
    d: "M-99.689,32.778l-1.818-.444.029-.021,1.816.444-.028.021",
    transform: "translate(104.864 -29.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    className: "cls-265",
    d: "M-99.667,32.761l-1.816-.444.028-.021,1.818.444-.029.021",
    transform: "translate(104.87 -29.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    className: "cls-266",
    d: "M-99.644,32.744l-1.818-.444.028-.021,1.818.444-.028.021",
    transform: "translate(104.875 -29.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    className: "cls-267",
    d: "M-99.622,32.727l-1.818-.444.029-.023,1.816.444-.028.023",
    transform: "translate(104.881 -29.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    className: "cls-268",
    d: "M-99.6,32.71l-1.816-.444.03-.025,1.818.445-.031.024",
    transform: "translate(104.887 -29.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    className: "cls-269",
    d: "M-99.574,32.692l-1.818-.445.036-.029,1.816.445-.035.029",
    transform: "translate(104.893 -29.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    className: "cls-270",
    d: "M-99.547,32.669l-1.816-.445.035-.029,1.818.444-.036.03",
    transform: "translate(104.9 -29.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    className: "cls-271",
    d: "M-99.517,32.645l-1.818-.444.036-.03,1.816.444-.035.03",
    transform: "translate(104.907 -29.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    className: "cls-272",
    d: "M-99.49,32.621l-1.816-.444.035-.03,1.818.444-.036.03",
    transform: "translate(104.915 -29.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    className: "cls-273",
    d: "M-99.46,32.617l-1.818-.444c.048-.041.1-.084.144-.129l1.818.445-.144.128",
    transform: "translate(104.922 -29.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    className: "cls-272",
    d: "M-99.345,32.51l-1.818-.445c.038-.034.074-.068.112-.1l1.816.444c-.036.036-.074.071-.11.105",
    transform: "translate(104.951 -30.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    className: "cls-271",
    d: "M-99.258,32.42l-1.816-.444L-101,31.9l1.816.444-.079.076",
    transform: "translate(104.973 -30.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    className: "cls-270",
    d: "M-99.195,32.356l-1.816-.444.059-.061,1.818.445-.06.06",
    transform: "translate(104.989 -30.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    className: "cls-269",
    d: "M-99.147,32.306l-1.818-.445.048-.049,1.818.444-.048.05",
    transform: "translate(105.001 -30.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    className: "cls-268",
    d: "M-99.108,32.266l-1.818-.444.048-.05,1.818.445-.048.049",
    transform: "translate(105.011 -30.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    className: "cls-267",
    d: "M-99.07,32.227l-1.818-.445.048-.051,1.818.445-.048.051",
    transform: "translate(105.02 -30.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    className: "cls-266",
    d: "M-99.033,32.183l-1.818-.445.033-.034,1.816.444-.031.035",
    transform: "translate(105.03 -30.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    className: "cls-265",
    d: "M-99.008,32.155l-1.816-.444.03-.035,1.818.445-.031.034",
    transform: "translate(105.037 -30.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    className: "cls-264",
    d: "M-98.982,32.128l-1.818-.445.031-.034,1.818.444-.031.035",
    transform: "translate(105.043 -30.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    className: "cls-263",
    d: "M-98.957,32.1l-1.818-.444.031-.035,1.816.444-.03.035",
    transform: "translate(105.049 -30.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    className: "cls-262",
    d: "M-98.934,32.072l-1.816-.444.03-.035,1.818.444-.031.035",
    transform: "translate(105.055 -30.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    className: "cls-261",
    d: "M-98.909,32.044l-1.818-.444.029-.034,1.818.444-.029.034",
    transform: "translate(105.062 -30.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    className: "cls-260",
    d: "M-98.885,32.016l-1.818-.444.025-.029,1.816.445-.024.028",
    transform: "translate(105.067 -30.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    className: "cls-259",
    d: "M-98.867,31.994l-1.816-.445.024-.029,1.816.445-.024.029",
    transform: "translate(105.072 -30.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    className: "cls-258",
    d: "M-98.848,31.971l-1.816-.445.024-.029,1.818.445-.025.029",
    transform: "translate(105.077 -30.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    className: "cls-257",
    d: "M-98.827,31.948l-1.818-.445.025-.029,1.816.444-.024.03",
    transform: "translate(105.082 -30.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    className: "cls-257",
    d: "M-98.809,31.924l-1.816-.444.024-.03,1.818.445-.025.029",
    transform: "translate(105.087 -30.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    className: "cls-256",
    d: "M-98.788,31.9l-1.818-.445.024-.029,1.818.444-.024.03",
    transform: "translate(105.092 -30.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    className: "cls-138",
    d: "M-98.769,31.877l-1.818-.444.024-.029,1.816.444-.023.029",
    transform: "translate(105.097 -30.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    className: "cls-255",
    d: "M-98.752,31.853l-1.816-.444.02-.025,1.816.444-.02.025",
    transform: "translate(105.102 -30.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    className: "cls-254",
    d: "M-98.736,31.833l-1.816-.444.019-.025,1.818.445-.02.024",
    transform: "translate(105.106 -30.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    className: "cls-253",
    d: "M-98.72,31.814l-1.818-.445.02-.024,1.816.444-.019.025",
    transform: "translate(105.11 -30.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    className: "cls-252",
    d: "M-98.7,31.794l-1.816-.444.019-.025,1.818.444-.02.025",
    transform: "translate(105.114 -30.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    className: "cls-251",
    d: "M-98.689,31.774l-1.818-.444.02-.025,1.816.444-.019.025",
    transform: "translate(105.117 -30.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    className: "cls-250",
    d: "M-98.674,31.754l-1.816-.444.02-.026,1.816.445-.02.025",
    transform: "translate(105.121 -30.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    className: "cls-249",
    d: "M-98.658,31.734l-1.816-.445.019-.025,1.818.444-.02.026",
    transform: "translate(105.125 -30.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    className: "cls-249",
    d: "M-98.641,31.713l-1.818-.444.02-.026,1.816.445-.019.025",
    transform: "translate(105.129 -30.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    className: "cls-248",
    d: "M-98.627,31.693l-1.816-.445.018-.024,1.818.444-.019.025",
    transform: "translate(105.133 -30.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    className: "cls-247",
    d: "M-98.612,31.672l-1.818-.444.018-.023,1.816.445-.016.021",
    transform: "translate(105.137 -30.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    className: "cls-246",
    d: "M-98.6,31.656l-1.816-.445.016-.023,1.816.445-.016.023",
    transform: "translate(105.14 -30.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    className: "cls-245",
    d: "M-98.586,31.637l-1.816-.445.016-.021,1.818.444-.018.023",
    transform: "translate(105.144 -30.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    className: "cls-244",
    d: "M-98.571,31.619l-1.818-.444.016-.023,1.818.444-.016.023",
    transform: "translate(105.147 -30.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    className: "cls-243",
    d: "M-98.559,31.6l-1.818-.444.016-.023,1.818.444-.016.023",
    transform: "translate(105.15 -30.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    className: "cls-242",
    d: "M-98.545,31.584l-1.818-.444.018-.024,1.816.445-.016.023",
    transform: "translate(105.154 -30.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    className: "cls-241",
    d: "M-98.533,31.566l-1.816-.445.016-.023,1.816.445-.016.023",
    transform: "translate(105.157 -30.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    className: "cls-240",
    d: "M-98.52,31.548l-1.816-.445.016-.023,1.816.444-.016.024",
    transform: "translate(105.161 -30.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    className: "cls-239",
    d: "M-98.507,31.529l-1.816-.444.016-.024,1.818.445-.018.023",
    transform: "translate(105.164 -30.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    className: "cls-238",
    d: "M-98.493,31.511l-1.818-.445.016-.023,1.818.444-.016.024",
    transform: "translate(105.167 -30.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    className: "cls-237",
    d: "M-98.48,31.491l-1.818-.444.015-.021,1.818.444-.015.021",
    transform: "translate(105.17 -30.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    className: "cls-236",
    d: "M-98.467,31.474l-1.818-.444.015-.021,1.816.444-.014.021",
    transform: "translate(105.173 -30.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    className: "cls-235",
    d: "M-98.457,31.457l-1.816-.444.015-.021,1.816.444-.015.021",
    transform: "translate(105.176 -30.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    className: "cls-234",
    d: "M-98.445,31.44-100.261,31l.015-.021,1.816.444-.015.021",
    transform: "translate(105.179 -30.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    className: "cls-233",
    d: "M-98.433,31.423l-1.816-.444.014-.021,1.818.444-.015.021",
    transform: "translate(105.183 -30.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    className: "cls-232",
    d: "M-98.421,31.406l-1.818-.444.015-.021,1.818.444-.015.021",
    transform: "translate(105.185 -30.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    className: "cls-231",
    d: "M-98.409,31.389l-1.818-.444.015-.023,1.816.445-.014.021",
    transform: "translate(105.188 -30.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    className: "cls-230",
    d: "M-98.4,31.372l-1.816-.445.015-.021,1.816.444-.015.023",
    transform: "translate(105.191 -30.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    className: "cls-229",
    d: "M-98.386,31.354l-1.816-.444.015-.023,1.816.445-.015.021",
    transform: "translate(105.194 -30.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    className: "cls-228",
    d: "M-98.374,31.337l-1.816-.445.014-.021,1.818.444-.015.023",
    transform: "translate(105.197 -30.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    className: "cls-227",
    d: "M-98.361,31.319l-1.818-.444.015-.023,1.818.445-.015.021",
    transform: "translate(105.2 -30.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    className: "cls-207",
    d: "M-98.35,31.3l-1.818-.445.015-.021,1.816.444-.014.023",
    transform: "translate(105.203 -30.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    className: "cls-208",
    d: "M-98.339,31.284l-1.816-.444.013-.02,1.818.444-.014.02",
    transform: "translate(105.206 -30.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    className: "cls-208",
    d: "M-98.327,31.268l-1.818-.444.014-.021,1.816.445-.013.02",
    transform: "translate(105.209 -30.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    className: "cls-208",
    d: "M-98.318,31.252l-1.816-.445.014-.02,1.816.445-.014.02",
    transform: "translate(105.212 -30.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    className: "cls-209",
    d: "M-98.307,31.236l-1.816-.445.013-.02,1.818.444-.014.021",
    transform: "translate(105.214 -30.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    className: "cls-210",
    d: "M-98.3,31.219l-1.818-.444.014-.021,1.818.445-.014.02",
    transform: "translate(105.217 -30.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    className: "cls-210",
    d: "M-98.285,31.2l-1.818-.445.014-.02,1.816.444-.013.021",
    transform: "translate(105.22 -30.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    className: "cls-210",
    d: "M-98.275,31.186l-1.816-.444.013-.021,1.818.445-.014.02",
    transform: "translate(105.223 -30.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    className: "cls-211",
    d: "M-98.263,31.17l-1.818-.445.014-.021,1.818.445-.014.021",
    transform: "translate(105.225 -30.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    className: "cls-212",
    d: "M-98.253,31.153l-1.818-.445.014-.02,1.816.444-.013.021",
    transform: "translate(105.228 -30.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    className: "cls-212",
    d: "M-98.243,31.136l-1.816-.444.013-.021,1.818.444-.014.021",
    transform: "translate(105.231 -30.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    className: "cls-212",
    d: "M-98.231,31.119l-1.818-.444.014-.021,1.816.444-.013.021",
    transform: "translate(105.233 -30.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    className: "cls-212",
    d: "M-98.222,31.1l-1.816-.444.014-.021,1.816.444-.014.021",
    transform: "translate(105.236 -30.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    className: "cls-213",
    d: "M-98.211,31.085l-1.816-.444.013-.021,1.818.444-.014.021",
    transform: "translate(105.239 -30.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    className: "cls-213",
    d: "M-98.2,31.068l-1.818-.444.013-.02,1.818.444-.013.02",
    transform: "translate(105.241 -30.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    className: "cls-214",
    d: "M-98.189,31.052l-1.818-.444.014-.021,1.816.444-.013.021",
    transform: "translate(105.244 -30.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    className: "cls-214",
    d: "M-98.18,31.035-100,30.591l.013-.021,1.816.445-.013.02",
    transform: "translate(105.247 -30.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    className: "cls-214",
    d: "M-98.17,31.019l-1.816-.445.013-.02,1.816.444-.013.021",
    transform: "translate(105.249 -30.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    className: "cls-214",
    d: "M-98.16,31l-1.816-.444.013-.021,1.818.444L-98.16,31",
    transform: "translate(105.252 -30.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    className: "cls-214",
    d: "M-98.149,30.985l-1.818-.444.013-.021,1.818.445-.013.02",
    transform: "translate(105.254 -30.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    className: "cls-215",
    d: "M-98.138,30.969l-1.818-.445.014-.021,1.816.445-.013.021",
    transform: "translate(105.257 -30.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    className: "cls-216",
    d: "M-98.129,30.952l-1.816-.445.013-.021,1.816.445-.013.021",
    transform: "translate(105.26 -30.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    className: "cls-216",
    d: "M-98.119,30.935l-1.816-.445.013-.021,1.816.445-.013.021",
    transform: "translate(105.262 -30.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    className: "cls-217",
    d: "M-98.109,30.918l-1.816-.445.013-.021,1.818.445-.014.021",
    transform: "translate(105.265 -30.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    className: "cls-217",
    d: "M-98.1,30.9l-1.818-.445.013-.021,1.818.445-.013.021",
    transform: "translate(105.267 -30.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    className: "cls-217",
    d: "M-98.087,30.884l-1.818-.445.013-.021,1.818.444-.013.023",
    transform: "translate(105.27 -30.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    className: "cls-218",
    d: "M-98.077,30.866l-1.818-.444.013-.021,1.818.445-.013.02",
    transform: "translate(105.272 -30.401)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    className: "cls-10",
    transform: "translate(12.799 11.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    className: "cls-36",
    d: "M-101.663,31.109l-1.817-.444.011,0,1.817.444-.011,0",
    transform: "translate(103.479 -14.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    className: "cls-36",
    d: "M-101.654,31.111l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.482 -14.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    className: "cls-35",
    d: "M-101.643,31.113l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.484 -14.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    className: "cls-34",
    d: "M-101.633,31.116l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.487 -14.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    className: "cls-34",
    d: "M-101.622,31.118l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.49 -14.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    className: "cls-34",
    d: "M-101.612,31.12l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.492 -14.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    className: "cls-33",
    d: "M-101.6,31.122l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.495 -14.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    className: "cls-32",
    d: "M-101.591,31.124l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.498 -14.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    className: "cls-32",
    d: "M-101.581,31.126l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.5 -14.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    className: "cls-32",
    d: "M-101.57,31.128l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.503 -14.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    className: "cls-32",
    d: "M-101.56,31.13l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.506 -14.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    className: "cls-31",
    d: "M-101.549,31.132l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.508 -14.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    className: "cls-30",
    d: "M-101.538,31.134l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.511 -14.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    className: "cls-30",
    d: "M-101.528,31.135l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.514 -14.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    className: "cls-30",
    d: "M-101.517,31.137l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.516 -14.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    className: "cls-29",
    d: "M-101.507,31.139l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.519 -14.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    className: "cls-28",
    d: "M-101.5,31.14l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.522 -14.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    className: "cls-28",
    d: "M-101.485,31.141-103.3,30.7l.013,0,1.817.444-.013,0",
    transform: "translate(103.524 -14.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    className: "cls-27",
    d: "M-101.475,31.143l-1.817-.444.013,0,1.817.444-.013,0",
    transform: "translate(103.527 -14.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    className: "cls-27",
    d: "M-101.464,31.144l-1.817-.444h.013l1.817.444h-.013",
    transform: "translate(103.53 -14.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    className: "cls-27",
    d: "M-101.453,31.145l-1.817-.444h.014l1.817.444h-.014",
    transform: "translate(103.533 -14.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    className: "cls-26",
    d: "M-101.443,31.146l-1.816-.444h.016l1.816.445-.016,0",
    transform: "translate(103.535 -14.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    className: "cls-25",
    d: "M-101.43,31.148l-1.816-.445h.016l1.818.445h-.018",
    transform: "translate(103.539 -14.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    className: "cls-25",
    d: "M-101.415,31.149l-1.818-.445h.016l1.818.445h-.016",
    transform: "translate(103.542 -14.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    className: "cls-25",
    d: "M-101.4,31.15l-1.818-.445h.018l1.816.445h-.016",
    transform: "translate(103.545 -14.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    className: "cls-24",
    d: "M-101.39,31.151l-1.816-.445h.016l1.816.444h-.016",
    transform: "translate(103.549 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    className: "cls-23",
    d: "M-101.377,31.151l-1.816-.444h.016l1.818.444h-.018",
    transform: "translate(103.552 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    className: "cls-23",
    d: "M-101.362,31.152l-1.818-.444h.016l1.818.445h-.016",
    transform: "translate(103.555 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    className: "cls-23",
    d: "M-101.349,31.153l-1.818-.445h.018l1.816.444h-.016",
    transform: "translate(103.559 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    className: "cls-22",
    d: "M-101.337,31.153l-1.816-.444h.016l1.818.444h-.018",
    transform: "translate(103.562 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    className: "cls-21",
    d: "M-101.323,31.153l-1.818-.444h.018l1.816.445h-.016",
    transform: "translate(103.566 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    className: "cls-20",
    d: "M-101.31,31.154l-1.816-.445h.016l1.818.445h-.018",
    transform: "translate(103.569 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    className: "cls-20",
    d: "M-101.3,31.154l-1.818-.445h.016l1.818.445h-.016",
    transform: "translate(103.572 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    className: "cls-19",
    d: "M-101.283,31.154l-1.818-.445h.018l1.816.445h-.016",
    transform: "translate(103.576 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    className: "cls-19",
    d: "M-101.27,31.154l-1.816-.445h.016l1.818.444h-.018",
    transform: "translate(103.579 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    className: "cls-18",
    d: "M-101.255,31.153l-1.818-.444h.018l1.816.444h-.016",
    transform: "translate(103.582 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    className: "cls-18",
    d: "M-101.243,31.153l-1.816-.444h.016l1.818.445h-.018",
    transform: "translate(103.586 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    className: "cls-17",
    d: "M-101.228,31.153l-1.818-.445h.018l1.818.444h-.018",
    transform: "translate(103.589 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    className: "cls-17",
    d: "M-101.215,31.152l-1.818-.444h.018l1.816.444h-.016",
    transform: "translate(103.593 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    className: "cls-16",
    d: "M-101.2,31.151l-1.816-.444H-103l1.818.445h-.018",
    transform: "translate(103.596 -14.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    className: "cls-16",
    d: "M-101.187,31.151-103,30.706h.018l1.816.445h-.016",
    transform: "translate(103.6 -14.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    className: "cls-15",
    d: "M-101.175,31.15l-1.816-.445h.016l1.818.445h-.018",
    transform: "translate(103.603 -14.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    className: "cls-15",
    d: "M-101.16,31.149l-1.818-.445h.018l1.818.444-.018,0",
    transform: "translate(103.607 -14.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    className: "cls-14",
    d: "M-101.146,31.148l-1.818-.444.05-.005,1.816.444-.049.005",
    transform: "translate(103.61 -14.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    className: "cls-13",
    d: "M-101.108,31.147l-1.816-.444q.066-.008.132-.019l1.816.444q-.066.011-.132.019",
    transform: "translate(103.62 -14.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    className: "cls-13",
    d: "M-101,31.134l-1.816-.444c.044-.009.088-.018.133-.029l1.818.445c-.045.01-.089.02-.134.028",
    transform: "translate(103.647 -14.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    className: "cls-12",
    d: "M-100.9,31.111l-1.818-.445c.033-.008.064-.015.1-.025h.006l1.816.444-.006,0-.1.025",
    transform: "translate(103.674 -14.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    className: "cls-161",
    d: "M-100.815,31.085l-1.816-.444.023-.008,1.818.445-.024.006",
    transform: "translate(103.695 -14.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    className: "cls-162",
    d: "M-100.8,31.08l-1.818-.445.023-.006,1.818.444-.023.008",
    transform: "translate(103.699 -14.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    className: "cls-163",
    d: "M-100.778,31.074l-1.818-.444.023-.008,1.818.445-.023.006",
    transform: "translate(103.704 -14.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    className: "cls-164",
    d: "M-100.759,31.07l-1.818-.445.023-.008,1.818.445-.023.008",
    transform: "translate(103.708 -14.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    className: "cls-165",
    d: "M-100.741,31.063l-1.818-.445.023-.008,1.816.445-.021.008",
    transform: "translate(103.713 -14.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    className: "cls-166",
    d: "M-100.725,31.058l-1.816-.445.023-.008,1.816.445-.023.008",
    transform: "translate(103.717 -14.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    className: "cls-167",
    d: "M-100.707,31.051l-1.816-.445.023-.008,1.816.444-.023.009",
    transform: "translate(103.722 -14.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    className: "cls-168",
    d: "M-100.689,31.045-102.5,30.6l.023-.009,1.816.445-.023.008",
    transform: "translate(103.726 -14.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    className: "cls-169",
    d: "M-100.671,31.039l-1.816-.445.021-.009,1.818.445-.023.009",
    transform: "translate(103.731 -14.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-170",
    d: "M-100.653,31.032l-1.818-.445.023-.009,1.816.445-.021.009",
    transform: "translate(103.735 -14.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-171",
    d: "M-100.636,31.025l-1.816-.445.023-.009,1.816.445-.023.009",
    transform: "translate(103.74 -14.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-172",
    d: "M-100.618,31.018l-1.816-.445.021-.009,1.818.445-.023.009",
    transform: "translate(103.744 -14.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    className: "cls-173",
    d: "M-100.6,31.011l-1.818-.445.023-.009,1.816.444-.021.01",
    transform: "translate(103.749 -14.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-174",
    d: "M-100.583,31l-1.816-.444.023-.01,1.816.444-.023.01",
    transform: "translate(103.753 -14.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-175",
    d: "M-100.565,30.995l-1.816-.444.021-.01,1.818.445-.023.009",
    transform: "translate(103.758 -14.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-176",
    d: "M-100.546,30.988l-1.818-.445.023-.01,1.816.445-.021.01",
    transform: "translate(103.762 -14.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-177",
    d: "M-100.53,30.98l-1.816-.445.021-.01,1.816.445-.021.01",
    transform: "translate(103.767 -14.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-178",
    d: "M-100.513,30.972l-1.816-.445.024-.011,1.816.445-.024.011",
    transform: "translate(103.771 -14.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-178",
    d: "M-100.494,30.964l-1.816-.445.025-.013,1.818.445-.026.013",
    transform: "translate(103.776 -14.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-179",
    d: "M-100.472,30.954l-1.818-.445.026-.013,1.816.444-.025.014",
    transform: "translate(103.781 -14.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-180",
    d: "M-100.453,30.943l-1.816-.444.025-.014,1.818.445-.026.013",
    transform: "translate(103.786 -14.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-181",
    d: "M-100.431,30.933l-1.818-.445.026-.013,1.816.444-.025.014",
    transform: "translate(103.791 -14.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-182",
    d: "M-100.412,30.922l-1.816-.444.025-.014,1.816.444-.025.014",
    transform: "translate(103.797 -14.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-183",
    d: "M-100.392,30.911l-1.816-.444.025-.015,1.818.445-.026.014",
    transform: "translate(103.802 -14.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-184",
    d: "M-100.371,30.9l-1.818-.445.026-.014,1.816.444-.025.015",
    transform: "translate(103.807 -14.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-185",
    d: "M-100.351,30.888l-1.816-.444.025-.015,1.816.445-.025.014",
    transform: "translate(103.812 -14.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-185",
    d: "M-100.331,30.877l-1.816-.445.025-.015,1.816.445-.025.015",
    transform: "translate(103.817 -14.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-186",
    d: "M-100.311,30.865l-1.816-.445.025-.015,1.816.445-.025.015",
    transform: "translate(103.822 -14.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-187",
    d: "M-100.291,30.853l-1.816-.445.025-.015,1.816.444-.025.016",
    transform: "translate(103.827 -14.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-188",
    d: "M-100.271,30.84l-1.816-.444.025-.016,1.816.445-.025.015",
    transform: "translate(103.832 -14.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-189",
    d: "M-100.251,30.828l-1.816-.445.025-.015,1.816.444-.025.016",
    transform: "translate(103.837 -14.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-190",
    d: "M-100.231,30.815l-1.816-.444.025-.016,1.816.444-.025.016",
    transform: "translate(103.842 -14.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-190",
    d: "M-100.211,30.8l-1.816-.444.024-.016,1.816.444-.024.016",
    transform: "translate(103.848 -14.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    className: "cls-191",
    d: "M-100.192,30.789l-1.816-.444.023-.016,1.816.445-.023.015",
    transform: "translate(103.852 -14.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-191",
    d: "M-100.174,30.777l-1.816-.445.023-.015,1.816.445-.023.015",
    transform: "translate(103.857 -14.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-192",
    d: "M-100.156,30.765l-1.816-.445.021-.015,1.818.444-.023.016",
    transform: "translate(103.862 -14.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-192",
    d: "M-100.138,30.752l-1.818-.444.023-.016,1.816.444-.021.016",
    transform: "translate(103.866 -14.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-192",
    d: "M-100.121,30.739l-1.816-.444.023-.016,1.816.445-.023.015",
    transform: "translate(103.87 -14.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-193",
    d: "M-100.1,30.727l-1.816-.445.021-.016,1.818.445-.023.016",
    transform: "translate(103.875 -14.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-194",
    d: "M-100.085,30.714l-1.818-.445.023-.016,1.816.444-.021.018",
    transform: "translate(103.879 -14.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-195",
    d: "M-100.068,30.7l-1.816-.444.021-.016,1.818.444-.023.016",
    transform: "translate(103.884 -14.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-196",
    d: "M-100.05,30.687l-1.818-.444.023-.018,1.816.444-.021.018",
    transform: "translate(103.888 -14.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-197",
    d: "M-100.033,30.673l-1.816-.444.021-.018,1.816.445-.021.016",
    transform: "translate(103.893 -14.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-198",
    d: "M-100.016,30.66l-1.816-.445.021-.016,1.818.444-.023.018",
    transform: "translate(103.897 -14.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    className: "cls-199",
    d: "M-100,30.647l-1.818-.444.023-.019,1.816.445-.021.018",
    transform: "translate(103.901 -14.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    className: "cls-199",
    d: "M-99.981,30.633l-1.816-.445.021-.018,1.816.445-.021.018",
    transform: "translate(103.906 -14.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    className: "cls-199",
    d: "M-99.964,30.619l-1.816-.445.021-.018,1.818.444-.023.019",
    transform: "translate(103.91 -14.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    className: "cls-200",
    d: "M-99.946,30.6l-1.818-.444.021-.019,1.818.445-.021.018",
    transform: "translate(103.915 -14.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    className: "cls-200",
    d: "M-99.929,30.59l-1.818-.445.021-.018,1.818.444-.021.019",
    transform: "translate(103.919 -14.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    className: "cls-201",
    d: "M-99.911,30.578l-1.818-.444.039-.034,1.816.444-.038.034",
    transform: "translate(103.923 -14.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    className: "cls-200",
    d: "M-99.882,30.554l-1.816-.444.056-.051,1.818.444-.058.051",
    transform: "translate(103.931 -14.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    className: "cls-200",
    d: "M-99.836,30.513l-1.818-.444.056-.053,1.818.444-.056.053",
    transform: "translate(103.942 -14.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    className: "cls-199",
    d: "M-99.791,30.472l-1.818-.444.056-.054,1.816.444-.055.054",
    transform: "translate(103.954 -14.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    className: "cls-199",
    d: "M-99.747,30.429l-1.816-.444.055-.056,1.816.445-.055.055",
    transform: "translate(103.965 -14.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    className: "cls-199",
    d: "M-99.7,30.385l-1.816-.445.054-.056,1.818.444-.055.058",
    transform: "translate(103.976 -14.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    className: "cls-198",
    d: "M-99.658,30.338l-1.818-.444.046-.05,1.818.445-.046.049",
    transform: "translate(103.987 -14.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    className: "cls-197",
    d: "M-99.622,30.293l-1.818-.445.019-.02,1.818.444-.019.021",
    transform: "translate(103.997 -14.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    className: "cls-196",
    d: "M-99.607,30.276l-1.818-.444.019-.02,1.818.444-.019.02",
    transform: "translate(104 -14.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    className: "cls-195",
    d: "M-99.591,30.26l-1.818-.444.019-.021,1.818.445-.019.02",
    transform: "translate(104.004 -14.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    className: "cls-194",
    d: "M-99.576,30.244l-1.818-.445.019-.021,1.818.445-.019.021",
    transform: "translate(104.008 -14.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    className: "cls-193",
    d: "M-99.561,30.227l-1.818-.445.019-.02,1.816.444-.018.021",
    transform: "translate(104.012 -14.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    className: "cls-192",
    d: "M-99.548,30.21l-1.816-.444.019-.021,1.816.444-.019.021",
    transform: "translate(104.016 -15.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    className: "cls-192",
    d: "M-99.533,30.193l-1.816-.444.018-.021,1.818.444-.019.021",
    transform: "translate(104.019 -15.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    className: "cls-192",
    d: "M-99.517,30.176l-1.818-.444.019-.021,1.818.444-.019.021",
    transform: "translate(104.023 -15.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    className: "cls-191",
    d: "M-99.5,30.159l-1.818-.444.019-.023,1.816.445-.018.021",
    transform: "translate(104.027 -15.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    className: "cls-191",
    d: "M-99.489,30.142l-1.816-.445.018-.021,1.818.444-.019.023",
    transform: "translate(104.031 -15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    className: "cls-190",
    d: "M-99.473,30.124l-1.818-.444.019-.023,1.816.445-.018.021",
    transform: "translate(104.034 -15.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    className: "cls-190",
    d: "M-99.46,30.107l-1.816-.445.018-.021,1.818.444-.019.023",
    transform: "translate(104.038 -15.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    className: "cls-189",
    d: "M-99.444,30.089l-1.818-.444.019-.023,1.816.444-.018.023",
    transform: "translate(104.041 -15.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    className: "cls-188",
    d: "M-99.431,30.071l-1.816-.444.018-.023,1.818.444-.019.023",
    transform: "translate(104.045 -15.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    className: "cls-187",
    d: "M-99.415,30.053l-1.818-.444.019-.023,1.816.444-.018.023",
    transform: "translate(104.049 -15.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    className: "cls-186",
    d: "M-99.4,30.035l-1.816-.444.018-.023,1.816.444-.018.023",
    transform: "translate(104.053 -15.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    className: "cls-185",
    d: "M-99.388,30.017l-1.816-.444.018-.023,1.818.444-.019.023",
    transform: "translate(104.056 -15.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    className: "cls-185",
    d: "M-99.373,30l-1.818-.444.018-.023,1.816.444-.016.023",
    transform: "translate(104.06 -15.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    className: "cls-184",
    d: "M-99.36,29.98l-1.816-.444.011-.015,1.818.444-.013.015",
    transform: "translate(104.063 -15.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    className: "cls-183",
    d: "M-99.35,29.968l-1.818-.444.011-.015,1.818.444-.011.015",
    transform: "translate(104.066 -15.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    className: "cls-182",
    d: "M-99.341,29.956l-1.818-.444.013-.015,1.816.444-.011.015",
    transform: "translate(104.068 -15.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    className: "cls-181",
    d: "M-99.332,29.944l-1.816-.444.011-.016,1.816.445-.011.015",
    transform: "translate(104.07 -15.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    className: "cls-180",
    d: "M-99.323,29.932l-1.816-.445.011-.015,1.818.444-.013.016",
    transform: "translate(104.073 -15.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    className: "cls-179",
    d: "M-99.312,29.919l-1.818-.444.011-.015,1.818.444-.011.015",
    transform: "translate(104.075 -15.075)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    className: "cls-178",
    d: "M-99.3,29.907l-1.818-.444.013-.016,1.816.445-.011.015",
    transform: "translate(104.077 -15.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    className: "cls-178",
    d: "M-99.295,29.9l-1.816-.445.011-.015,1.816.444-.011.016",
    transform: "translate(104.08 -15.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    className: "cls-177",
    d: "M-99.286,29.882l-1.816-.444.011-.016,1.818.445-.013.015",
    transform: "translate(104.082 -15.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    className: "cls-176",
    d: "M-99.275,29.87l-1.818-.445.011-.015,1.818.444-.011.016",
    transform: "translate(104.084 -15.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    className: "cls-175",
    d: "M-99.266,29.857l-1.818-.444.011-.016,1.818.444-.011.016",
    transform: "translate(104.087 -15.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    className: "cls-174",
    d: "M-99.257,29.844l-1.818-.444.011-.016,1.818.445-.011.015",
    transform: "translate(104.089 -15.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    className: "cls-173",
    d: "M-99.248,29.832l-1.818-.445.013-.015,1.816.444-.011.016",
    transform: "translate(104.091 -15.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    className: "cls-172",
    d: "M-99.24,29.819l-1.816-.444.011-.016,1.816.444-.011.016",
    transform: "translate(104.094 -15.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    className: "cls-171",
    d: "M-99.231,29.806l-1.816-.444.011-.016,1.816.444-.011.016",
    transform: "translate(104.096 -15.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-170",
    d: "M-99.222,29.793l-1.816-.444.011-.016,1.816.444-.011.016",
    transform: "translate(104.098 -15.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    className: "cls-169",
    d: "M-99.213,29.78l-1.816-.444.011-.016,1.816.445-.011.015",
    transform: "translate(104.101 -15.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    className: "cls-168",
    d: "M-99.2,29.768l-1.816-.445.011-.016,1.816.445-.011.016",
    transform: "translate(104.103 -15.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    className: "cls-167",
    d: "M-99.195,29.755l-1.816-.445.011-.016,1.816.445-.011.016",
    transform: "translate(104.105 -15.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    className: "cls-166",
    d: "M-99.186,29.742-101,29.3l.011-.016,1.816.445-.011.016",
    transform: "translate(104.107 -15.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    className: "cls-165",
    d: "M-99.177,29.729l-1.816-.445.011-.016,1.816.444-.011.018",
    transform: "translate(104.11 -15.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    className: "cls-164",
    d: "M-99.168,29.715l-1.816-.444.011-.016,1.816.444-.011.016",
    transform: "translate(104.112 -15.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    className: "cls-163",
    d: "M-99.159,29.7l-1.816-.444.011-.016,1.816.444-.011.016",
    transform: "translate(104.114 -15.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    className: "cls-162",
    d: "M-99.15,29.689l-1.816-.444.01-.016,1.818.444-.011.016",
    transform: "translate(104.117 -15.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    className: "cls-161",
    d: "M-99.141,29.676l-1.818-.444.011-.018,1.818.445-.011.016",
    transform: "translate(104.119 -15.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    className: "cls-12",
    d: "M-99.132,29.663l-1.818-.445.011-.016,1.818.444-.011.018",
    transform: "translate(104.121 -15.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    className: "cls-13",
    d: "M-99.122,29.649l-1.818-.444.011-.016,1.816.444-.01.016",
    transform: "translate(104.123 -15.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    className: "cls-13",
    d: "M-99.115,29.636l-1.816-.444.01-.016,1.816.445-.01.015",
    transform: "translate(104.125 -15.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    className: "cls-14",
    d: "M-99.106,29.623l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(104.127 -15.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    className: "cls-15",
    d: "M-99.1,29.612l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(104.129 -15.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    className: "cls-15",
    d: "M-99.091,29.6l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(104.131 -15.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    className: "cls-16",
    d: "M-99.084,29.589l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(104.133 -15.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    className: "cls-16",
    d: "M-99.076,29.577l-1.817-.444.009-.015,1.817.444-.009.015",
    transform: "translate(104.135 -15.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    className: "cls-17",
    d: "M-99.069,29.566l-1.817-.444.009-.015,1.817.444-.009.015",
    transform: "translate(104.137 -15.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    className: "cls-17",
    d: "M-99.061,29.554l-1.817-.444.009-.015,1.817.444-.009.015",
    transform: "translate(104.139 -15.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    className: "cls-18",
    d: "M-99.054,29.543l-1.817-.444.009-.015,1.817.444-.009.015",
    transform: "translate(104.141 -15.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    className: "cls-18",
    d: "M-99.046,29.531l-1.818-.444.01-.015,1.816.445-.009.014",
    transform: "translate(104.142 -15.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    className: "cls-19",
    d: "M-99.04,29.52l-1.816-.445.009-.015,1.818.445-.01.015",
    transform: "translate(104.144 -15.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    className: "cls-19",
    d: "M-99.031,29.508l-1.818-.445.01-.014,1.816.444-.009.015",
    transform: "translate(104.146 -15.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    className: "cls-20",
    d: "M-99.025,29.5l-1.816-.444.009-.015,1.816.444-.009.015",
    transform: "translate(104.148 -15.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    className: "cls-20",
    d: "M-99.018,29.484l-1.816-.444.009-.015,1.818.444-.01.015",
    transform: "translate(104.15 -15.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    className: "cls-21",
    d: "M-99.009,29.472l-1.818-.444.01-.015,1.816.444-.009.015",
    transform: "translate(104.152 -15.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    className: "cls-22",
    d: "M-99,29.46l-1.816-.444.009-.015,1.816.445L-99,29.46",
    transform: "translate(104.154 -15.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    className: "cls-23",
    d: "M-99,29.449-100.812,29l.009-.015,1.818.445-.01.015",
    transform: "translate(104.156 -15.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    className: "cls-23",
    d: "M-98.988,29.437l-1.818-.445.009-.015,1.818.445-.009.015",
    transform: "translate(104.157 -15.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    className: "cls-23",
    d: "M-98.98,29.425l-1.818-.445.01-.015,1.816.445-.009.015",
    transform: "translate(104.159 -15.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    className: "cls-24",
    d: "M-98.974,29.413l-1.816-.445.009-.015,1.816.445-.009.015",
    transform: "translate(104.161 -15.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    className: "cls-25",
    d: "M-98.967,29.4l-1.816-.445.009-.015,1.818.445-.01.015",
    transform: "translate(104.163 -15.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    className: "cls-25",
    d: "M-98.958,29.389l-1.818-.445.009-.015,1.818.445-.009.015",
    transform: "translate(104.165 -15.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    className: "cls-25",
    d: "M-98.952,29.377l-1.818-.445.009-.015,1.818.444-.009.016",
    transform: "translate(104.166 -15.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    className: "cls-26",
    d: "M-98.945,29.364l-1.818-.444.01-.015,1.816.444-.009.015",
    transform: "translate(104.168 -15.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    className: "cls-27",
    d: "M-98.938,29.352l-1.816-.444.009-.015,1.816.444-.009.015",
    transform: "translate(104.17 -15.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    className: "cls-27",
    d: "M-98.931,29.34l-1.816-.444.009-.015,1.816.444-.009.015",
    transform: "translate(104.172 -15.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    className: "cls-27",
    d: "M-98.924,29.328l-1.816-.444.009-.016,1.818.445-.01.015",
    transform: "translate(104.174 -15.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    className: "cls-28",
    d: "M-98.915,29.316l-1.818-.445.009-.015,1.818.444-.009.016",
    transform: "translate(104.176 -15.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    className: "cls-28",
    d: "M-98.909,29.3l-1.818-.444.009-.015,1.818.444-.009.015",
    transform: "translate(104.177 -15.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    className: "cls-29",
    d: "M-98.9,29.291l-1.818-.444.009-.016,1.818.445-.009.015",
    transform: "translate(104.179 -15.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    className: "cls-30",
    d: "M-98.895,29.279l-1.818-.445.009-.015,1.818.444-.009.016",
    transform: "translate(104.181 -15.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    className: "cls-30",
    d: "M-98.887,29.266l-1.818-.444.01-.015,1.816.444-.009.015",
    transform: "translate(104.183 -15.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    className: "cls-30",
    d: "M-98.881,29.254l-1.816-.444.009-.016,1.816.445-.009.015",
    transform: "translate(104.185 -15.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    className: "cls-31",
    d: "M-98.874,29.242l-1.816-.445.008-.015,1.818.444-.009.016",
    transform: "translate(104.187 -15.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    className: "cls-32",
    d: "M-98.867,29.229l-1.818-.444.009-.015,1.818.444-.009.015",
    transform: "translate(104.188 -15.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    className: "cls-32",
    d: "M-98.859,29.217l-1.818-.444.009-.016,1.818.445-.009.015",
    transform: "translate(104.19 -15.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    className: "cls-32",
    d: "M-98.853,29.205l-1.818-.445.009-.015,1.818.444-.009.016",
    transform: "translate(104.192 -15.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    className: "cls-32",
    d: "M-98.845,29.192l-1.818-.444.009-.015,1.818.444-.009.015",
    transform: "translate(104.193 -15.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    className: "cls-33",
    d: "M-98.839,29.18l-1.818-.444.009-.016,1.818.445-.009.015",
    transform: "translate(104.195 -15.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    className: "cls-34",
    d: "M-98.831,29.168l-1.818-.445.009-.015,1.816.444-.008.016",
    transform: "translate(104.197 -15.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    className: "cls-34",
    d: "M-98.826,29.155l-1.816-.444.009-.016,1.816.445-.009.015",
    transform: "translate(104.199 -15.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    className: "cls-34",
    d: "M-98.819,29.143l-1.816-.445.009-.015,1.816.444-.009.016",
    transform: "translate(104.2 -15.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    className: "cls-35",
    d: "M-98.812,29.13l-1.816-.444.008-.016,1.818.445-.009.015",
    transform: "translate(104.202 -15.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    className: "cls-36",
    d: "M-98.8,29.118l-1.818-.445.009-.015,1.818.444-.009.016",
    transform: "translate(104.204 -15.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    className: "cls-36",
    d: "M-98.8,29.105l-1.818-.444.009-.016,1.816.444-.008.016",
    transform: "translate(104.205 -15.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    className: "cls-160",
    d: "M-98.792,29.092l-1.816-.444.009-.016,1.816.445-.009.015",
    transform: "translate(104.207 -15.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    className: "cls-160",
    d: "M-98.785,29.08l-1.816-.445.009-.015,1.816.444-.009.016",
    transform: "translate(104.209 -15.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    className: "cls-160",
    d: "M-98.778,29.067l-1.816-.444.008-.016,1.818.444-.009.016",
    transform: "translate(104.211 -15.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    className: "cls-159",
    d: "M-98.771,29.054l-1.818-.444.009-.016,1.816.445-.008.015",
    transform: "translate(104.212 -15.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    className: "cls-158",
    d: "M-98.765,29.042l-1.816-.445.009-.015,1.816.444-.009.016",
    transform: "translate(104.214 -15.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    className: "cls-158",
    d: "M-98.758,29.029l-1.816-.444.008-.016,1.818.444-.009.016",
    transform: "translate(104.216 -15.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    className: "cls-158",
    d: "M-98.751,29.016l-1.818-.444.009-.016,1.818.445-.009.015",
    transform: "translate(104.217 -15.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    className: "cls-157",
    d: "M-98.743,29l-1.818-.445.009-.016,1.816.445-.008.016",
    transform: "translate(104.219 -15.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    className: "cls-156",
    d: "M-98.738,28.991l-1.816-.445.008-.016,1.818.445-.009.016",
    transform: "translate(104.221 -15.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    className: "cls-156",
    d: "M-98.731,28.978l-1.818-.445.009-.015,1.818.444-.009.016",
    transform: "translate(104.223 -15.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    className: "cls-156",
    d: "M-98.723,28.965l-1.818-.444.009-.016,1.816.444-.008.016",
    transform: "translate(104.224 -15.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    className: "cls-156",
    d: "M-98.718,28.952l-1.816-.444.007-.016,1.818.444-.009.016",
    transform: "translate(104.226 -15.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    className: "cls-155",
    d: "M-98.711,28.939l-1.818-.444.009-.016,1.816.444-.008.016",
    transform: "translate(104.228 -15.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    className: "cls-154",
    d: "M-98.7,28.926l-1.816-.444.009-.016,1.816.444-.009.016",
    transform: "translate(104.229 -15.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    className: "cls-154",
    d: "M-98.7,28.913l-1.816-.444.008-.016,1.818.444-.009.016",
    transform: "translate(104.231 -15.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    className: "cls-153",
    d: "M-98.69,28.9l-1.818-.444.009-.016,1.816.444-.008.016",
    transform: "translate(104.233 -15.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    className: "cls-152",
    d: "M-98.685,28.887l-1.816-.444.008-.016,1.818.444-.009.016",
    transform: "translate(104.234 -15.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    className: "cls-152",
    d: "M-98.678,28.874l-1.818-.444.009-.016,1.816.444-.008.016",
    transform: "translate(104.236 -15.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    className: "cls-152",
    d: "M-98.672,28.861l-1.816-.444.008-.016,1.818.444-.009.016",
    transform: "translate(104.238 -15.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    className: "cls-151",
    d: "M-98.664,28.848l-1.818-.444.009-.016,1.816.444-.007.016",
    transform: "translate(104.239 -15.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    className: "cls-151",
    d: "M-98.659,28.835l-1.816-.444.009-.018,1.816.444-.009.018",
    transform: "translate(104.241 -15.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    className: "cls-150",
    d: "M-98.652,28.821l-1.816-.444.008-.018,1.818.444-.009.018",
    transform: "translate(104.243 -15.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    className: "cls-150",
    d: "M-98.644,28.807l-1.818-.444.009-.018,1.818.444-.009.018",
    transform: "translate(104.244 -15.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    className: "cls-149",
    d: "M-98.638,28.793l-1.818-.444.009-.018,1.818.444-.009.018",
    transform: "translate(104.246 -15.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    className: "cls-149",
    d: "M-98.63,28.78l-1.818-.444.009-.019,1.818.445-.009.018",
    transform: "translate(104.248 -15.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    className: "cls-148",
    d: "M-98.623,28.766l-1.818-.445.009-.018,1.818.445-.009.018",
    transform: "translate(104.25 -15.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    className: "cls-147",
    d: "M-98.617,28.752l-1.818-.445.009-.018,1.816.444-.008.019",
    transform: "translate(104.251 -15.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    className: "cls-146",
    d: "M-98.611,28.736l-1.816-.444.009-.018,1.816.444-.009.018",
    transform: "translate(104.253 -15.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    className: "cls-146",
    d: "M-98.6,28.723l-1.816-.444.009-.019,1.816.445-.009.018",
    transform: "translate(104.255 -15.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    className: "cls-146",
    d: "M-98.6,28.709l-1.816-.445.008-.018,1.818.444-.009.019",
    transform: "translate(104.257 -15.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    className: "cls-145",
    d: "M-98.59,28.693l-1.818-.444.009-.018,1.818.444-.009.018",
    transform: "translate(104.258 -15.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    className: "cls-144",
    d: "M-98.582,28.68l-1.818-.444.009-.019,1.816.445-.008.018",
    transform: "translate(104.26 -15.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    className: "cls-144",
    d: "M-98.577,28.666l-1.816-.445.009-.018,1.816.444-.009.019",
    transform: "translate(104.262 -15.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    className: "cls-144",
    d: "M-98.57,28.651l-1.816-.444.008-.019,1.818.445-.009.018",
    transform: "translate(104.264 -15.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    className: "cls-143",
    d: "M-98.562,28.637l-1.818-.445.009-.018,1.818.444-.009.019",
    transform: "translate(104.265 -15.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    className: "cls-142",
    d: "M-98.556,28.622l-1.818-.444.009-.019,1.816.445-.008.018",
    transform: "translate(104.267 -15.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    className: "cls-142",
    d: "M-98.55,28.608l-1.816-.445.009-.018,1.816.444-.009.019",
    transform: "translate(104.269 -15.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    className: "cls-142",
    d: "M-98.543,28.593l-1.816-.444.008-.019,1.818.445-.009.018",
    transform: "translate(104.271 -15.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    className: "cls-141",
    d: "M-98.535,28.579l-1.818-.445.009-.018,1.816.444-.008.019",
    transform: "translate(104.272 -15.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    className: "cls-141",
    d: "M-98.53,28.564l-1.816-.444.009-.019,1.816.445-.009.018",
    transform: "translate(104.274 -15.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    className: "cls-140",
    d: "M-98.523,28.55l-1.816-.445.008-.018,1.818.444-.009.019",
    transform: "translate(104.276 -15.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    className: "cls-139",
    d: "M-98.515,28.535l-1.818-.444.009-.019,1.816.444-.008.019",
    transform: "translate(104.277 -15.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    className: "cls-139",
    d: "M-98.51,28.52l-1.816-.444.008-.019,1.818.445-.009.018",
    transform: "translate(104.279 -15.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    className: "cls-139",
    d: "M-98.5,28.506l-1.818-.445.009-.018,1.816.444-.008.019",
    transform: "translate(104.28 -15.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    className: "cls-138",
    d: "M-98.5,28.491l-1.816-.444.008-.019,1.818.444-.009.019",
    transform: "translate(104.282 -15.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    className: "cls-137",
    d: "M-98.489,28.476l-1.818-.444.009-.019,1.816.445-.008.018",
    transform: "translate(104.284 -15.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    className: "cls-137",
    d: "M-98.484,28.462l-1.816-.445.008-.019,1.818.445-.009.019",
    transform: "translate(104.285 -15.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    className: "cls-137",
    d: "M-98.477,28.447-100.294,28l.009-.018,1.816.444-.008.019",
    transform: "translate(104.287 -15.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    className: "cls-137",
    d: "M-98.471,28.432l-1.816-.444.008-.019,1.818.444-.009.019",
    transform: "translate(104.289 -15.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    className: "cls-136",
    d: "M-98.463,28.417l-1.818-.444.009-.019,1.816.444-.008.019",
    transform: "translate(104.29 -15.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    className: "cls-135",
    d: "M-98.458,28.4l-1.816-.444.008-.019,1.818.444-.009.019",
    transform: "translate(104.292 -15.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    className: "cls-135",
    d: "M-98.451,28.387l-1.818-.444.01-.021,1.816.445-.009.02",
    transform: "translate(104.294 -15.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    className: "cls-135",
    d: "M-98.444,28.371l-1.816-.445.009-.02,1.816.444-.009.021",
    transform: "translate(104.295 -15.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    className: "cls-134",
    d: "M-98.437,28.354l-1.816-.444.009-.021,1.816.444-.009.021",
    transform: "translate(104.297 -15.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    className: "cls-133",
    d: "M-98.43,28.337l-1.816-.444.009-.021,1.818.445-.01.02",
    transform: "translate(104.299 -15.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    className: "cls-133",
    d: "M-98.421,28.321l-1.818-.445.009-.021,1.818.445-.009.021",
    transform: "translate(104.301 -15.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    className: "cls-132",
    d: "M-98.415,28.3l-1.818-.445.009-.02,1.818.444-.009.021",
    transform: "translate(104.303 -15.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    className: "cls-132",
    d: "M-98.407,28.287l-1.818-.444.009-.021,1.818.444-.009.021",
    transform: "translate(104.304 -15.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    className: "cls-131",
    d: "M-98.4,28.27l-1.818-.444.009-.021,1.818.444-.009.021",
    transform: "translate(104.306 -15.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    className: "cls-131",
    d: "M-98.394,28.253l-1.818-.444.009-.021,1.818.445-.009.02",
    transform: "translate(104.308 -15.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    className: "cls-130",
    d: "M-98.387,28.237l-1.818-.445.009-.021,1.818.445-.009.021",
    transform: "translate(104.31 -15.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    className: "cls-130",
    d: "M-98.379,28.22l-1.818-.445.009-.021,1.818.445-.009.021",
    transform: "translate(104.311 -15.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    className: "cls-129",
    d: "M-98.372,28.2l-1.818-.445.009-.021,1.818.445-.009.021",
    transform: "translate(104.313 -15.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    className: "cls-128",
    d: "M-98.365,28.186l-1.818-.445.009-.02,1.818.444-.009.021",
    transform: "translate(104.315 -15.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    className: "cls-127",
    d: "M-98.358,28.169l-1.818-.444.009-.021,1.818.444-.009.021",
    transform: "translate(104.317 -15.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    className: "cls-127",
    d: "M-98.352,28.152l-1.818-.444.009-.021,1.816.444-.008.021",
    transform: "translate(104.319 -15.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    className: "cls-127",
    d: "M-98.346,28.135l-1.816-.444.009-.023,1.816.445-.009.021",
    transform: "translate(104.32 -15.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    className: "cls-126",
    d: "M-98.339,28.118l-1.816-.445.009-.021,1.816.445-.009.021",
    transform: "translate(104.322 -15.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    className: "cls-125",
    d: "M-98.332,28.1l-1.816-.445.008-.021,1.818.445-.009.021",
    transform: "translate(104.324 -15.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    className: "cls-124",
    d: "M-98.324,28.084l-1.818-.445.009-.021,1.818.445-.009.021",
    transform: "translate(104.325 -15.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    className: "cls-124",
    d: "M-98.317,28.067l-1.818-.445.009-.021,1.816.444-.007.023",
    transform: "translate(104.327 -15.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    className: "cls-123",
    d: "M-98.312,28.049l-1.816-.444.009-.021,1.816.444-.009.021",
    transform: "translate(104.329 -15.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    className: "cls-122",
    d: "M-98.3,28.032l-1.816-.444.008-.021,1.818.444-.009.021",
    transform: "translate(104.331 -15.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    className: "cls-122",
    d: "M-98.3,28.015l-1.818-.444.009-.023,1.818.445-.009.021",
    transform: "translate(104.332 -15.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    className: "cls-122",
    d: "M-98.29,28l-1.818-.445.009-.021,1.816.445L-98.29,28",
    transform: "translate(104.334 -15.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    className: "cls-121",
    d: "M-98.285,27.981l-1.816-.445.008-.021,1.818.444-.009.023",
    transform: "translate(104.336 -15.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    className: "cls-121",
    d: "M-98.277,27.963l-1.818-.444.009-.021,1.818.444-.009.021",
    transform: "translate(104.337 -15.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    className: "cls-120",
    d: "M-98.27,27.946l-1.818-.444.009-.023,1.816.445-.008.021",
    transform: "translate(104.339 -15.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    className: "cls-120",
    d: "M-98.265,27.93l-1.816-.445.009-.024,1.818.444-.01.025",
    transform: "translate(104.341 -15.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    className: "cls-119",
    d: "M-98.256,27.91l-1.818-.444.01-.025,1.816.445-.009.024",
    transform: "translate(104.343 -15.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    className: "cls-119",
    d: "M-98.25,27.891l-1.816-.445.009-.025,1.816.445-.009.025",
    transform: "translate(104.345 -15.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    className: "cls-118",
    d: "M-98.243,27.871l-1.816-.445.009-.024,1.818.444-.01.025",
    transform: "translate(104.346 -15.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    className: "cls-117",
    d: "M-98.234,27.851l-1.818-.444.01-.025,1.816.444-.009.025",
    transform: "translate(104.348 -15.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    className: "cls-117",
    d: "M-98.228,27.831l-1.816-.444.009-.025,1.818.444-.01.025",
    transform: "translate(104.35 -15.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    className: "cls-117",
    d: "M-98.22,27.811l-1.818-.444.009-.025,1.818.444-.009.025",
    transform: "translate(104.352 -15.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    className: "cls-117",
    d: "M-98.212,27.791l-1.818-.444.01-.025,1.816.444-.009.025",
    transform: "translate(104.354 -15.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    className: "cls-116",
    d: "M-98.206,27.771l-1.816-.444.009-.025,1.816.444-.009.025",
    transform: "translate(104.356 -15.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    className: "cls-115",
    d: "M-98.2,27.751l-1.816-.444.009-.025,1.818.444-.01.025",
    transform: "translate(104.358 -15.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    className: "cls-115",
    d: "M-98.191,27.731l-1.818-.444.009-.025,1.818.444-.009.025",
    transform: "translate(104.359 -15.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    className: "cls-115",
    d: "M-98.183,27.711-100,27.267l.01-.025,1.816.444-.009.025",
    transform: "translate(104.361 -15.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    className: "cls-114",
    d: "M-98.177,27.691l-1.816-.444.009-.025,1.816.444-.009.025",
    transform: "translate(104.363 -15.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    className: "cls-113",
    d: "M-98.17,27.671l-1.816-.444.009-.025,1.816.444-.009.025",
    transform: "translate(104.365 -15.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    className: "cls-113",
    d: "M-98.163,27.651l-1.816-.444.009-.025,1.816.444-.009.025",
    transform: "translate(104.367 -15.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    className: "cls-112",
    d: "M-98.156,27.631l-1.816-.444.009-.026,1.818.445-.01.025",
    transform: "translate(104.368 -15.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    className: "cls-111",
    d: "M-98.148,27.611l-1.818-.445.009-.025,1.818.445-.009.025",
    transform: "translate(104.37 -15.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    className: "cls-110",
    d: "M-98.141,27.591l-1.818-.445.009-.025,1.818.444-.009.026",
    transform: "translate(104.372 -15.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    className: "cls-110",
    d: "M-98.133,27.57l-1.818-.444.009-.025,1.818.444-.009.025",
    transform: "translate(104.374 -15.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    className: "cls-109",
    d: "M-98.126,27.55l-1.818-.444.009-.026,1.816.445-.008.025",
    transform: "translate(104.376 -15.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    className: "cls-109",
    d: "M-98.121,27.53l-1.816-.445.009-.025,1.816.445-.009.025",
    transform: "translate(104.377 -15.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    className: "cls-109",
    d: "M-98.114,27.51l-1.816-.445.009-.025,1.816.444-.009.026",
    transform: "translate(104.379 -15.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    className: "cls-108",
    d: "M-98.107,27.489l-1.816-.444.009-.025,1.816.444-.009.025",
    transform: "translate(104.381 -15.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    className: "cls-107",
    d: "M-98.1,27.469l-1.816-.444.008-.026,1.818.445-.009.025",
    transform: "translate(104.383 -15.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    className: "cls-107",
    d: "M-98.092,27.45-99.91,27l.01-.029,1.818.445-.01.029",
    transform: "translate(104.384 -15.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    className: "cls-107",
    d: "M-98.084,27.427l-1.818-.445.01-.029,1.816.444-.009.03",
    transform: "translate(104.386 -15.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    className: "cls-107",
    d: "M-98.078,27.4l-1.816-.444.01-.029,1.816.444-.01.029",
    transform: "translate(104.388 -15.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    className: "cls-106",
    d: "M-98.07,27.38l-1.816-.444.009-.03,1.818.444-.01.03",
    transform: "translate(104.39 -15.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    className: "cls-105",
    d: "M-98.061,27.356l-1.818-.444.01-.029,1.816.444-.009.029",
    transform: "translate(104.392 -15.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    className: "cls-105",
    d: "M-98.055,27.333l-1.816-.444.009-.03,1.818.445-.01.029",
    transform: "translate(104.394 -15.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    className: "cls-105",
    d: "M-98.046,27.31l-1.818-.445.01-.029,1.816.444-.009.03",
    transform: "translate(104.396 -15.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    className: "cls-104",
    d: "M-98.04,27.286l-1.816-.444.009-.03,1.818.444-.01.03",
    transform: "translate(104.398 -15.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    className: "cls-104",
    d: "M-98.031,27.262l-1.818-.444.01-.03,1.816.445-.009.029",
    transform: "translate(104.4 -15.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    className: "cls-104",
    d: "M-98.025,27.239l-1.816-.445.009-.029,1.818.444-.01.03",
    transform: "translate(104.402 -15.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    className: "cls-103",
    d: "M-98.016,27.215l-1.818-.444.01-.03,1.816.445-.009.029",
    transform: "translate(104.403 -15.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    className: "cls-103",
    d: "M-98.01,27.192l-1.816-.445.009-.03,1.818.445-.01.03",
    transform: "translate(104.406 -15.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    className: "cls-102",
    d: "M-98,27.168l-1.818-.445.009-.029,1.818.444-.009.03",
    transform: "translate(104.407 -15.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    className: "cls-102",
    d: "M-97.994,27.144l-1.818-.444.01-.03,1.816.444-.009.03",
    transform: "translate(104.409 -15.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    className: "cls-101",
    d: "M-97.988,27.12l-1.816-.444.009-.03,1.818.445-.01.029",
    transform: "translate(104.411 -15.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    className: "cls-101",
    d: "M-97.979,27.1l-1.818-.445.009-.029,1.818.444-.009.03",
    transform: "translate(104.413 -15.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    className: "cls-100",
    d: "M-97.973,27.073l-1.818-.444.009-.03,1.818.444-.009.03",
    transform: "translate(104.415 -15.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    className: "cls-99",
    d: "M-97.965,27.049l-1.818-.444.01-.03,1.816.444-.009.03",
    transform: "translate(104.416 -15.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    className: "cls-98",
    d: "M-97.959,27.025l-1.816-.444.009-.03,1.816.444-.009.03",
    transform: "translate(104.418 -15.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    className: "cls-98",
    d: "M-97.952,27l-1.816-.444.009-.03,1.816.445-.009.029",
    transform: "translate(104.42 -15.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    className: "cls-98",
    d: "M-97.945,26.978l-1.816-.445.009-.03,1.816.445-.009.03",
    transform: "translate(104.422 -15.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    className: "cls-97",
    d: "M-97.938,26.955l-1.816-.445.009-.034,1.818.445-.01.034",
    transform: "translate(104.424 -15.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    className: "cls-96",
    d: "M-97.929,26.928l-1.818-.445.01-.034,1.818.444-.01.035",
    transform: "translate(104.425 -15.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    className: "cls-96",
    d: "M-97.921,26.9l-1.818-.444.01-.034,1.818.444-.01.034",
    transform: "translate(104.428 -15.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    className: "cls-96",
    d: "M-97.914,26.873l-1.818-.444.01-.035,1.818.445-.01.034",
    transform: "translate(104.43 -15.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    className: "cls-95",
    d: "M-97.905,26.846l-1.818-.445.01-.034,1.816.444-.009.035",
    transform: "translate(104.432 -15.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    className: "cls-94",
    d: "M-97.9,26.818l-1.816-.444.01-.035,1.816.445-.01.034",
    transform: "translate(104.434 -15.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    className: "cls-94",
    d: "M-97.891,26.791l-1.816-.445.009-.034,1.818.444-.01.035",
    transform: "translate(104.436 -15.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    className: "cls-94",
    d: "M-97.883,26.763l-1.818-.444.01-.035,1.816.444-.009.035",
    transform: "translate(104.437 -15.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    className: "cls-93",
    d: "M-97.876,26.735l-1.816-.444.009-.034,1.818.444-.01.034",
    transform: "translate(104.439 -15.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    className: "cls-92",
    d: "M-97.868,26.708l-1.818-.444.01-.035,1.816.444-.009.035",
    transform: "translate(104.441 -15.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    className: "cls-92",
    d: "M-97.861,26.68l-1.816-.444.009-.035,1.818.445-.01.034",
    transform: "translate(104.443 -15.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    className: "cls-92",
    d: "M-97.852,26.653l-1.818-.445.01-.034,1.816.444-.009.035",
    transform: "translate(104.445 -15.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    className: "cls-91",
    d: "M-97.846,26.625l-1.816-.444.009-.035,1.818.444-.01.035",
    transform: "translate(104.447 -15.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    className: "cls-91",
    d: "M-97.837,26.6l-1.818-.444.009-.035,1.818.445-.009.034",
    transform: "translate(104.449 -15.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    className: "cls-90",
    d: "M-97.83,26.57l-1.818-.445.01-.034,1.816.444-.009.035",
    transform: "translate(104.451 -15.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    className: "cls-89",
    d: "M-97.824,26.542-99.64,26.1l.009-.035,1.816.444-.009.035",
    transform: "translate(104.453 -15.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    className: "cls-89",
    d: "M-97.817,26.514l-1.816-.444.009-.035,1.818.444-.01.035",
    transform: "translate(104.454 -15.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    className: "cls-89",
    d: "M-97.808,26.486l-1.818-.444.009-.035,1.818.445-.009.034",
    transform: "translate(104.456 -15.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    className: "cls-89",
    d: "M-97.8,26.46l-1.818-.445.01-.038,1.816.445-.009.038",
    transform: "translate(104.458 -15.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    className: "cls-88",
    d: "M-97.795,26.43l-1.816-.445.01-.039,1.816.444-.01.04",
    transform: "translate(104.46 -15.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    className: "cls-87",
    d: "M-97.787,26.4l-1.816-.444.009-.04,1.818.445-.01.039",
    transform: "translate(104.462 -15.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    className: "cls-87",
    d: "M-97.779,26.367l-1.818-.445.01-.039,1.818.444-.01.04",
    transform: "translate(104.464 -15.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    className: "cls-87",
    d: "M-97.77,26.335l-1.818-.444.01-.04,1.816.444-.009.04",
    transform: "translate(104.466 -15.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    className: "cls-86",
    d: "M-97.764,26.3l-1.816-.444.01-.04,1.816.445-.01.039",
    transform: "translate(104.468 -15.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    className: "cls-86",
    d: "M-97.756,26.272l-1.816-.445.009-.04,1.818.445-.01.04",
    transform: "translate(104.47 -16.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    className: "cls-86",
    d: "M-97.748,26.24l-1.818-.445.01-.039,1.816.444-.009.04",
    transform: "translate(104.472 -16.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    className: "cls-85",
    d: "M-97.741,26.208l-1.816-.444.009-.04,1.818.444-.01.04",
    transform: "translate(104.474 -16.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    className: "cls-84",
    d: "M-97.732,26.176l-1.818-.444.01-.04,1.816.445-.009.039",
    transform: "translate(104.475 -16.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    className: "cls-83",
    d: "M-97.726,26.145l-1.816-.445.009-.04,1.816.445-.009.04",
    transform: "translate(104.478 -16.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    className: "cls-83",
    d: "M-97.719,26.113l-1.816-.445.009-.039,1.818.444-.01.04",
    transform: "translate(104.479 -16.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    className: "cls-82",
    d: "M-97.711,26.081l-1.818-.444.009-.04,1.818.444-.009.04",
    transform: "translate(104.481 -16.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    className: "cls-82",
    d: "M-97.7,26.049l-1.818-.444.009-.04,1.818.444-.009.04",
    transform: "translate(104.483 -16.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    className: "cls-81",
    d: "M-97.7,26.017l-1.818-.444.01-.04,1.816.445-.009.039",
    transform: "translate(104.485 -16.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    className: "cls-80",
    d: "M-97.69,25.986l-1.816-.445.009-.04,1.816.445-.009.04",
    transform: "translate(104.487 -16.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    className: "cls-79",
    d: "M-97.683,25.954l-1.816-.445.009-.041,1.816.444-.009.043",
    transform: "translate(104.488 -16.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    className: "cls-79",
    d: "M-97.676,25.921l-1.816-.444.009-.045,1.818.444-.01.045",
    transform: "translate(104.49 -16.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    className: "cls-79",
    d: "M-97.667,25.885l-1.818-.444.01-.045,1.818.445-.01.044",
    transform: "translate(104.492 -16.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    className: "cls-78",
    d: "M-97.66,25.85l-1.818-.445.01-.045,1.816.445-.009.045",
    transform: "translate(104.494 -16.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    className: "cls-77",
    d: "M-97.653,25.814l-1.816-.445.009-.044,1.816.444-.009.045",
    transform: "translate(104.496 -16.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    className: "cls-76",
    d: "M-97.646,25.778l-1.816-.444.009-.045,1.818.444-.01.045",
    transform: "translate(104.498 -16.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    className: "cls-76",
    d: "M-97.638,25.742l-1.818-.444.01-.045,1.816.444-.009.045",
    transform: "translate(104.5 -16.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    className: "cls-76",
    d: "M-97.631,25.706l-1.816-.444.009-.045,1.816.444-.009.045",
    transform: "translate(104.502 -16.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    className: "cls-75",
    d: "M-97.624,25.67l-1.816-.444.009-.045,1.816.445-.009.044",
    transform: "translate(104.503 -16.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    className: "cls-75",
    d: "M-97.617,25.635l-1.816-.445.009-.045,1.816.445-.009.045",
    transform: "translate(104.505 -16.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    className: "cls-75",
    d: "M-97.61,25.6l-1.816-.445.009-.045,1.816.445-.009.045",
    transform: "translate(104.507 -16.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    className: "cls-74",
    d: "M-97.6,25.563l-1.816-.445.008-.044,1.818.444-.009.045",
    transform: "translate(104.509 -16.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    className: "cls-74",
    d: "M-97.6,25.527l-1.818-.444.009-.045,1.818.444-.009.045",
    transform: "translate(104.51 -16.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    className: "cls-73",
    d: "M-97.588,25.491l-1.818-.444L-99.4,25l1.816.444-.008.045",
    transform: "translate(104.512 -16.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    className: "cls-73",
    d: "M-97.583,25.455l-1.816-.444.008-.045,1.818.444-.009.045",
    transform: "translate(104.514 -16.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    className: "cls-72",
    d: "M-97.575,25.42l-1.818-.444.009-.05,1.818.444-.009.05",
    transform: "translate(104.515 -16.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    className: "cls-72",
    d: "M-97.568,25.38l-1.818-.444.01-.05,1.816.445-.009.049",
    transform: "translate(104.517 -16.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    className: "cls-71",
    d: "M-97.562,25.341l-1.816-.445.008-.05,1.818.445-.009.05",
    transform: "translate(104.519 -16.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    className: "cls-71",
    d: "M-97.555,25.3l-1.818-.445.009-.05,1.818.445-.009.05",
    transform: "translate(104.521 -16.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    className: "cls-70",
    d: "M-97.541,25.221l-1.818-.444.009-.05,1.816.444-.008.05",
    transform: "translate(104.524 -16.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    className: "cls-70",
    d: "M-97.535,25.181l-1.816-.444.008-.05,1.818.445-.009.049",
    transform: "translate(104.526 -16.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    className: "cls-69",
    d: "M-97.527,25.142l-1.818-.445.009-.05,1.816.445-.008.05",
    transform: "translate(104.527 -16.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    className: "cls-68",
    d: "M-97.522,25.1l-1.816-.445.008-.049,1.816.444-.008.05",
    transform: "translate(104.529 -16.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    className: "cls-68",
    d: "M-97.516,25.062l-1.816-.444.008-.05,1.816.444-.008.05",
    transform: "translate(104.531 -16.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    className: "cls-68",
    d: "M-97.51,25.022l-1.816-.444.008-.05,1.818.445-.009.049",
    transform: "translate(104.532 -16.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    className: "cls-67",
    d: "M-97.5,24.983l-1.818-.445.008-.049,1.816.444-.006.05",
    transform: "translate(104.534 -16.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    className: "cls-67",
    d: "M-97.5,24.943l-1.816-.444.008-.051,1.816.445-.008.05",
    transform: "translate(104.535 -16.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    className: "cls-67",
    d: "M-97.492,24.9l-1.816-.445.008-.054,1.818.444-.009.055",
    transform: "translate(104.537 -16.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    className: "cls-66",
    d: "M-97.485,24.86l-1.818-.444.008-.055,1.818.444-.007.055",
    transform: "translate(104.538 -16.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    className: "cls-65",
    d: "M-97.478,24.816l-1.818-.444.008-.055,1.818.445-.008.054",
    transform: "translate(104.54 -16.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    className: "cls-64",
    d: "M-97.472,24.773l-1.818-.445.008-.054,1.818.444-.008.055",
    transform: "translate(104.541 -16.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    className: "cls-64",
    d: "M-97.466,24.729l-1.818-.444.008-.055,1.818.445-.007.054",
    transform: "translate(104.543 -16.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    className: "cls-64",
    d: "M-97.461,24.686l-1.818-.445.008-.054,1.816.444-.006.055",
    transform: "translate(104.544 -16.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    className: "cls-63",
    d: "M-97.456,24.642l-1.816-.444.006-.055,1.818.445-.008.054",
    transform: "translate(104.546 -16.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    className: "cls-63",
    d: "M-97.45,24.6l-1.818-.445.006-.054,1.818.444-.006.055",
    transform: "translate(104.547 -16.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    className: "cls-62",
    d: "M-97.445,24.555l-1.818-.444.008-.054,1.816.444-.006.054",
    transform: "translate(104.549 -16.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    className: "cls-61",
    d: "M-97.44,24.512l-1.816-.444.006-.055,1.816.445-.006.054",
    transform: "translate(104.55 -16.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    className: "cls-61",
    d: "M-97.435,24.469l-1.816-.445.006-.054,1.816.445-.006.054",
    transform: "translate(104.551 -16.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    className: "cls-61",
    d: "M-97.43,24.426l-1.816-.445.005-.054,1.818.444-.006.055",
    transform: "translate(104.553 -16.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    className: "cls-60",
    d: "M-97.425,24.382l-1.818-.444.006-.055,1.818.444-.006.055",
    transform: "translate(104.554 -16.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    className: "cls-59",
    d: "M-97.42,24.338l-1.818-.444.006-.055,1.816.444-.005.055",
    transform: "translate(104.555 -16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    className: "cls-58",
    d: "M-97.416,24.294l-1.816-.444.005-.055,1.818.444-.006.055",
    transform: "translate(104.556 -16.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    className: "cls-58",
    d: "M-97.41,24.25l-1.818-.444.005-.055,1.818.445-.005.054",
    transform: "translate(104.557 -16.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    className: "cls-58",
    d: "M-97.406,24.207l-1.818-.445.006-.054,1.816.444-.005.055",
    transform: "translate(104.558 -16.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    className: "cls-57",
    d: "M-97.4,24.163l-1.816-.444.005-.055,1.816.445-.005.054",
    transform: "translate(104.559 -16.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    className: "cls-57",
    d: "M-97.4,24.12l-1.816-.445,0-.054,1.818.444-.005.055",
    transform: "translate(104.56 -16.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    className: "cls-57",
    d: "M-97.394,24.076l-1.818-.444,0-.055,1.818.445-.005.054",
    transform: "translate(104.561 -16.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    className: "cls-56",
    d: "M-97.39,24.033l-1.818-.445.005-.054,1.816.445,0,.054",
    transform: "translate(104.562 -16.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    className: "cls-55",
    d: "M-97.388,23.99l-1.816-.445,0-.054,1.816.444,0,.055",
    transform: "translate(104.563 -16.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    className: "cls-54",
    d: "M-97.385,23.946-99.2,23.5l0-.055,1.818.444-.005.055",
    transform: "translate(104.564 -16.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    className: "cls-54",
    d: "M-97.38,23.9l-1.818-.444.005-.068,1.818.445,0,.066",
    transform: "translate(104.565 -16.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    className: "cls-53",
    d: "M-97.377,23.851l-1.818-.445.005-.066,1.816.444,0,.068",
    transform: "translate(104.566 -16.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    className: "cls-53",
    d: "M-97.374,23.8l-1.816-.444,0-.066,1.818.444-.005.066",
    transform: "translate(104.567 -16.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    className: "cls-52",
    d: "M-97.369,23.744l-1.818-.444,0-.066,1.818.444,0,.066",
    transform: "translate(104.567 -16.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    className: "cls-52",
    d: "M-97.366,23.691l-1.818-.444,0-.066,1.818.444,0,.066",
    transform: "translate(104.568 -16.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    className: "cls-51",
    d: "M-97.363,23.638l-1.818-.444,0-.066,1.816.445,0,.065",
    transform: "translate(104.569 -16.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    className: "cls-51",
    d: "M-97.362,23.586l-1.816-.445,0-.065,1.818.444,0,.066",
    transform: "translate(104.57 -16.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    className: "cls-51",
    d: "M-97.358,23.533l-1.818-.444,0-.065,1.818.444,0,.065",
    transform: "translate(104.57 -16.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    className: "cls-50",
    d: "M-97.356,23.481l-1.818-.444,0-.065,1.818.444,0,.065",
    transform: "translate(104.571 -16.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    className: "cls-49",
    d: "M-97.355,23.43l-1.818-.444,0-.073,1.818.444,0,.073",
    transform: "translate(104.571 -16.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    className: "cls-49",
    d: "M-97.352,23.372l-1.818-.444,0-.073,1.816.445v.071",
    transform: "translate(104.572 -16.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    className: "cls-49",
    d: "M-97.352,23.315l-1.816-.445V22.8l1.816.444v.073",
    transform: "translate(104.572 -16.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    className: "cls-48",
    d: "M-97.351,23.257l-1.816-.444v-.071l1.816.444v.071",
    transform: "translate(104.573 -16.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    className: "cls-47",
    d: "M-97.35,23.2l-1.816-.444v-.071l1.818.445v.07",
    transform: "translate(104.573 -16.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    className: "cls-47",
    d: "M-97.348,23.144l-1.818-.445v-.07l1.816.444v.071",
    transform: "translate(104.573 -16.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    className: "cls-47",
    d: "M-97.349,23.087l-1.816-.444v-.07l1.816.444v.07",
    transform: "translate(104.573 -16.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    className: "cls-46",
    d: "M-97.349,23.031l-1.816-.444v-.07l1.816.444v.07",
    transform: "translate(104.573 -16.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    className: "cls-43",
    d: "M-97.348,22.977l-1.816-.444v-.083l1.818.445v.081",
    transform: "translate(104.573 -16.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    className: "cls-43",
    d: "M-97.348,22.913l-1.818-.445v-.085l1.816.445,0,.085",
    transform: "translate(104.573 -16.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    className: "cls-43",
    d: "M-97.35,22.845l-1.816-.445,0-.085,1.818.445v.085",
    transform: "translate(104.572 -16.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    className: "cls-42",
    d: "M-97.351,22.777l-1.818-.445,0-.084,1.818.445,0,.084",
    transform: "translate(104.572 -16.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    className: "cls-42",
    d: "M-97.353,22.71l-1.818-.445,0-.084,1.816.445,0,.084",
    transform: "translate(104.571 -16.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    className: "cls-41",
    d: "M-97.356,22.643l-1.816-.445,0-.083,1.816.444,0,.084",
    transform: "translate(104.57 -16.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    className: "cls-41",
    d: "M-97.359,22.577l-1.816-.444-.005-.09,1.816.445.005.089",
    transform: "translate(104.569 -16.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    className: "cls-40",
    d: "M-97.362,22.512l-1.816-.445-.007-.119,1.818.444.006.12",
    transform: "translate(104.568 -16.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    className: "cls-40",
    d: "M-97.367,22.416l-1.818-.444-.009-.119,1.818.445.009.118",
    transform: "translate(104.566 -17.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    className: "cls-40",
    d: "M-97.374,22.322l-1.818-.445-.009-.117,1.816.444.01.118",
    transform: "translate(104.564 -17.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    className: "cls-39",
    d: "M-97.382,22.227l-1.816-.444-.011-.117,1.816.444.011.117",
    transform: "translate(104.562 -17.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    className: "cls-38",
    d: "M-97.389,22.147l-1.816-.444c-.006-.061-.013-.122-.02-.181l1.818.444q.011.09.019.18",
    transform: "translate(104.558 -17.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    className: "cls-38",
    d: "M-97.4,22.012l-1.818-.444c-.008-.075-.018-.15-.028-.224l1.816.445c.011.074.02.148.029.223",
    transform: "translate(104.552 -17.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    className: "cls-38",
    d: "M-96.867,22.641l-1.816-.445c-.311-2.245-1.307-3.849-2.789-4.212l1.818.444c1.48.362,2.478,1.968,2.788,4.213",
    transform: "translate(103.988 -17.984)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    className: "cls-10",
    transform: "translate(9.937 28.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    className: "cls-274",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    className: "cls-38",
    d: "M-101.968,33.579l-1.818-.444a4.745,4.745,0,0,1-1.978-1.05l1.816.444a4.724,4.724,0,0,0,1.979,1.05",
    transform: "translate(105.763 -32.085)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    className: "cls-10",
    transform: "translate(13.729 11.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    className: "cls-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    className: "cls-207",
    d: "M-100.921,18.5l-1.818-.445a3.853,3.853,0,0,1,.436-.1l1.816.444a3.643,3.643,0,0,0-.435.1",
    transform: "translate(102.738 -17.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    className: "cls-208",
    d: "M-100.574,18.4l-1.816-.444.05-.008,1.818.444-.051.008",
    transform: "translate(102.826 -17.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    className: "cls-208",
    d: "M-100.532,18.394l-1.818-.444.05-.008,1.818.444-.05.008",
    transform: "translate(102.836 -17.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    className: "cls-208",
    d: "M-100.493,18.388l-1.818-.444.05-.006,1.816.445-.049.005",
    transform: "translate(102.847 -17.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    className: "cls-209",
    d: "M-100.454,18.384l-1.816-.445.049-.005,1.818.444-.05.006",
    transform: "translate(102.857 -17.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    className: "cls-210",
    d: "M-100.413,18.378l-1.818-.444.05,0,1.816.444-.049,0",
    transform: "translate(102.866 -17.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    className: "cls-210",
    d: "M-100.375,18.375l-1.816-.444.049,0,1.818.444-.05,0",
    transform: "translate(102.877 -17.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    className: "cls-210",
    d: "M-100.334,18.372l-1.818-.444.049,0,1.818.445-.049,0",
    transform: "translate(102.887 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    className: "cls-211",
    d: "M-100.3,18.37l-1.818-.445h.025l1.816.445h-.024",
    transform: "translate(102.896 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    className: "cls-212",
    d: "M-100.277,18.369l-1.816-.445h.025l1.816.444h-.025",
    transform: "translate(102.902 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    className: "cls-212",
    d: "M-100.257,18.368l-1.816-.444h.024l1.818.445h-.025",
    transform: "translate(102.907 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    className: "cls-212",
    d: "M-100.237,18.368l-1.818-.445h.025l1.816.444h-.024",
    transform: "translate(102.911 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    className: "cls-212",
    d: "M-100.218,18.367l-1.816-.444h.024l1.818.445h-.025",
    transform: "translate(102.917 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    className: "cls-213",
    d: "M-100.2,18.367l-1.818-.445h.025l1.816.445h-.024",
    transform: "translate(102.921 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    className: "cls-213",
    d: "M-100.179,18.367-102,17.922h.024l1.818.445h-.025",
    transform: "translate(102.926 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    className: "cls-214",
    d: "M-100.158,18.367l-1.818-.445h.025l1.816.444h-.024",
    transform: "translate(102.931 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    className: "cls-214",
    d: "M-100.14,18.367l-1.816-.444h.024l1.816.444h-.024",
    transform: "translate(102.936 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    className: "cls-214",
    d: "M-100.121,18.367l-1.816-.444h.024l1.818.444h-.025",
    transform: "translate(102.941 -17.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    className: "cls-214",
    d: "M-100.1,18.368l-1.818-.444h.024l1.818.445h-.024",
    transform: "translate(102.946 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    className: "cls-214",
    d: "M-100.081,18.369l-1.818-.445h.024l1.818.445h-.024",
    transform: "translate(102.951 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    className: "cls-215",
    d: "M-100.062,18.37l-1.818-.445h.024l1.818.445h-.024",
    transform: "translate(102.955 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    className: "cls-216",
    d: "M-100.043,18.371l-1.818-.445h.024l1.818.445h-.024",
    transform: "translate(102.96 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    className: "cls-216",
    d: "M-100.024,18.372l-1.818-.445.024,0,1.818.444h-.024",
    transform: "translate(102.965 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    className: "cls-217",
    d: "M-100.006,18.373l-1.818-.444h.021l1.816.444h-.02",
    transform: "translate(102.97 -17.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    className: "cls-217",
    d: "M-99.99,18.374l-1.816-.444h.019l1.818.445-.02,0",
    transform: "translate(102.974 -17.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    className: "cls-217",
    d: "M-99.973,18.376l-1.818-.445.02,0,1.816.444h-.019",
    transform: "translate(102.978 -17.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    className: "cls-218",
    d: "M-99.959,18.377l-1.816-.444h.019l1.818.445-.02,0",
    transform: "translate(102.982 -17.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    className: "cls-218",
    d: "M-99.942,18.379l-1.818-.445.02,0,1.816.444h-.019",
    transform: "translate(102.986 -17.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    className: "cls-218",
    d: "M-99.928,18.38l-1.816-.444.019,0,1.818.444-.02,0",
    transform: "translate(102.99 -17.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    className: "cls-219",
    d: "M-99.911,18.382l-1.818-.444.019,0,1.818.444-.019,0",
    transform: "translate(102.994 -17.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    className: "cls-219",
    d: "M-99.9,18.384l-1.818-.444.02,0,1.816.444-.019,0",
    transform: "translate(102.998 -17.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    className: "cls-220",
    d: "M-99.882,18.386l-1.816-.444.019,0,1.816.444-.019,0",
    transform: "translate(103.002 -17.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    className: "cls-220",
    d: "M-99.867,18.388l-1.816-.444.019,0,1.818.444-.02,0",
    transform: "translate(103.005 -17.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    className: "cls-220",
    d: "M-99.85,18.39l-1.818-.444.019,0,1.818.444-.019,0",
    transform: "translate(103.009 -17.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    className: "cls-220",
    d: "M-99.836,18.392l-1.818-.444.02,0,1.816.445-.019,0",
    transform: "translate(103.013 -17.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    className: "cls-220",
    d: "M-99.821,18.395l-1.816-.445.019,0,1.816.444-.019,0",
    transform: "translate(103.017 -17.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    className: "cls-220",
    d: "M-99.806,18.4l-1.816-.444.019,0,1.816.444-.019,0",
    transform: "translate(103.021 -17.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    className: "cls-221",
    d: "M-99.791,18.4l-1.816-.444.019,0,1.816.445-.019,0",
    transform: "translate(103.025 -17.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    className: "cls-222",
    d: "M-99.776,18.4l-1.816-.445.019,0,1.816.444-.019,0",
    transform: "translate(103.029 -17.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    className: "cls-222",
    d: "M-99.761,18.4l-1.816-.444.019,0,1.816.444-.019,0",
    transform: "translate(103.032 -17.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    className: "cls-222",
    d: "M-99.746,18.408l-1.816-.444.019,0,1.816.444-.019,0",
    transform: "translate(103.036 -17.911)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    className: "cls-222",
    d: "M-99.731,18.411l-1.816-.444.018,0,1.816.444-.018,0",
    transform: "translate(103.04 -17.911)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    className: "cls-223",
    d: "M-99.717,18.414l-1.816-.444.016,0,1.818.444-.018,0",
    transform: "translate(103.043 -17.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    className: "cls-223",
    d: "M-99.7,18.417l-1.818-.444.016,0,1.816.444-.015,0",
    transform: "translate(103.047 -17.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    className: "cls-223",
    d: "M-99.691,18.42l-1.816-.444.016,0,1.816.444-.016,0",
    transform: "translate(103.05 -17.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    className: "cls-224",
    d: "M-99.678,18.423l-1.816-.444.016,0,1.816.444-.016,0",
    transform: "translate(103.053 -17.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    className: "cls-224",
    d: "M-99.664,18.426l-1.817-.444.012,0,1.817.444-.012,0",
    transform: "translate(103.057 -17.907)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(4.831 39.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    className: "cls-135",
    d: "M-108.02,41.516l-1.817-.444.123-.221,1.817.444Z",
    transform: "translate(109.837 -40.851)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(4.828 39.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    className: "cls-202",
    d: "M-107.9,41.325l-1.817-.444-.126-.149,1.817.444Z",
    transform: "translate(109.839 -40.732)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    className: "cls-10",
    transform: "translate(5.572 35.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    className: "cls-20",
    d: "M-107.429,38.475l-1.816-.444h.162l1.818.445h-.163",
    transform: "translate(109.245 -36.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    className: "cls-19",
    d: "M-107.3,38.476l-1.818-.445c.075,0,.152,0,.227,0l1.816.445h-.226",
    transform: "translate(109.278 -36.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    className: "cls-19",
    d: "M-107.119,38.476l-1.816-.445.233,0,1.816.445-.233,0",
    transform: "translate(109.324 -36.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    className: "cls-18",
    d: "M-106.933,38.475l-1.816-.445.234,0,1.818.444-.236.005",
    transform: "translate(109.371 -36.829)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    className: "cls-18",
    d: "M-106.744,38.471l-1.818-.444.242-.008,1.818.445-.242.006",
    transform: "translate(109.418 -36.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    className: "cls-17",
    d: "M-106.552,38.467l-1.818-.445.244-.009,1.818.445-.244.009",
    transform: "translate(109.467 -36.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    className: "cls-17",
    d: "M-106.357,38.46l-1.818-.445c.085,0,.169-.008.253-.011l1.818.444-.253.013",
    transform: "translate(109.517 -36.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    className: "cls-16",
    d: "M-106.155,38.451l-1.818-.444.254-.014,1.818.444-.254.014",
    transform: "translate(109.568 -36.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    className: "cls-16",
    d: "M-105.952,38.44-107.769,38l.266-.018,1.816.445-.264.016",
    transform: "translate(109.619 -36.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    className: "cls-15",
    d: "M-105.741,38.428l-1.816-.445c.089-.005.179-.013.268-.019l1.816.444-.268.02",
    transform: "translate(109.673 -36.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    className: "cls-15",
    d: "M-105.527,38.413l-1.816-.444.276-.024,1.818.445-.277.023",
    transform: "translate(109.727 -36.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    className: "cls-14",
    d: "M-105.305,38.4l-1.818-.445c.1-.008.191-.016.285-.026l1.818.445-.285.026",
    transform: "translate(109.783 -36.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    className: "cls-13",
    d: "M-105.079,38.375l-1.818-.445q.147-.013.29-.03l1.818.445-.29.03",
    transform: "translate(109.841 -36.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    className: "cls-13",
    d: "M-104.847,38.352l-1.818-.445q.152-.015.3-.034l1.818.444-.3.035",
    transform: "translate(109.899 -36.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    className: "cls-12",
    d: "M-104.607,38.52l-1.818-.444a31.4,31.4,0,0,0,4.946-1.005l1.818.445a31.545,31.545,0,0,1-4.946,1",
    transform: "translate(109.96 -37.071)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(3.175 40.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    className: "cls-13",
    d: "M-109.341,41.945l-1.817-.444,1.656-.474,1.817.444Z",
    transform: "translate(111.157 -41.027)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(3.436 39.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M-109.132,41.574l-1.817-.444,1.391-.4,1.817.444Z",
    transform: "translate(110.949 -40.732)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    className: "cls-10",
    transform: "translate(9.369 11.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    className: "cls-277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    className: "cls-10",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    className: "cls-278",
    d: "M-100.994,32.32l-1.816-.445c-1.74-.425-2.936-3.188-3.308-5.988l1.816.444c.372,2.8,1.569,5.564,3.308,5.989",
    transform: "translate(106.241 -16.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    className: "cls-279",
    d: "M-104.3,26.38l-1.816-.444q-.017-.122-.03-.244l1.816.445.03.243",
    transform: "translate(106.235 -16.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    className: "cls-279",
    d: "M-104.32,26.186l-1.816-.445c-.01-.08-.019-.162-.026-.243l1.818.445c.008.08.016.162.025.243",
    transform: "translate(106.229 -16.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    className: "cls-279",
    d: "M-104.342,25.976l-1.818-.445-.015-.165,1.816.444c0,.055.01.11.016.167",
    transform: "translate(106.226 -16.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    className: "cls-279",
    d: "M-104.356,25.838l-1.816-.444-.011-.139,1.816.444.011.139",
    transform: "translate(106.224 -16.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    className: "cls-279",
    d: "M-104.366,25.727l-1.816-.444c0-.046-.008-.093-.01-.139l1.816.445c0,.046.006.093.01.138",
    transform: "translate(106.222 -16.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    className: "cls-280",
    d: "M-104.374,25.617l-1.816-.445c0-.046-.006-.092-.009-.138l1.818.444.008.139",
    transform: "translate(106.22 -16.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    className: "cls-280",
    d: "M-104.38,25.5l-1.818-.444-.006-.113,1.818.445.006.112",
    transform: "translate(106.219 -16.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    className: "cls-280",
    d: "M-104.386,25.407l-1.818-.445,0-.09,1.818.444,0,.092",
    transform: "translate(106.218 -16.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    className: "cls-280",
    d: "M-104.389,25.334l-1.818-.444,0-.092,1.818.445,0,.09",
    transform: "translate(106.217 -16.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    className: "cls-280",
    d: "M-104.392,25.262l-1.818-.445,0-.09,1.818.444,0,.092",
    transform: "translate(106.217 -16.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    className: "cls-281",
    d: "M-104.394,25.189l-1.818-.444,0-.09,1.818.444,0,.09",
    transform: "translate(106.216 -16.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    className: "cls-282",
    d: "M-104.4,25.117l-1.818-.444v-.09l1.818.445v.089",
    transform: "translate(106.216 -16.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    className: "cls-282",
    d: "M-104.4,25.045l-1.818-.445v-.085l1.818.445v.085",
    transform: "translate(106.216 -16.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    className: "cls-283",
    d: "M-104.4,24.973l-1.818-.445v-.065l1.818.444v.066",
    transform: "translate(106.216 -16.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    className: "cls-283",
    d: "M-104.4,24.92l-1.818-.444V24.41l1.818.445v.065",
    transform: "translate(106.216 -16.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    className: "cls-283",
    d: "M-104.4,24.868l-1.818-.445v-.065l1.818.444v.066",
    transform: "translate(106.216 -16.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    className: "cls-284",
    d: "M-104.4,24.815l-1.818-.444v-.065l1.818.444v.065",
    transform: "translate(106.216 -16.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    className: "cls-284",
    d: "M-104.4,24.763l-1.818-.444v-.066l1.816.445v.065",
    transform: "translate(106.216 -16.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    className: "cls-284",
    d: "M-104.4,24.711l-1.816-.445V24.2l1.818.445,0,.065",
    transform: "translate(106.216 -16.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    className: "cls-284",
    d: "M-104.4,24.659l-1.818-.445v-.065l1.818.444v.066",
    transform: "translate(106.217 -16.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    className: "cls-284",
    d: "M-104.394,24.606l-1.818-.444,0-.065,1.818.444,0,.065",
    transform: "translate(106.217 -16.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    className: "cls-285",
    d: "M-104.392,24.553l-1.818-.444,0-.059,1.816.445v.058",
    transform: "translate(106.217 -16.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    className: "cls-286",
    d: "M-104.392,24.506l-1.816-.445,0-.053,1.816.445,0,.053",
    transform: "translate(106.218 -16.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    className: "cls-286",
    d: "M-104.39,24.464l-1.816-.445v-.053l1.818.445,0,.053",
    transform: "translate(106.219 -16.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    className: "cls-286",
    d: "M-104.387,24.421l-1.818-.445,0-.051,1.816.444,0,.053",
    transform: "translate(106.219 -16.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    className: "cls-287",
    d: "M-104.386,24.379l-1.816-.444,0-.053,1.816.444,0,.053",
    transform: "translate(106.22 -16.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    className: "cls-287",
    d: "M-104.384,24.337l-1.816-.444,0-.053,1.818.444,0,.053",
    transform: "translate(106.22 -16.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    className: "cls-288",
    d: "M-104.381,24.3l-1.818-.444,0-.053,1.816.445,0,.051",
    transform: "translate(106.221 -16.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    className: "cls-288",
    d: "M-104.379,24.254l-1.816-.445,0-.051,1.816.444,0,.053",
    transform: "translate(106.221 -16.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    className: "cls-289",
    d: "M-104.376,24.212l-1.816-.444,0-.053,1.818.444,0,.053",
    transform: "translate(106.222 -16.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    className: "cls-289",
    d: "M-104.372,24.17l-1.818-.444.005-.053,1.816.445,0,.051",
    transform: "translate(106.223 -16.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    className: "cls-289",
    d: "M-104.37,24.129l-1.816-.445,0-.051,1.816.444,0,.053",
    transform: "translate(106.224 -16.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    className: "cls-289",
    d: "M-104.367,24.085l-1.816-.444,0-.041,1.816.445,0,.04",
    transform: "translate(106.224 -16.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    className: "cls-290",
    d: "M-104.364,24.053l-1.816-.445,0-.038,1.818.444,0,.039",
    transform: "translate(106.225 -16.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    className: "cls-290",
    d: "M-104.361,24.021l-1.818-.444,0-.038,1.816.444,0,.038",
    transform: "translate(106.226 -16.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    className: "cls-290",
    d: "M-104.359,23.992l-1.816-.444,0-.039,1.816.445,0,.038",
    transform: "translate(106.226 -16.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    className: "cls-290",
    d: "M-104.356,23.962l-1.816-.445,0-.038,1.816.445,0,.038",
    transform: "translate(106.227 -16.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    className: "cls-291",
    d: "M-104.353,23.932l-1.816-.445,0-.038,1.816.444,0,.039",
    transform: "translate(106.228 -16.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    className: "cls-292",
    d: "M-104.35,23.9l-1.816-.444,0-.038,1.816.444,0,.038",
    transform: "translate(106.229 -16.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    className: "cls-292",
    d: "M-104.347,23.87l-1.816-.444,0-.038,1.816.444,0,.038",
    transform: "translate(106.229 -16.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    className: "cls-293",
    d: "M-104.344,23.84l-1.816-.444,0-.038,1.816.444,0,.038",
    transform: "translate(106.23 -16.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    className: "cls-293",
    d: "M-104.341,23.81l-1.816-.444,0-.038,1.818.444,0,.038",
    transform: "translate(106.231 -16.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    className: "cls-293",
    d: "M-104.337,23.78l-1.818-.444.005-.038,1.816.444,0,.038",
    transform: "translate(106.232 -16.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    className: "cls-293",
    d: "M-104.334,23.75l-1.816-.444,0-.038,1.818.444-.005.038",
    transform: "translate(106.233 -16.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    className: "cls-294",
    d: "M-104.33,23.72l-1.818-.444.005-.038,1.816.444,0,.038",
    transform: "translate(106.234 -16.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    className: "cls-295",
    d: "M-104.327,23.69l-1.816-.444.005-.038,1.816.444-.005.038",
    transform: "translate(106.235 -16.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    className: "cls-295",
    d: "M-104.323,23.66l-1.816-.444,0-.038,1.818.444-.005.038",
    transform: "translate(106.235 -16.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    className: "cls-295",
    d: "M-104.319,23.63l-1.818-.444.005-.034,1.816.445,0,.033",
    transform: "translate(106.236 -16.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    className: "cls-295",
    d: "M-104.316,23.6l-1.816-.445,0-.033,1.818.444-.005.034",
    transform: "translate(106.237 -16.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    className: "cls-296",
    d: "M-104.311,23.577l-1.818-.444.005-.034,1.816.445,0,.033",
    transform: "translate(106.238 -16.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    className: "cls-296",
    d: "M-104.309,23.551l-1.816-.445,0-.033,1.818.444-.005.034",
    transform: "translate(106.239 -16.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    className: "cls-296",
    d: "M-104.3,23.524l-1.818-.444.005-.034,1.818.445-.005.033",
    transform: "translate(106.24 -16.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    className: "cls-296",
    d: "M-104.3,23.5l-1.818-.445.005-.033,1.816.444,0,.034",
    transform: "translate(106.241 -16.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    className: "cls-297",
    d: "M-104.3,23.471l-1.816-.444,0-.034,1.816.445-.005.033",
    transform: "translate(106.242 -16.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    className: "cls-298",
    d: "M-104.294,23.445-106.11,23l0-.033,1.816.444,0,.034",
    transform: "translate(106.243 -16.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    className: "cls-299",
    d: "M-104.29,23.417l-1.816-.444.005-.033,1.816.444-.005.033",
    transform: "translate(106.244 -16.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    className: "cls-299",
    d: "M-104.286,23.392l-1.816-.444.005-.034,1.816.445-.005.033",
    transform: "translate(106.245 -16.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    className: "cls-299",
    d: "M-104.282,23.366l-1.816-.445,0-.033,1.818.444-.006.034",
    transform: "translate(106.246 -16.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    className: "cls-299",
    d: "M-104.276,23.338l-1.818-.444,0-.033,1.818.444,0,.033",
    transform: "translate(106.247 -16.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    className: "cls-299",
    d: "M-104.273,23.313l-1.818-.444.006-.034,1.816.445-.005.033",
    transform: "translate(106.248 -16.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    className: "cls-300",
    d: "M-104.269,23.287l-1.816-.445.005-.033,1.816.444-.005.034",
    transform: "translate(106.249 -16.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    className: "cls-301",
    d: "M-104.265,23.259l-1.816-.444.005-.033,1.818.444-.006.033",
    transform: "translate(106.25 -16.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    className: "cls-301",
    d: "M-104.26,23.233l-1.818-.444.006-.033,1.816.444-.005.033",
    transform: "translate(106.251 -16.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    className: "cls-301",
    d: "M-104.256,23.207l-1.816-.444,0-.03,1.816.444-.005.03",
    transform: "translate(106.253 -16.841)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    className: "cls-301",
    d: "M-104.252,23.182l-1.816-.444.005-.028,1.816.444-.005.028",
    transform: "translate(106.254 -16.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    className: "cls-301",
    d: "M-104.248,23.16l-1.816-.444.005-.028,1.816.444-.005.028",
    transform: "translate(106.255 -16.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    className: "cls-302",
    d: "M-104.244,23.138l-1.816-.444,0-.028,1.816.444-.005.028",
    transform: "translate(106.255 -16.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    className: "cls-302",
    d: "M-104.24,23.116l-1.816-.444.005-.028,1.816.444-.005.028",
    transform: "translate(106.257 -16.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    className: "cls-302",
    d: "M-104.236,23.094l-1.816-.444.005-.028,1.816.444-.005.028",
    transform: "translate(106.258 -16.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    className: "cls-303",
    d: "M-104.232,23.072l-1.816-.444.005-.028,1.818.444-.006.028",
    transform: "translate(106.259 -16.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    className: "cls-303",
    d: "M-104.227,23.05l-1.818-.444,0-.028,1.818.444-.005.028",
    transform: "translate(106.26 -16.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    className: "cls-304",
    d: "M-104.222,23.028l-1.818-.444.006-.028,1.816.444-.005.028",
    transform: "translate(106.261 -16.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    className: "cls-304",
    d: "M-104.219,23.006l-1.816-.444.005-.028,1.816.445,0,.026",
    transform: "translate(106.262 -16.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    className: "cls-304",
    d: "M-104.215,22.986l-1.816-.445,0-.028,1.818.445-.006.028",
    transform: "translate(106.263 -16.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    className: "cls-304",
    d: "M-104.209,22.963l-1.818-.445.006-.026,1.816.444-.005.028",
    transform: "translate(106.264 -16.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    className: "cls-304",
    d: "M-104.206,22.941l-1.816-.444.005-.028,1.818.444-.006.028",
    transform: "translate(106.265 -16.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    className: "cls-304",
    d: "M-104.2,22.919l-1.818-.444.006-.028,1.816.444,0,.028",
    transform: "translate(106.266 -16.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    className: "cls-305",
    d: "M-104.2,22.9l-1.816-.444.005-.028,1.818.445-.006.026",
    transform: "translate(106.267 -16.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    className: "cls-306",
    d: "M-104.191,22.877l-1.818-.445L-106,22.4l1.816.445-.005.028",
    transform: "translate(106.268 -16.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    className: "cls-306",
    d: "M-104.188,22.854-106,22.409l0-.026,1.818.444-.006.028",
    transform: "translate(106.27 -16.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    className: "cls-306",
    d: "M-104.183,22.832-106,22.389l.006-.028,1.818.445-.006.026",
    transform: "translate(106.271 -16.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    className: "cls-306",
    d: "M-104.178,22.812-106,22.367l.006-.028,1.816.445-.005.028",
    transform: "translate(106.272 -16.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    className: "cls-306",
    d: "M-104.174,22.789l-1.816-.445.005-.026,1.818.445-.006.026",
    transform: "translate(106.273 -16.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    className: "cls-307",
    d: "M-104.169,22.768l-1.818-.445.006-.023,1.816.444-.005.024",
    transform: "translate(106.274 -16.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    className: "cls-308",
    d: "M-104.165,22.749l-1.816-.444.005-.024,1.816.445-.005.023",
    transform: "translate(106.276 -16.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    className: "cls-308",
    d: "M-104.161,22.731l-1.816-.445.005-.023,1.818.444-.006.024",
    transform: "translate(106.277 -16.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    className: "cls-309",
    d: "M-104.155,22.712l-1.818-.444,0-.024,1.818.445-.005.023",
    transform: "translate(106.278 -16.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    className: "cls-309",
    d: "M-104.152,22.694l-1.818-.445.006-.023,1.816.444,0,.024",
    transform: "translate(106.279 -16.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    className: "cls-310",
    d: "M-104.148,22.674l-1.816-.444,0-.023,1.816.444,0,.023",
    transform: "translate(106.28 -16.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    className: "cls-310",
    d: "M-104.144,22.657l-1.816-.444,0-.024,1.818.445-.006.023",
    transform: "translate(106.281 -16.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    className: "cls-310",
    d: "M-104.138,22.639l-1.818-.445.006-.023,1.816.444,0,.024",
    transform: "translate(106.282 -16.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    className: "cls-310",
    d: "M-104.135,22.619l-1.816-.444.005-.023,1.816.444-.005.023",
    transform: "translate(106.283 -16.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    className: "cls-310",
    d: "M-104.131,22.6l-1.816-.444.005-.024,1.818.445-.006.023",
    transform: "translate(106.284 -16.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    className: "cls-310",
    d: "M-104.125,22.584l-1.818-.445.006-.023,1.816.444-.005.024",
    transform: "translate(106.285 -16.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    className: "cls-311",
    d: "M-104.122,22.564l-1.816-.444,0-.023,1.818.444-.006.023",
    transform: "translate(106.287 -17.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    className: "cls-311",
    d: "M-104.117,22.546l-1.818-.444.006-.023,1.818.444-.006.023",
    transform: "translate(106.288 -17.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    className: "cls-311",
    d: "M-104.112,22.529l-1.818-.444.006-.024,1.816.445,0,.023",
    transform: "translate(106.289 -17.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    className: "cls-311",
    d: "M-104.108,22.511l-1.816-.445.005-.023,1.818.445-.006.023",
    transform: "translate(106.29 -17.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    className: "cls-311",
    d: "M-104.1,22.493l-1.818-.445.006-.023,1.816.444-.005.024",
    transform: "translate(106.291 -17.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    className: "cls-312",
    d: "M-104.1,22.473l-1.816-.444.006-.023,1.816.444-.006.023",
    transform: "translate(106.292 -17.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    className: "cls-312",
    d: "M-104.094,22.455l-1.816-.444.005-.023,1.818.444-.006.023",
    transform: "translate(106.294 -17.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    className: "cls-312",
    d: "M-104.088,22.437l-1.818-.444.006-.023,1.818.444-.006.023",
    transform: "translate(106.295 -17.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    className: "cls-313",
    d: "M-104.084,22.419l-1.818-.444.006-.023,1.816.444,0,.023",
    transform: "translate(106.296 -17.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    className: "cls-313",
    d: "M-104.08,22.4l-1.816-.444.006-.023,1.816.444-.006.023",
    transform: "translate(106.297 -17.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    className: "cls-313",
    d: "M-104.075,22.383l-1.816-.444.006-.023,1.816.444-.006.023",
    transform: "translate(106.298 -17.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    className: "cls-9",
    d: "M-104.07,22.365l-1.816-.444.005-.023,1.818.445-.006.021",
    transform: "translate(106.3 -17.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    className: "cls-9",
    d: "M-104.065,22.348l-1.818-.445.006-.019,1.816.444,0,.02",
    transform: "translate(106.301 -17.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    className: "cls-9",
    d: "M-104.061,22.332l-1.816-.444,0-.02,1.816.445-.005.019",
    transform: "translate(106.302 -17.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    className: "cls-9",
    d: "M-104.057,22.317l-1.816-.445,0-.019,1.818.444-.006.02",
    transform: "translate(106.303 -17.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    className: "cls-9",
    d: "M-104.051,22.3l-1.818-.444.006-.02,1.816.445-.005.019",
    transform: "translate(106.304 -17.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    className: "cls-314",
    d: "M-104.048,22.286l-1.816-.445.005-.019,1.816.444,0,.02",
    transform: "translate(106.305 -17.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    className: "cls-314",
    d: "M-104.044,22.27l-1.816-.444.005-.02,1.818.445-.006.019",
    transform: "translate(106.306 -17.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    className: "cls-314",
    d: "M-104.039,22.255l-1.818-.445.006-.019,1.816.444-.005.02",
    transform: "translate(106.307 -17.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    className: "cls-314",
    d: "M-104.035,22.239l-1.816-.444,0-.02,1.818.445-.006.019",
    transform: "translate(106.308 -17.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    className: "cls-315",
    d: "M-104.03,22.224l-1.818-.445.006-.019,1.816.444-.005.02",
    transform: "translate(106.31 -17.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    className: "cls-315",
    d: "M-104.026,22.208l-1.816-.444.005-.019,1.818.444-.006.019",
    transform: "translate(106.311 -17.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    className: "cls-316",
    d: "M-104.02,22.193l-1.818-.444.006-.02,1.816.445-.005.019",
    transform: "translate(106.312 -17.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    className: "cls-316",
    d: "M-104.017,22.178l-1.816-.445.005-.019,1.818.444-.006.02",
    transform: "translate(106.313 -17.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    className: "cls-317",
    d: "M-104.011,22.162l-1.818-.444.006-.019,1.816.444-.005.019",
    transform: "translate(106.314 -17.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    className: "cls-317",
    d: "M-104.008,22.147l-1.816-.444.005-.02,1.818.445-.006.019",
    transform: "translate(106.315 -17.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    className: "cls-317",
    d: "M-104,22.132l-1.818-.445.006-.019,1.818.444-.006.02",
    transform: "translate(106.316 -17.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    className: "cls-318",
    d: "M-104,22.116l-1.818-.444.006-.019,1.816.444-.005.019",
    transform: "translate(106.318 -17.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    className: "cls-318",
    d: "M-103.994,22.1l-1.816-.444.005-.02,1.818.445-.006.019",
    transform: "translate(106.319 -17.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    className: "cls-318",
    d: "M-103.988,22.086l-1.818-.445.006-.019,1.818.445-.006.019",
    transform: "translate(106.32 -17.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    className: "cls-318",
    d: "M-103.983,22.071l-1.818-.445.006-.019,1.816.444-.005.02",
    transform: "translate(106.321 -17.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    className: "cls-318",
    d: "M-103.98,22.055l-1.816-.444.006-.019,1.816.444-.006.019",
    transform: "translate(106.322 -17.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    className: "cls-319",
    d: "M-103.975,22.04l-1.816-.444.005-.019,1.818.444-.006.019",
    transform: "translate(106.324 -17.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    className: "cls-320",
    d: "M-103.969,22.025l-1.818-.444.006-.02,1.818.445-.006.019",
    transform: "translate(106.325 -17.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    className: "cls-320",
    d: "M-103.965,22.01l-1.818-.445.006-.019,1.818.445-.006.019",
    transform: "translate(106.326 -17.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    className: "cls-321",
    d: "M-103.96,21.995l-1.818-.445.006-.019,1.816.445-.005.019",
    transform: "translate(106.327 -17.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    className: "cls-321",
    d: "M-103.956,21.98l-1.816-.445.006-.019,1.816.444-.006.02",
    transform: "translate(106.328 -17.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    className: "cls-321",
    d: "M-103.951,21.964l-1.816-.444.006-.019,1.816.444-.006.019",
    transform: "translate(106.33 -17.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    className: "cls-322",
    d: "M-103.946,21.948l-1.816-.444.005-.018,1.818.445-.006.016",
    transform: "translate(106.331 -17.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    className: "cls-322",
    d: "M-103.94,21.935l-1.818-.445.006-.016,1.816.445-.005.016",
    transform: "translate(106.332 -17.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    className: "cls-323",
    d: "M-103.937,21.922l-1.816-.445.005-.016,1.816.444-.005.018",
    transform: "translate(106.333 -17.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    className: "cls-323",
    d: "M-103.933,21.908l-1.816-.444.005-.018,1.818.445-.006.016",
    transform: "translate(106.335 -17.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    className: "cls-323",
    d: "M-103.927,21.9l-1.818-.445.006-.016,1.816.444,0,.018",
    transform: "translate(106.335 -17.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    className: "cls-323",
    d: "M-103.924,21.881l-1.816-.444,0-.016,1.818.444-.006.016",
    transform: "translate(106.337 -17.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    className: "cls-324",
    d: "M-103.919,21.868l-1.818-.444.006-.018,1.816.445-.005.016",
    transform: "translate(106.338 -17.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    className: "cls-324",
    d: "M-103.915,21.855l-1.816-.445.005-.016,1.818.445-.006.016",
    transform: "translate(106.339 -17.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    className: "cls-324",
    d: "M-103.91,21.842l-1.818-.445.006-.016,1.816.444-.005.018",
    transform: "translate(106.34 -17.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    className: "cls-324",
    d: "M-103.906,21.828l-1.816-.444.005-.016,1.818.444-.006.016",
    transform: "translate(106.341 -17.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    className: "cls-325",
    d: "M-103.9,21.815l-1.818-.444.006-.018,1.818.445-.006.016",
    transform: "translate(106.342 -17.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    className: "cls-326",
    d: "M-103.9,21.8l-1.818-.445.006-.016,1.816.445-.005.016",
    transform: "translate(106.344 -17.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    className: "cls-326",
    d: "M-103.892,21.789l-1.816-.445.005-.016,1.818.444-.006.018",
    transform: "translate(106.345 -17.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    className: "cls-326",
    d: "M-103.886,21.775l-1.818-.444.006-.016,1.816.444-.005.016",
    transform: "translate(106.346 -17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    className: "cls-326",
    d: "M-103.883,21.762l-1.816-.444.006-.016,1.816.444-.006.016",
    transform: "translate(106.347 -17.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    className: "cls-326",
    d: "M-103.878,21.749l-1.816-.444.005-.016,1.818.444-.006.016",
    transform: "translate(106.348 -17.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    className: "cls-326",
    d: "M-103.872,21.736l-1.818-.444.006-.018,1.816.445-.005.016",
    transform: "translate(106.349 -17.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    className: "cls-327",
    d: "M-103.869,21.723l-1.816-.445.006-.016,1.816.445-.006.016",
    transform: "translate(106.351 -17.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    className: "cls-328",
    d: "M-103.864,21.71l-1.816-.445.005-.016,1.818.445-.006.016",
    transform: "translate(106.352 -17.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    className: "cls-328",
    d: "M-103.858,21.7l-1.818-.445.006-.016,1.818.445-.006.016",
    transform: "translate(106.353 -17.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    className: "cls-328",
    d: "M-103.853,21.684l-1.818-.445.006-.016,1.816.444-.005.018",
    transform: "translate(106.354 -17.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    className: "cls-328",
    d: "M-103.85,21.67l-1.816-.444.006-.016,1.816.444-.006.016",
    transform: "translate(106.355 -17.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    className: "cls-329",
    d: "M-103.845,21.657l-1.816-.444.006-.016,1.816.444-.006.016",
    transform: "translate(106.357 -17.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    className: "cls-329",
    d: "M-103.84,21.644l-1.816-.444,0-.016,1.818.444-.006.016",
    transform: "translate(106.358 -17.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    className: "cls-329",
    d: "M-103.835,21.631l-1.818-.444.006-.016,1.818.444-.006.016",
    transform: "translate(106.359 -17.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    className: "cls-329",
    d: "M-103.83,21.618l-1.818-.444.006-.016,1.818.444-.006.016",
    transform: "translate(106.36 -17.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    className: "cls-330",
    d: "M-103.824,21.605l-1.818-.444.006-.016,1.818.444-.006.016",
    transform: "translate(106.361 -17.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    className: "cls-331",
    d: "M-103.819,21.592l-1.818-.444.006-.016,1.816.444,0,.016",
    transform: "translate(106.363 -17.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    className: "cls-332",
    d: "M-103.816,21.579l-1.816-.444.006-.016,1.816.445-.006.015",
    transform: "translate(106.364 -17.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    className: "cls-332",
    d: "M-103.811,21.567l-1.816-.445.006-.016,1.816.445-.006.016",
    transform: "translate(106.365 -17.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    className: "cls-332",
    d: "M-103.806,21.554l-1.816-.445.005-.014,1.818.444-.006.015",
    transform: "translate(106.366 -17.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    className: "cls-332",
    d: "M-103.8,21.542l-1.818-.444.006-.015,1.816.444-.005.015",
    transform: "translate(106.368 -17.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    className: "cls-332",
    d: "M-103.8,21.53l-1.816-.444,0-.015,1.818.444-.006.015",
    transform: "translate(106.369 -17.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    className: "cls-333",
    d: "M-103.791,21.518l-1.818-.444.006-.015,1.818.445-.006.014",
    transform: "translate(106.37 -17.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    className: "cls-333",
    d: "M-103.787,21.507l-1.818-.445.006-.015,1.816.445,0,.015",
    transform: "translate(106.371 -17.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    className: "cls-334",
    d: "M-103.783,21.495l-1.816-.445.005-.014,1.818.444-.006.015",
    transform: "translate(106.373 -17.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    className: "cls-334",
    d: "M-103.778,21.483l-1.818-.444.006-.015,1.818.444-.006.015",
    transform: "translate(106.374 -17.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    className: "cls-334",
    d: "M-103.773,21.471l-1.818-.444.006-.015,1.816.445,0,.014",
    transform: "translate(106.375 -17.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    className: "cls-334",
    d: "M-103.769,21.46l-1.816-.445.005-.015,1.818.445-.006.015",
    transform: "translate(106.376 -17.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    className: "cls-335",
    d: "M-103.764,21.448-105.581,21l.006-.015,1.817.444-.006.015",
    transform: "translate(106.377 -17.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    className: "cls-335",
    d: "M-103.759,21.436l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.378 -17.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    className: "cls-336",
    d: "M-103.754,21.424l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.379 -17.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    className: "cls-336",
    d: "M-103.75,21.413l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.381 -17.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    className: "cls-337",
    d: "M-103.745,21.4l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.382 -17.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    className: "cls-338",
    d: "M-103.74,21.389l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.383 -17.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    className: "cls-338",
    d: "M-103.735,21.378l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.384 -17.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    className: "cls-338",
    d: "M-103.73,21.366l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.386 -17.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    className: "cls-338",
    d: "M-103.726,21.355l-1.817-.444.006-.015,1.817.444-.006.015",
    transform: "translate(106.387 -17.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    className: "cls-338",
    d: "M-103.721,21.343l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.388 -17.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    className: "cls-338",
    d: "M-103.716,21.331l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.389 -17.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    className: "cls-339",
    d: "M-103.711,21.32l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.39 -17.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    className: "cls-340",
    d: "M-103.706,21.308l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.392 -17.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    className: "cls-340",
    d: "M-103.7,21.3l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.393 -17.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    className: "cls-340",
    d: "M-103.7,21.285l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.394 -17.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    className: "cls-340",
    d: "M-103.691,21.274l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.395 -17.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    className: "cls-340",
    d: "M-103.686,21.262l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.397 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    className: "cls-341",
    d: "M-103.681,21.251l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.398 -17.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    className: "cls-341",
    d: "M-103.676,21.239l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.399 -17.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    className: "cls-341",
    d: "M-103.671,21.228l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.4 -17.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    className: "cls-342",
    d: "M-103.666,21.216l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.402 -17.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    className: "cls-342",
    d: "M-103.661,21.205l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.403 -17.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    className: "cls-343",
    d: "M-103.656,21.194l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.404 -17.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    className: "cls-343",
    d: "M-103.651,21.182l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.406 -17.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    className: "cls-343",
    d: "M-103.646,21.171l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.407 -17.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    className: "cls-343",
    d: "M-103.642,21.16l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.408 -17.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    className: "cls-343",
    d: "M-103.637,21.15l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.409 -17.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    className: "cls-343",
    d: "M-103.632,21.139l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.411 -17.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    className: "cls-344",
    d: "M-103.627,21.128l-1.817-.444.006-.014,1.817.444-.006.014",
    transform: "translate(106.412 -17.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    className: "cls-344",
    d: "M-103.622,21.117l-1.817-.444.006-.014,1.817.444-.006.013",
    transform: "translate(106.413 -17.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    className: "cls-344",
    d: "M-103.617,21.106l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.414 -17.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    className: "cls-344",
    d: "M-103.612,21.1l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.415 -17.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    className: "cls-345",
    d: "M-103.607,21.085l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.417 -17.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    className: "cls-346",
    d: "M-103.6,21.074l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.418 -17.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    className: "cls-346",
    d: "M-103.6,21.063l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.419 -17.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    className: "cls-346",
    d: "M-103.592,21.053l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.42 -17.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    className: "cls-347",
    d: "M-103.587,21.042-105.4,20.6l.006-.013,1.817.444-.006.013",
    transform: "translate(106.422 -17.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    className: "cls-347",
    d: "M-103.582,21.031l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.423 -17.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    className: "cls-347",
    d: "M-103.577,21.021l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.424 -17.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    className: "cls-348",
    d: "M-103.572,21.01l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.426 -17.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    className: "cls-348",
    d: "M-103.567,21l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.427 -17.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    className: "cls-348",
    d: "M-103.562,20.989l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.428 -17.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    className: "cls-348",
    d: "M-103.556,20.978l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.43 -17.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    className: "cls-348",
    d: "M-103.551,20.968l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.431 -17.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    className: "cls-349",
    d: "M-103.546,20.957l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.432 -17.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    className: "cls-349",
    d: "M-103.541,20.947l-1.817-.444.006-.013,1.817.444-.006.013",
    transform: "translate(106.434 -17.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    className: "cls-350",
    d: "M-103.536,20.936l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.435 -17.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    className: "cls-350",
    d: "M-103.53,20.926l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.436 -17.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    className: "cls-350",
    d: "M-103.525,20.915l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.437 -17.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    className: "cls-350",
    d: "M-103.52,20.9l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.439 -17.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    className: "cls-351",
    d: "M-103.515,20.894l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.44 -17.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    className: "cls-351",
    d: "M-103.51,20.884l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.441 -17.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    className: "cls-352",
    d: "M-103.5,20.873l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.443 -17.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    className: "cls-352",
    d: "M-103.5,20.863l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.444 -17.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    className: "cls-352",
    d: "M-103.494,20.852l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.446 -17.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    className: "cls-353",
    d: "M-103.489,20.842l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.447 -17.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    className: "cls-353",
    d: "M-103.483,20.832l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.448 -17.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    className: "cls-353",
    d: "M-103.478,20.821l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.45 -17.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    className: "cls-353",
    d: "M-103.472,20.811l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.451 -17.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    className: "cls-353",
    d: "M-103.467,20.8l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.452 -17.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    className: "cls-353",
    d: "M-103.461,20.79l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.454 -17.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    className: "cls-354",
    d: "M-103.456,20.779l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.455 -17.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    className: "cls-354",
    d: "M-103.45,20.768l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.457 -17.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    className: "cls-354",
    d: "M-103.445,20.758l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.458 -17.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    className: "cls-354",
    d: "M-103.439,20.747l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.459 -17.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    className: "cls-354",
    d: "M-103.434,20.737l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.461 -17.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    className: "cls-224",
    d: "M-103.428,20.727l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.462 -17.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    className: "cls-224",
    d: "M-103.422,20.716l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.464 -17.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    className: "cls-224",
    d: "M-103.417,20.706l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.465 -17.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    className: "cls-223",
    d: "M-103.411,20.7l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.466 -17.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    className: "cls-223",
    d: "M-103.405,20.685l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.468 -17.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    className: "cls-223",
    d: "M-103.4,20.675l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.469 -17.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    className: "cls-222",
    d: "M-103.394,20.664l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.471 -17.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    className: "cls-222",
    d: "M-103.388,20.654l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.472 -17.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    className: "cls-222",
    d: "M-103.383,20.644-105.2,20.2l.007-.013,1.817.444-.007.013",
    transform: "translate(106.474 -17.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    className: "cls-222",
    d: "M-103.377,20.633l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.475 -17.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    className: "cls-221",
    d: "M-103.371,20.623l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.477 -17.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    className: "cls-220",
    d: "M-103.365,20.613l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.478 -17.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    className: "cls-220",
    d: "M-103.36,20.6l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.479 -17.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    className: "cls-220",
    d: "M-103.354,20.592l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.481 -17.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    className: "cls-220",
    d: "M-103.348,20.582l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.482 -17.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    className: "cls-220",
    d: "M-103.342,20.572l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.484 -17.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    className: "cls-220",
    d: "M-103.337,20.562l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.486 -17.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    className: "cls-219",
    d: "M-103.331,20.551l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.487 -17.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    className: "cls-219",
    d: "M-103.325,20.541l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.488 -17.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    className: "cls-218",
    d: "M-103.319,20.531l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.49 -17.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    className: "cls-218",
    d: "M-103.313,20.521l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.491 -17.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    className: "cls-218",
    d: "M-103.307,20.511l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.493 -17.52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    className: "cls-217",
    d: "M-103.3,20.5l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.494 -17.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    className: "cls-217",
    d: "M-103.3,20.491l-1.817-.444.007-.013,1.817.444-.007.013",
    transform: "translate(106.496 -17.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    className: "cls-217",
    d: "M-103.289,20.481l-1.817-.444.008-.014,1.817.444-.008.014",
    transform: "translate(106.497 -17.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    className: "cls-216",
    d: "M-103.283,20.47l-1.817-.444.008-.014,1.817.444-.008.014",
    transform: "translate(106.499 -17.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    className: "cls-216",
    d: "M-103.276,20.458l-1.817-.444.008-.014,1.817.444-.008.014",
    transform: "translate(106.501 -17.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    className: "cls-215",
    d: "M-103.269,20.447-105.086,20l.009-.014,1.817.444-.009.014",
    transform: "translate(106.503 -17.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    className: "cls-214",
    d: "M-103.262,20.436l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.504 -17.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    className: "cls-214",
    d: "M-103.255,20.425l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.506 -17.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    className: "cls-214",
    d: "M-103.249,20.414l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.508 -17.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    className: "cls-214",
    d: "M-103.242,20.4l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.509 -17.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    className: "cls-214",
    d: "M-103.235,20.391l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.511 -17.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    className: "cls-213",
    d: "M-103.228,20.38l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.513 -17.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    className: "cls-213",
    d: "M-103.221,20.369l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.515 -17.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    className: "cls-212",
    d: "M-103.214,20.358l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.516 -17.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    className: "cls-212",
    d: "M-103.207,20.347l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.518 -17.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    className: "cls-212",
    d: "M-103.2,20.336l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.52 -17.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    className: "cls-212",
    d: "M-103.193,20.325l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.522 -17.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    className: "cls-211",
    d: "M-103.186,20.314-105,19.87l.009-.014,1.817.444-.009.014",
    transform: "translate(106.523 -17.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    className: "cls-210",
    d: "M-103.179,20.3-105,19.859l.009-.014,1.817.444-.009.014",
    transform: "translate(106.525 -17.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    className: "cls-210",
    d: "M-103.172,20.292l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.527 -17.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    className: "cls-210",
    d: "M-103.165,20.281l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.529 -17.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    className: "cls-209",
    d: "M-103.158,20.27l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.531 -17.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    className: "cls-208",
    d: "M-103.151,20.259l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.532 -17.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    className: "cls-208",
    d: "M-103.144,20.248l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.534 -17.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    className: "cls-208",
    d: "M-103.137,20.238l-1.817-.444.009-.014,1.817.444-.009.014",
    transform: "translate(106.536 -17.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    className: "cls-207",
    d: "M-103.13,20.227l-1.817-.444.009-.013,1.817.444-.009.013",
    transform: "translate(106.538 -17.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    className: "cls-227",
    d: "M-103.123,20.216l-1.817-.444.009-.013,1.817.444-.009.013",
    transform: "translate(106.54 -17.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    className: "cls-228",
    d: "M-103.115,20.205l-1.817-.444.009-.013,1.817.444-.009.013",
    transform: "translate(106.541 -17.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    className: "cls-229",
    d: "M-103.108,20.195l-1.817-.444.009-.013,1.817.444-.009.013",
    transform: "translate(106.543 -17.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    className: "cls-230",
    d: "M-103.1,20.184l-1.817-.444.009-.013,1.817.444-.009.013",
    transform: "translate(106.545 -17.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    className: "cls-231",
    d: "M-103.094,20.173l-1.817-.444.009-.013,1.817.444-.009.013",
    transform: "translate(106.547 -17.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    className: "cls-232",
    d: "M-103.087,20.163l-1.816-.444.011-.016,1.816.444-.011.016",
    transform: "translate(106.549 -17.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    className: "cls-233",
    d: "M-103.078,20.15l-1.816-.444.011-.018,1.816.445-.011.016",
    transform: "translate(106.551 -17.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    className: "cls-234",
    d: "M-103.069,20.137l-1.816-.445.011-.016,1.818.444-.013.018",
    transform: "translate(106.553 -17.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    className: "cls-235",
    d: "M-103.058,20.123l-1.818-.444.013-.018,1.816.444-.011.018",
    transform: "translate(106.556 -17.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    className: "cls-236",
    d: "M-103.05,20.109l-1.816-.444.011-.018,1.818.445-.013.016",
    transform: "translate(106.558 -17.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    className: "cls-237",
    d: "M-103.039,20.1l-1.818-.445.013-.016,1.816.444-.011.018",
    transform: "translate(106.561 -17.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    className: "cls-238",
    d: "M-103.031,20.082l-1.816-.444.013-.018,1.816.445-.013.016",
    transform: "translate(106.563 -17.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    className: "cls-239",
    d: "M-103.021,20.069l-1.816-.445.011-.016,1.818.444-.013.018",
    transform: "translate(106.566 -17.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    className: "cls-240",
    d: "M-103.01,20.055l-1.818-.444.013-.016,1.816.444-.011.016",
    transform: "translate(106.568 -17.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    className: "cls-241",
    d: "M-103,20.042l-1.816-.444.011-.018,1.818.445-.013.016",
    transform: "translate(106.57 -17.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    className: "cls-242",
    d: "M-102.992,20.029l-1.818-.445.013-.016,1.818.444-.013.018",
    transform: "translate(106.573 -17.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    className: "cls-243",
    d: "M-102.982,20.015l-1.818-.444.013-.016,1.816.444-.011.016",
    transform: "translate(106.575 -17.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    className: "cls-244",
    d: "M-102.973,20l-1.816-.444.013-.018,1.816.445-.013.016",
    transform: "translate(106.578 -17.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    className: "cls-245",
    d: "M-102.963,19.989l-1.816-.445.011-.016,1.818.445-.013.016",
    transform: "translate(106.58 -17.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    className: "cls-246",
    d: "M-102.952,19.976l-1.818-.445.013-.016,1.818.445-.013.016",
    transform: "translate(106.583 -17.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    className: "cls-247",
    d: "M-102.942,19.963l-1.818-.445.013-.016,1.818.444-.013.018",
    transform: "translate(106.585 -17.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    className: "cls-248",
    d: "M-102.932,19.949l-1.818-.444.013-.016,1.818.444-.013.016",
    transform: "translate(106.588 -17.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    className: "cls-249",
    d: "M-102.922,19.936l-1.818-.444.013-.016,1.816.444-.011.016",
    transform: "translate(106.59 -17.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    className: "cls-249",
    d: "M-102.914,19.923l-1.816-.444.013-.016,1.816.444-.013.016",
    transform: "translate(106.593 -17.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    className: "cls-250",
    d: "M-102.9,19.91l-1.816-.444.013-.016,1.816.444-.013.016",
    transform: "translate(106.595 -17.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    className: "cls-251",
    d: "M-102.894,19.9l-1.816-.444.013-.016,1.816.445-.013.015",
    transform: "translate(106.598 -17.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    className: "cls-252",
    d: "M-102.884,19.885l-1.816-.445.013-.016,1.816.445-.013.016",
    transform: "translate(106.6 -17.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    className: "cls-253",
    d: "M-102.874,19.872l-1.816-.445.013-.016,1.818.445-.014.016",
    transform: "translate(106.603 -17.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    className: "cls-254",
    d: "M-102.863,19.861l-1.818-.445.02-.025,1.818.444-.02.026",
    transform: "translate(106.605 -17.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    className: "cls-255",
    d: "M-102.846,19.84l-1.818-.444.02-.025,1.818.445-.02.024",
    transform: "translate(106.609 -17.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    className: "cls-138",
    d: "M-102.831,19.821l-1.818-.445.02-.025,1.818.445-.02.025",
    transform: "translate(106.614 -17.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    className: "cls-256",
    d: "M-102.815,19.8l-1.818-.445.02-.024,1.818.444-.02.025",
    transform: "translate(106.618 -17.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    className: "cls-257",
    d: "M-102.8,19.781l-1.818-.444.021-.025,1.816.444-.02.025",
    transform: "translate(106.622 -17.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    className: "cls-257",
    d: "M-102.783,19.761l-1.816-.444.02-.025,1.816.445-.02.024",
    transform: "translate(106.626 -17.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    className: "cls-258",
    d: "M-102.767,19.742l-1.816-.445.02-.024,1.818.444-.021.025",
    transform: "translate(106.63 -17.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    className: "cls-259",
    d: "M-102.749,19.722l-1.818-.444.021-.024,1.816.444-.02.024",
    transform: "translate(106.634 -17.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    className: "cls-260",
    d: "M-102.734,19.7l-1.816-.444.02-.024,1.818.444-.021.024",
    transform: "translate(106.638 -17.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    className: "cls-261",
    d: "M-102.716,19.684l-1.818-.444.021-.024,1.816.444-.02.024",
    transform: "translate(106.642 -17.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    className: "cls-262",
    d: "M-102.7,19.665l-1.816-.444.02-.024,1.818.444-.021.024",
    transform: "translate(106.647 -17.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    className: "cls-263",
    d: "M-102.683,19.646-104.5,19.2l.021-.024,1.818.444-.021.024",
    transform: "translate(106.651 -17.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    className: "cls-264",
    d: "M-102.666,19.627l-1.818-.444.021-.024,1.816.445-.02.023",
    transform: "translate(106.655 -17.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    className: "cls-265",
    d: "M-102.651,19.609l-1.816-.445.021-.023,1.816.444-.021.024",
    transform: "translate(106.659 -17.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    className: "cls-266",
    d: "M-102.634,19.593l-1.816-.444.039-.043,1.816.444-.039.043",
    transform: "translate(106.664 -17.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    className: "cls-267",
    d: "M-102.6,19.561l-1.816-.444.046-.05,1.818.444-.048.05",
    transform: "translate(106.672 -17.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    className: "cls-268",
    d: "M-102.564,19.521l-1.818-.444.048-.049,1.816.444-.046.049",
    transform: "translate(106.681 -17.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    className: "cls-269",
    d: "M-102.528,19.482l-1.816-.444.048-.049,1.816.445-.048.048",
    transform: "translate(106.691 -17.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    className: "cls-270",
    d: "M-102.49,19.444-104.306,19l.048-.048,1.818.445-.049.048",
    transform: "translate(106.7 -17.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    className: "cls-271",
    d: "M-102.45,19.405l-1.818-.445.049-.046,1.818.444-.049.048",
    transform: "translate(106.71 -17.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    className: "cls-272",
    d: "M-102.411,19.376l-1.818-.444.1-.09,1.816.445c-.033.029-.064.059-.1.089",
    transform: "translate(106.72 -17.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    className: "cls-271",
    d: "M-102.336,19.3l-1.816-.445.061-.055,1.818.444-.063.056",
    transform: "translate(106.739 -17.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    className: "cls-270",
    d: "M-102.285,19.253l-1.818-.444.063-.055,1.818.445-.063.054",
    transform: "translate(106.752 -17.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    className: "cls-269",
    d: "M-102.236,19.21l-1.818-.445.064-.053,1.818.444-.064.054",
    transform: "translate(106.764 -17.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    className: "cls-268",
    d: "M-102.185,19.166-104,18.723l.064-.053,1.818.445-.064.051",
    transform: "translate(106.777 -17.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    className: "cls-267",
    d: "M-102.134,19.122l-1.818-.445.043-.033,1.816.444-.041.034",
    transform: "translate(106.79 -17.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    className: "cls-266",
    d: "M-102.1,19.092l-1.816-.444.026-.021,1.818.445-.028.02",
    transform: "translate(106.799 -17.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    className: "cls-265",
    d: "M-102.078,19.076l-1.818-.445.028-.02,1.816.444-.026.021",
    transform: "translate(106.804 -17.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    className: "cls-264",
    d: "M-102.058,19.059l-1.816-.444.026-.021,1.818.445-.028.02",
    transform: "translate(106.81 -17.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    className: "cls-263",
    d: "M-102.035,19.043l-1.818-.445.028-.02,1.818.445-.028.02",
    transform: "translate(106.815 -17.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    className: "cls-262",
    d: "M-102.013,19.027l-1.818-.445.028-.02,1.818.445-.028.02",
    transform: "translate(106.821 -17.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    className: "cls-261",
    d: "M-101.992,19.011l-1.818-.445.028-.02,1.818.445-.028.02",
    transform: "translate(106.826 -17.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    className: "cls-260",
    d: "M-101.97,18.995l-1.818-.445.028-.019,1.818.444-.028.02",
    transform: "translate(106.832 -17.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    className: "cls-259",
    d: "M-101.947,18.979l-1.818-.444.028-.02,1.818.444-.028.02",
    transform: "translate(106.837 -17.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    className: "cls-258",
    d: "M-101.925,18.963l-1.818-.444.029-.019,1.816.444-.028.019",
    transform: "translate(106.843 -17.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    className: "cls-257",
    d: "M-101.9,18.948l-1.816-.444.028-.019,1.816.444-.028.019",
    transform: "translate(106.849 -17.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    className: "cls-257",
    d: "M-101.882,18.933l-1.816-.444.028-.019,1.818.444-.029.019",
    transform: "translate(106.854 -17.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    className: "cls-256",
    d: "M-101.858,18.918l-1.818-.444.029-.019,1.816.444-.028.019",
    transform: "translate(106.86 -17.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    className: "cls-138",
    d: "M-101.837,18.9l-1.816-.444.034-.023,1.818.444-.035.023",
    transform: "translate(106.866 -17.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    className: "cls-255",
    d: "M-101.809,18.885l-1.818-.444.036-.023,1.816.444-.035.023",
    transform: "translate(106.873 -17.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    className: "cls-254",
    d: "M-101.781,18.867l-1.816-.444.035-.023,1.818.445-.036.021",
    transform: "translate(106.88 -17.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    className: "cls-253",
    d: "M-101.752,18.85l-1.818-.445.036-.021,1.816.444-.035.023",
    transform: "translate(106.887 -17.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    className: "cls-252",
    d: "M-101.724,18.832l-1.816-.444.035-.021,1.818.444-.036.021",
    transform: "translate(106.894 -17.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    className: "cls-251",
    d: "M-101.695,18.815l-1.818-.444.036-.021,1.816.445-.035.02",
    transform: "translate(106.901 -17.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    className: "cls-250",
    d: "M-101.667,18.8l-1.816-.445.036-.02,1.816.444-.036.021",
    transform: "translate(106.909 -17.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    className: "cls-249",
    d: "M-101.638,18.782l-1.816-.444.036-.02,1.816.444-.036.02",
    transform: "translate(106.916 -17.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    className: "cls-249",
    d: "M-101.609,18.766l-1.816-.444.036-.02,1.816.444-.036.02",
    transform: "translate(106.923 -17.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    className: "cls-248",
    d: "M-101.58,18.75l-1.816-.444.036-.02,1.818.445-.038.019",
    transform: "translate(106.931 -17.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    className: "cls-247",
    d: "M-101.549,18.736l-1.818-.445.048-.024,1.816.444-.046.025",
    transform: "translate(106.938 -17.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    className: "cls-246",
    d: "M-101.513,18.716l-1.816-.444.05-.026,1.818.445-.051.025",
    transform: "translate(106.948 -17.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    className: "cls-245",
    d: "M-101.471,18.7l-1.818-.445.051-.024,1.816.444-.05.025",
    transform: "translate(106.958 -17.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    className: "cls-244",
    d: "M-101.432,18.676l-1.816-.444.05-.025,1.818.445-.051.024",
    transform: "translate(106.968 -17.988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    className: "cls-243",
    d: "M-101.391,18.657l-1.818-.445.051-.023,1.818.444-.051.024",
    transform: "translate(106.979 -17.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    className: "cls-242",
    d: "M-101.349,18.637l-1.818-.444.051-.023,1.818.444-.051.023",
    transform: "translate(106.989 -17.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    className: "cls-241",
    d: "M-101.309,18.619l-1.818-.444.053-.023,1.816.445-.051.021",
    transform: "translate(106.999 -18.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    className: "cls-240",
    d: "M-101.268,18.6l-1.816-.445.045-.018,1.816.444-.045.019",
    transform: "translate(107.01 -18.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    className: "cls-239",
    d: "M-101.232,18.585l-1.816-.444.029-.011,1.816.444-.029.011",
    transform: "translate(107.019 -18.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    className: "cls-238",
    d: "M-101.209,18.576l-1.816-.444.029-.011,1.816.444-.029.011",
    transform: "translate(107.025 -18.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    className: "cls-237",
    d: "M-101.186,18.567-103,18.123l.029-.011,1.816.444-.029.011",
    transform: "translate(107.031 -18.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    className: "cls-236",
    d: "M-101.163,18.558l-1.816-.444.029-.011,1.818.445-.03.01",
    transform: "translate(107.037 -18.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    className: "cls-235",
    d: "M-101.139,18.55l-1.818-.445.029-.01,1.818.444-.029.011",
    transform: "translate(107.042 -18.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    className: "cls-234",
    d: "M-101.116,18.541l-1.818-.444.03-.01,1.816.444-.029.01",
    transform: "translate(107.048 -18.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    className: "cls-233",
    d: "M-101.093,18.533l-1.816-.444.029-.01,1.816.444-.029.01",
    transform: "translate(107.054 -18.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    className: "cls-232",
    d: "M-101.07,18.525l-1.816-.444.029-.01,1.818.444-.03.01",
    transform: "translate(107.06 -18.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    className: "cls-231",
    d: "M-101.046,18.517l-1.818-.444.03-.01,1.816.445-.029.009",
    transform: "translate(107.066 -18.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    className: "cls-230",
    d: "M-101.023,18.51l-1.816-.445.029-.009,1.818.444-.03.01",
    transform: "translate(107.072 -18.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    className: "cls-229",
    d: "M-101,18.5l-1.818-.444.03-.01,1.818.445-.03.009",
    transform: "translate(107.078 -18.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    className: "cls-228",
    d: "M-100.975,18.495l-1.818-.445.03-.009,1.816.445-.029.009",
    transform: "translate(107.084 -18.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    className: "cls-227",
    d: "M-100.952,18.488l-1.816-.445.029-.009,1.818.445-.03.009",
    transform: "translate(107.09 -18.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    className: "cls-207",
    d: "M-100.928,18.479l-1.817-.444.009,0,1.817.444-.009,0",
    transform: "translate(107.096 -18.032)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(3.421 38.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    className: "cls-44",
    d: "M-109.129,41.887l-1.817-.444-.016-1.947,1.817.444Z",
    transform: "translate(110.961 -39.496)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    className: "cls-10",
    transform: "translate(5.544 28.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    className: "cls-355",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    className: "cls-10",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    className: "cls-279",
    d: "M-107.428,38.477l-1.817-.444v-.009l1.817.444v.009",
    transform: "translate(109.274 -30.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    className: "cls-279",
    d: "M-107.429,38.479l-1.816-.445-.005-.056,1.816.445.005.056",
    transform: "translate(109.273 -30.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    className: "cls-279",
    d: "M-107.433,38.433l-1.816-.445,0-.048,1.816.445,0,.048",
    transform: "translate(109.272 -30.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    className: "cls-279",
    d: "M-107.436,38.4l-1.816-.445,0-.051,1.816.444,0,.053",
    transform: "translate(109.271 -30.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    className: "cls-280",
    d: "M-107.439,38.354l-1.816-.444,0-.058,1.816.445,0,.056",
    transform: "translate(109.27 -30.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    className: "cls-280",
    d: "M-107.442,38.307l-1.816-.445,0-.045,1.818.445v.045",
    transform: "translate(109.27 -30.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    className: "cls-280",
    d: "M-107.443,38.272l-1.818-.445,0-.049,1.818.445,0,.049",
    transform: "translate(109.269 -30.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    className: "cls-280",
    d: "M-107.445,38.233l-1.818-.445v-.051l1.816.444,0,.053",
    transform: "translate(109.269 -30.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    className: "cls-280",
    d: "M-107.447,38.192l-1.816-.444,0-.055,1.818.445v.054",
    transform: "translate(109.268 -30.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    className: "cls-281",
    d: "M-107.448,38.146l-1.818-.445V37.66l1.816.444v.043",
    transform: "translate(109.268 -30.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    className: "cls-282",
    d: "M-107.45,38.113l-1.816-.444v-.044l1.818.444v.044",
    transform: "translate(109.268 -30.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    className: "cls-282",
    d: "M-107.45,38.078l-1.818-.444v-.045l1.816.444v.045",
    transform: "translate(109.268 -30.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    className: "cls-283",
    d: "M-107.45,38.042l-1.816-.444v-.046l1.818.444v.046",
    transform: "translate(109.268 -30.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    className: "cls-283",
    d: "M-107.45,38.006l-1.818-.444c0-.016,0-.033,0-.049l1.816.444v.049",
    transform: "translate(109.268 -30.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    className: "cls-283",
    d: "M-107.451,37.966l-1.816-.444v-.044l1.816.444v.044",
    transform: "translate(109.268 -30.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    className: "cls-284",
    d: "M-107.451,37.93l-1.816-.444v-.039l1.818.445v.038",
    transform: "translate(109.268 -30.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    className: "cls-284",
    d: "M-107.45,37.9l-1.818-.445v-.038l1.816.444V37.9",
    transform: "translate(109.268 -30.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    className: "cls-284",
    d: "M-107.45,37.869l-1.816-.444v-.04l1.818.445v.039",
    transform: "translate(109.268 -30.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    className: "cls-284",
    d: "M-107.448,37.838l-1.818-.445v-.04l1.818.445v.04",
    transform: "translate(109.268 -30.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    className: "cls-284",
    d: "M-107.447,37.806l-1.818-.445V37.32l1.818.445v.041",
    transform: "translate(109.269 -30.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    className: "cls-285",
    d: "M-107.447,37.773l-1.818-.445v-.041l1.818.445v.041",
    transform: "translate(109.269 -30.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    className: "cls-286",
    d: "M-107.446,37.741l-1.818-.445,0-.043,1.816.445v.043",
    transform: "translate(109.269 -30.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    className: "cls-286",
    d: "M-107.445,37.705l-1.816-.445v-.035l1.818.445,0,.035",
    transform: "translate(109.27 -30.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    className: "cls-286",
    d: "M-107.442,37.677l-1.818-.445V37.2l1.818.445v.033",
    transform: "translate(109.27 -30.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    className: "cls-287",
    d: "M-107.442,37.651l-1.818-.445,0-.034,1.816.445v.034",
    transform: "translate(109.27 -30.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    className: "cls-287",
    d: "M-107.441,37.624l-1.816-.445v-.034l1.818.445,0,.034",
    transform: "translate(109.271 -30.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    className: "cls-288",
    d: "M-107.439,37.6l-1.818-.445,0-.034,1.818.444,0,.035",
    transform: "translate(109.271 -30.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    className: "cls-288",
    d: "M-107.436,37.569l-1.818-.444,0-.035,1.816.445v.034",
    transform: "translate(109.272 -30.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    className: "cls-289",
    d: "M-107.436,37.542l-1.816-.445,0-.035,1.816.445,0,.035",
    transform: "translate(109.272 -30.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    className: "cls-289",
    d: "M-107.434,37.514l-1.816-.445,0-.035,1.816.445,0,.035",
    transform: "translate(109.273 -30.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    className: "cls-289",
    d: "M-107.432,37.486l-1.816-.445,0-.035,1.818.444,0,.036",
    transform: "translate(109.273 -30.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    className: "cls-289",
    d: "M-107.428,37.457l-1.818-.444,0-.036,1.816.444,0,.036",
    transform: "translate(109.274 -30.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    className: "cls-290",
    d: "M-107.427,37.427l-1.816-.444,0-.029,1.816.445,0,.028",
    transform: "translate(109.274 -30.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    className: "cls-290",
    d: "M-107.425,37.4l-1.816-.445v-.024l1.818.444,0,.025",
    transform: "translate(109.275 -30.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    className: "cls-290",
    d: "M-107.422,37.384l-1.818-.444,0-.025,1.818.444,0,.025",
    transform: "translate(109.275 -30.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    className: "cls-290",
    d: "M-107.42,37.364l-1.818-.444,0-.025,1.818.444,0,.025",
    transform: "translate(109.276 -30.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    className: "cls-291",
    d: "M-107.419,37.344l-1.818-.444,0-.025,1.818.444,0,.025",
    transform: "translate(109.276 -30.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    className: "cls-292",
    d: "M-107.416,37.324l-1.818-.444,0-.025,1.818.444,0,.025",
    transform: "translate(109.277 -30.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    className: "cls-292",
    d: "M-107.415,37.3l-1.818-.444,0-.025,1.818.444,0,.025",
    transform: "translate(109.277 -30.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    className: "cls-293",
    d: "M-107.413,37.284l-1.818-.444,0-.026,1.818.445,0,.025",
    transform: "translate(109.278 -30.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    className: "cls-293",
    d: "M-107.41,37.264l-1.818-.445,0-.025,1.816.444,0,.026",
    transform: "translate(109.278 -30.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    className: "cls-293",
    d: "M-107.409,37.243l-1.816-.444,0-.026,1.816.445,0,.025",
    transform: "translate(109.279 -30.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    className: "cls-293",
    d: "M-107.407,37.223l-1.816-.445,0-.026,1.818.445,0,.026",
    transform: "translate(109.279 -30.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    className: "cls-294",
    d: "M-107.4,37.2l-1.818-.445,0-.025,1.816.444,0,.026",
    transform: "translate(109.28 -30.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    className: "cls-295",
    d: "M-107.4,37.181l-1.816-.444,0-.026,1.818.444,0,.026",
    transform: "translate(109.281 -30.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    className: "cls-295",
    d: "M-107.4,37.16l-1.818-.444,0-.026,1.818.444,0,.026",
    transform: "translate(109.281 -30.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    className: "cls-295",
    d: "M-107.4,37.139l-1.818-.444,0-.028,1.816.445,0,.026",
    transform: "translate(109.282 -30.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    className: "cls-295",
    d: "M-107.394,37.118l-1.816-.445,0-.024,1.818.445,0,.024",
    transform: "translate(109.283 -30.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    className: "cls-296",
    d: "M-107.391,37.1l-1.818-.445,0-.021,1.816.444,0,.023",
    transform: "translate(109.283 -30.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    className: "cls-296",
    d: "M-107.389,37.08l-1.816-.444,0-.023,1.818.445,0,.021",
    transform: "translate(109.284 -30.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    className: "cls-296",
    d: "M-107.385,37.063l-1.818-.445,0-.021,1.816.444,0,.023",
    transform: "translate(109.284 -30.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    className: "cls-296",
    d: "M-107.384,37.045-109.2,36.6l0-.023,1.818.445,0,.021",
    transform: "translate(109.285 -30.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    className: "cls-297",
    d: "M-107.38,37.028l-1.818-.445,0-.021,1.816.444,0,.023",
    transform: "translate(109.286 -30.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    className: "cls-298",
    d: "M-107.379,37.01l-1.816-.444,0-.023,1.818.444,0,.023",
    transform: "translate(109.287 -30.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    className: "cls-299",
    d: "M-107.375,36.992l-1.818-.444,0-.023,1.818.444,0,.023",
    transform: "translate(109.287 -30.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    className: "cls-299",
    d: "M-107.372,36.974l-1.818-.444,0-.023,1.816.445,0,.021",
    transform: "translate(109.288 -30.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    className: "cls-299",
    d: "M-107.371,36.958l-1.816-.445,0-.023,1.816.445,0,.023",
    transform: "translate(109.289 -30.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    className: "cls-299",
    d: "M-107.368,36.94l-1.816-.445,0-.023,1.818.445,0,.023",
    transform: "translate(109.289 -30.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    className: "cls-299",
    d: "M-107.364,36.922l-1.818-.445,0-.023,1.818.445,0,.023",
    transform: "translate(109.29 -30.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    className: "cls-300",
    d: "M-107.362,36.9l-1.818-.445,0-.023,1.818.444,0,.024",
    transform: "translate(109.291 -30.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    className: "cls-301",
    d: "M-107.358,36.884l-1.818-.444,0-.023,1.818.444,0,.023",
    transform: "translate(109.291 -30.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    className: "cls-301",
    d: "M-107.356,36.866l-1.818-.444.005-.023,1.816.444,0,.023",
    transform: "translate(109.292 -30.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    className: "cls-301",
    d: "M-107.353,36.849l-1.816-.444,0-.024,1.816.445,0,.023",
    transform: "translate(109.293 -30.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    className: "cls-301",
    d: "M-107.35,36.831l-1.816-.445,0-.023,1.816.444,0,.024",
    transform: "translate(109.294 -31.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    className: "cls-301",
    d: "M-107.347,36.812l-1.816-.444,0-.024,1.818.445,0,.023",
    transform: "translate(109.295 -31.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    className: "cls-302",
    d: "M-107.342,36.794l-1.818-.445.005-.023,1.816.444,0,.024",
    transform: "translate(109.295 -31.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    className: "cls-302",
    d: "M-107.34,36.773l-1.816-.444,0-.018,1.818.444,0,.018",
    transform: "translate(109.296 -31.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    className: "cls-302",
    d: "M-107.337,36.76l-1.818-.444,0-.019,1.816.445,0,.018",
    transform: "translate(109.297 -31.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    className: "cls-303",
    d: "M-107.335,36.746l-1.816-.445,0-.018,1.816.444,0,.019",
    transform: "translate(109.298 -31.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    className: "cls-303",
    d: "M-107.332,36.73l-1.816-.444,0-.018,1.818.444,0,.018",
    transform: "translate(109.298 -31.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    className: "cls-304",
    d: "M-107.329,36.717l-1.818-.444,0-.019,1.818.445,0,.018",
    transform: "translate(109.299 -31.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    className: "cls-304",
    d: "M-107.326,36.7l-1.818-.445,0-.018,1.818.444,0,.019",
    transform: "translate(109.3 -31.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    className: "cls-304",
    d: "M-107.323,36.688l-1.818-.444,0-.019,1.816.445,0,.018",
    transform: "translate(109.301 -31.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    className: "cls-304",
    d: "M-107.321,36.674l-1.816-.445,0-.018,1.816.444,0,.019",
    transform: "translate(109.301 -31.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    className: "cls-304",
    d: "M-107.318,36.659l-1.816-.444,0-.019,1.816.445,0,.018",
    transform: "translate(109.302 -31.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    className: "cls-304",
    d: "M-107.315,36.645l-1.816-.445,0-.018,1.816.444,0,.019",
    transform: "translate(109.303 -31.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    className: "cls-305",
    d: "M-107.312,36.63l-1.816-.444,0-.019,1.816.445,0,.018",
    transform: "translate(109.304 -31.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    className: "cls-306",
    d: "M-107.309,36.616l-1.816-.445,0-.018,1.816.444,0,.019",
    transform: "translate(109.304 -31.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    className: "cls-306",
    d: "M-107.306,36.6l-1.816-.444,0-.019,1.816.444,0,.019",
    transform: "translate(109.305 -31.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    className: "cls-306",
    d: "M-107.3,36.586l-1.816-.444,0-.019,1.818.445,0,.018",
    transform: "translate(109.306 -31.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    className: "cls-306",
    d: "M-107.3,36.572l-1.818-.445,0-.019,1.818.445,0,.019",
    transform: "translate(109.306 -31.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    className: "cls-306",
    d: "M-107.3,36.557l-1.818-.445.005-.018,1.816.444,0,.019",
    transform: "translate(109.307 -31.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    className: "cls-307",
    d: "M-107.293,36.542l-1.816-.444,0-.019,1.816.444,0,.019",
    transform: "translate(109.308 -31.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    className: "cls-308",
    d: "M-107.29,36.527l-1.816-.444,0-.019,1.818.445-.005.018",
    transform: "translate(109.309 -31.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    className: "cls-308",
    d: "M-107.286,36.513l-1.818-.445.005-.019,1.816.445,0,.019",
    transform: "translate(109.31 -31.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    className: "cls-309",
    d: "M-107.283,36.5l-1.816-.445,0-.019,1.816.445,0,.019",
    transform: "translate(109.311 -31.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    className: "cls-309",
    d: "M-107.28,36.483l-1.816-.445,0-.018,1.818.444-.005.019",
    transform: "translate(109.312 -31.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    className: "cls-310",
    d: "M-107.275,36.468l-1.818-.444.005-.019,1.816.444,0,.019",
    transform: "translate(109.312 -31.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    className: "cls-310",
    d: "M-107.273,36.453l-1.816-.444,0-.019,1.818.444-.005.019",
    transform: "translate(109.313 -31.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    className: "cls-310",
    d: "M-107.269,36.438l-1.818-.444,0-.019,1.818.444-.005.019",
    transform: "translate(109.314 -31.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    className: "cls-310",
    d: "M-107.264,36.422l-1.818-.444,0-.015,1.818.444,0,.015",
    transform: "translate(109.315 -31.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    className: "cls-310",
    d: "M-107.261,36.41l-1.818-.444,0-.015,1.816.444,0,.015",
    transform: "translate(109.316 -31.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    className: "cls-310",
    d: "M-107.26,36.4l-1.816-.444,0-.015,1.816.444,0,.015",
    transform: "translate(109.317 -31.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    className: "cls-311",
    d: "M-107.257,36.386l-1.816-.444,0-.015,1.816.445,0,.014",
    transform: "translate(109.317 -31.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    className: "cls-311",
    d: "M-107.254,36.375l-1.816-.445,0-.014,1.816.444,0,.015",
    transform: "translate(109.318 -31.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    className: "cls-311",
    d: "M-107.251,36.363l-1.816-.444,0-.015,1.816.444,0,.015",
    transform: "translate(109.319 -31.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    className: "cls-311",
    d: "M-107.248,36.351l-1.816-.444,0-.015,1.816.444,0,.015",
    transform: "translate(109.32 -31.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    className: "cls-311",
    d: "M-107.245,36.339l-1.816-.444,0-.015,1.816.445,0,.014",
    transform: "translate(109.321 -31.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    className: "cls-312",
    d: "M-107.242,36.328l-1.816-.445,0-.015,1.816.445,0,.015",
    transform: "translate(109.321 -31.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    className: "cls-312",
    d: "M-107.239,36.316l-1.816-.445,0-.015,1.816.445,0,.015",
    transform: "translate(109.322 -31.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    className: "cls-312",
    d: "M-107.236,36.3l-1.816-.445,0-.014,1.816.444,0,.015",
    transform: "translate(109.323 -31.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    className: "cls-313",
    d: "M-107.233,36.292l-1.816-.444,0-.015,1.818.444-.005.015",
    transform: "translate(109.324 -31.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    className: "cls-313",
    d: "M-107.228,36.28l-1.818-.444,0-.015,1.818.444,0,.015",
    transform: "translate(109.324 -31.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    className: "cls-313",
    d: "M-107.226,36.268l-1.818-.444,0-.015,1.818.444,0,.015",
    transform: "translate(109.325 -31.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    className: "cls-9",
    d: "M-107.222,36.256l-1.818-.444.005-.015,1.816.444,0,.015",
    transform: "translate(109.326 -31.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    className: "cls-9",
    d: "M-107.22,36.244l-1.816-.444,0-.015,1.816.444,0,.015",
    transform: "translate(109.327 -31.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    className: "cls-9",
    d: "M-107.217,36.232l-1.816-.444,0-.015,1.818.445-.005.014",
    transform: "translate(109.327 -31.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    className: "cls-9",
    d: "M-107.213,36.221l-1.818-.445.005-.015,1.816.445,0,.015",
    transform: "translate(109.328 -31.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    className: "cls-9",
    d: "M-107.21,36.209l-1.816-.445,0-.015,1.816.445,0,.015",
    transform: "translate(109.329 -31.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    className: "cls-314",
    d: "M-107.207,36.2l-1.816-.445,0-.015,1.818.445-.005.015",
    transform: "translate(109.33 -31.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    className: "cls-314",
    d: "M-107.2,36.185l-1.818-.445,0-.015,1.816.445,0,.015",
    transform: "translate(109.331 -31.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    className: "cls-314",
    d: "M-107.2,36.173l-1.816-.445,0-.015,1.818.445-.005.015",
    transform: "translate(109.332 -31.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    className: "cls-314",
    d: "M-107.2,36.161l-1.818-.445,0-.015,1.816.445,0,.015",
    transform: "translate(109.333 -31.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    className: "cls-315",
    d: "M-107.193,36.149l-1.816-.445,0-.015,1.818.445,0,.015",
    transform: "translate(109.334 -31.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    className: "cls-315",
    d: "M-107.188,36.137l-1.818-.445.005-.015,1.816.444,0,.016",
    transform: "translate(109.334 -31.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    className: "cls-316",
    d: "M-107.186,36.124-109,35.68l0-.015,1.818.444,0,.015",
    transform: "translate(109.335 -31.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    className: "cls-316",
    d: "M-107.182,36.112-109,35.668l.005-.015,1.816.444,0,.015",
    transform: "translate(109.336 -31.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    className: "cls-317",
    d: "M-107.179,36.1l-1.816-.444,0-.015,1.818.444,0,.015",
    transform: "translate(109.337 -31.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    className: "cls-317",
    d: "M-107.175,36.088l-1.818-.444,0-.015,1.816.444,0,.015",
    transform: "translate(109.338 -31.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    className: "cls-317",
    d: "M-107.172,36.076l-1.816-.444.005-.015,1.816.444-.005.015",
    transform: "translate(109.339 -31.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    className: "cls-318",
    d: "M-107.168,36.064l-1.816-.444,0-.015,1.818.444-.005.015",
    transform: "translate(109.34 -31.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    className: "cls-318",
    d: "M-107.164,36.051l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.341 -31.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    className: "cls-318",
    d: "M-107.161,36.041l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.342 -31.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    className: "cls-318",
    d: "M-107.158,36.031l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.342 -31.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    className: "cls-318",
    d: "M-107.155,36.022l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.343 -31.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    className: "cls-319",
    d: "M-107.152,36.012l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.344 -31.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    className: "cls-320",
    d: "M-107.148,36l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.345 -31.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    className: "cls-320",
    d: "M-107.145,35.992l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.346 -31.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    className: "cls-321",
    d: "M-107.142,35.982l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.346 -31.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    className: "cls-321",
    d: "M-107.139,35.972l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.347 -31.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    className: "cls-321",
    d: "M-107.136,35.962l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.348 -31.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    className: "cls-322",
    d: "M-107.133,35.953l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.349 -31.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    className: "cls-322",
    d: "M-107.129,35.943l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.35 -31.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    className: "cls-323",
    d: "M-107.126,35.933l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.35 -31.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    className: "cls-323",
    d: "M-107.123,35.923l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.351 -31.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    className: "cls-323",
    d: "M-107.12,35.913l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.352 -31.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    className: "cls-323",
    d: "M-107.116,35.9l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.353 -31.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    className: "cls-324",
    d: "M-107.113,35.893l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.354 -31.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    className: "cls-324",
    d: "M-107.11,35.883l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.355 -31.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    className: "cls-324",
    d: "M-107.106,35.873l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.355 -31.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    className: "cls-324",
    d: "M-107.1,35.863l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.356 -31.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    className: "cls-325",
    d: "M-107.1,35.853l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.357 -31.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    className: "cls-326",
    d: "M-107.1,35.843l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.358 -31.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    className: "cls-326",
    d: "M-107.093,35.834l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.359 -31.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    className: "cls-326",
    d: "M-107.089,35.824l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.36 -31.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    className: "cls-326",
    d: "M-107.086,35.814l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.361 -31.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    className: "cls-326",
    d: "M-107.082,35.8l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.362 -31.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    className: "cls-326",
    d: "M-107.078,35.794l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.362 -31.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    className: "cls-327",
    d: "M-107.075,35.784l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.363 -31.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    className: "cls-328",
    d: "M-107.071,35.774l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.364 -31.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    className: "cls-328",
    d: "M-107.068,35.764l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.365 -31.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    className: "cls-328",
    d: "M-107.064,35.754l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.366 -31.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    className: "cls-328",
    d: "M-107.06,35.744l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.367 -31.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    className: "cls-329",
    d: "M-107.057,35.734l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.368 -31.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    className: "cls-329",
    d: "M-107.053,35.724l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.369 -31.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    className: "cls-329",
    d: "M-107.049,35.714l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.37 -31.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    className: "cls-329",
    d: "M-107.046,35.7l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.371 -31.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    className: "cls-330",
    d: "M-107.042,35.694l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.372 -31.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    className: "cls-331",
    d: "M-107.038,35.684l-1.817-.444,0-.013,1.817.444,0,.013",
    transform: "translate(109.373 -31.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    className: "cls-332",
    d: "M-107.034,35.673l-1.817-.444,0-.012,1.817.444,0,.012",
    transform: "translate(109.374 -31.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    className: "cls-332",
    d: "M-107.031,35.664l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.375 -31.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    className: "cls-332",
    d: "M-107.027,35.655l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.375 -31.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    className: "cls-332",
    d: "M-107.024,35.647l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.376 -31.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    className: "cls-332",
    d: "M-107.021,35.638l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.377 -31.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    className: "cls-333",
    d: "M-107.017,35.629l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.378 -31.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    className: "cls-333",
    d: "M-107.014,35.62l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.379 -31.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    className: "cls-334",
    d: "M-107.01,35.612l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.38 -31.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    className: "cls-334",
    d: "M-107.007,35.6l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.381 -31.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    className: "cls-334",
    d: "M-107,35.594l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.381 -31.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    className: "cls-334",
    d: "M-107,35.586l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.382 -31.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    className: "cls-335",
    d: "M-107,35.577l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.383 -31.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    className: "cls-335",
    d: "M-106.993,35.568l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.384 -31.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    className: "cls-336",
    d: "M-106.99,35.559l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.385 -31.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    className: "cls-336",
    d: "M-106.986,35.551l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.386 -31.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    className: "cls-337",
    d: "M-106.982,35.542-108.8,35.1l0-.011,1.817.444,0,.011",
    transform: "translate(109.387 -31.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    className: "cls-338",
    d: "M-106.979,35.533l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.388 -31.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    className: "cls-338",
    d: "M-106.975,35.524l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.389 -31.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    className: "cls-338",
    d: "M-106.972,35.516l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.39 -31.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    className: "cls-338",
    d: "M-106.968,35.507l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.391 -31.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    className: "cls-338",
    d: "M-106.964,35.5l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.391 -31.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    className: "cls-338",
    d: "M-106.961,35.489l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.392 -31.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    className: "cls-339",
    d: "M-106.957,35.481l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.393 -31.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    className: "cls-340",
    d: "M-106.953,35.472l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.394 -31.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    className: "cls-340",
    d: "M-106.95,35.463l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.395 -31.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    className: "cls-340",
    d: "M-106.946,35.454l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.396 -31.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    className: "cls-340",
    d: "M-106.942,35.445-108.759,35l0-.011,1.817.444,0,.011",
    transform: "translate(109.397 -31.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    className: "cls-340",
    d: "M-106.938,35.437l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.398 -31.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    className: "cls-341",
    d: "M-106.934,35.428l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.399 -31.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    className: "cls-341",
    d: "M-106.931,35.419l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.4 -31.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    className: "cls-341",
    d: "M-106.927,35.41l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.401 -31.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    className: "cls-342",
    d: "M-106.923,35.4l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.402 -31.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    className: "cls-342",
    d: "M-106.919,35.393l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.403 -31.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    className: "cls-343",
    d: "M-106.915,35.384l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.404 -31.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    className: "cls-343",
    d: "M-106.911,35.375l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.405 -31.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    className: "cls-343",
    d: "M-106.907,35.366l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.406 -31.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    className: "cls-343",
    d: "M-106.9,35.358l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.407 -31.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    className: "cls-343",
    d: "M-106.9,35.349l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.408 -31.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    className: "cls-343",
    d: "M-106.9,35.34l-1.817-.444,0-.011,1.817.444-.005.011",
    transform: "translate(109.409 -31.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    className: "cls-344",
    d: "M-106.891,35.331l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.41 -31.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    className: "cls-344",
    d: "M-106.887,35.323l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.411 -31.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    className: "cls-344",
    d: "M-106.883,35.314l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.412 -31.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    className: "cls-344",
    d: "M-106.879,35.3l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.413 -31.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    className: "cls-345",
    d: "M-106.875,35.3l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.414 -31.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    className: "cls-346",
    d: "M-106.871,35.287l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.415 -31.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    className: "cls-346",
    d: "M-106.867,35.279l-1.817-.444,0-.011,1.817.444,0,.011",
    transform: "translate(109.416 -31.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    className: "cls-346",
    d: "M-106.863,35.27l-1.817-.444.005-.011,1.817.444,0,.011",
    transform: "translate(109.417 -31.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    className: "cls-347",
    d: "M-106.859,35.262l-1.817-.444.005-.011,1.817.444,0,.011",
    transform: "translate(109.418 -31.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    className: "cls-347",
    d: "M-106.855,35.253l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.419 -31.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    className: "cls-347",
    d: "M-106.851,35.245l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.42 -31.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    className: "cls-348",
    d: "M-106.847,35.236l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.421 -31.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    className: "cls-348",
    d: "M-106.843,35.228l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.422 -31.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    className: "cls-348",
    d: "M-106.839,35.22l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.423 -31.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    className: "cls-348",
    d: "M-106.835,35.211l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.424 -31.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    className: "cls-348",
    d: "M-106.831,35.2l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.425 -31.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    className: "cls-349",
    d: "M-106.827,35.194l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.426 -31.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    className: "cls-349",
    d: "M-106.823,35.186l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.427 -31.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    className: "cls-350",
    d: "M-106.818,35.177l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.428 -31.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    className: "cls-350",
    d: "M-106.814,35.169l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.43 -31.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    className: "cls-350",
    d: "M-106.81,35.16l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.431 -31.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    className: "cls-350",
    d: "M-106.806,35.152l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.432 -31.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    className: "cls-351",
    d: "M-106.8,35.144l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.433 -31.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    className: "cls-351",
    d: "M-106.8,35.135l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.434 -31.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    className: "cls-352",
    d: "M-106.793,35.127l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.435 -31.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    className: "cls-352",
    d: "M-106.789,35.118l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.436 -31.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    className: "cls-352",
    d: "M-106.784,35.11l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.437 -31.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    className: "cls-353",
    d: "M-106.78,35.1l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.438 -31.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    className: "cls-353",
    d: "M-106.776,35.093l-1.817-.444.005-.011,1.817.444-.005.011",
    transform: "translate(109.439 -31.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    className: "cls-353",
    d: "M-106.771,35.084l-1.817-.444.005-.011,1.817.444-.006.011",
    transform: "translate(109.44 -31.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    className: "cls-353",
    d: "M-106.767,35.076l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.441 -31.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    className: "cls-353",
    d: "M-106.763,35.067l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.443 -31.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    className: "cls-353",
    d: "M-106.758,35.059l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.444 -31.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    className: "cls-354",
    d: "M-106.754,35.051l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.445 -31.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    className: "cls-354",
    d: "M-106.749,35.042l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.446 -31.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    className: "cls-354",
    d: "M-106.745,35.034l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.447 -31.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    className: "cls-354",
    d: "M-106.74,35.025l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.448 -31.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    className: "cls-354",
    d: "M-106.736,35.017l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.449 -31.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    className: "cls-224",
    d: "M-106.731,35.008l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.45 -31.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    className: "cls-224",
    d: "M-106.727,35l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.452 -31.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    className: "cls-224",
    d: "M-106.722,34.992l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.453 -31.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    className: "cls-223",
    d: "M-106.718,34.983l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.454 -31.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    className: "cls-223",
    d: "M-106.713,34.975l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.455 -31.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    className: "cls-223",
    d: "M-106.709,34.966l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.456 -31.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    className: "cls-222",
    d: "M-106.7,34.958l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.457 -31.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    className: "cls-222",
    d: "M-106.7,34.949l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.459 -31.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    className: "cls-222",
    d: "M-106.695,34.941l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.46 -31.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    className: "cls-222",
    d: "M-106.69,34.932l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.461 -31.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    className: "cls-221",
    d: "M-106.685,34.924l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.462 -31.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    className: "cls-220",
    d: "M-106.681,34.916l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.463 -31.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    className: "cls-220",
    d: "M-106.676,34.907l-1.817-.444.006-.011,1.817.444-.006.011",
    transform: "translate(109.465 -31.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    className: "cls-220",
    d: "M-106.671,34.9l-1.817-.444.007-.011,1.817.444-.007.011",
    transform: "translate(109.466 -31.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    className: "cls-220",
    d: "M-106.666,34.89l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.467 -31.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    className: "cls-220",
    d: "M-106.66,34.88l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.468 -31.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    className: "cls-220",
    d: "M-106.655,34.871l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.47 -31.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    className: "cls-219",
    d: "M-106.649,34.861l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.471 -31.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    className: "cls-219",
    d: "M-106.644,34.852l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.473 -31.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    className: "cls-218",
    d: "M-106.638,34.842l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.474 -31.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    className: "cls-218",
    d: "M-106.632,34.832l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.475 -31.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    className: "cls-218",
    d: "M-106.627,34.823l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.477 -31.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    className: "cls-217",
    d: "M-106.621,34.813l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.478 -31.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    className: "cls-217",
    d: "M-106.616,34.8l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.48 -31.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    className: "cls-217",
    d: "M-106.61,34.794l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.481 -31.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    className: "cls-216",
    d: "M-106.6,34.784l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.483 -31.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    className: "cls-216",
    d: "M-106.6,34.775l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.484 -31.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    className: "cls-215",
    d: "M-106.593,34.765l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.486 -31.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    className: "cls-214",
    d: "M-106.587,34.756l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.487 -31.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    className: "cls-214",
    d: "M-106.581,34.746-108.4,34.3l.007-.012,1.817.444-.007.012",
    transform: "translate(109.489 -31.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    className: "cls-214",
    d: "M-106.575,34.737l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.49 -31.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    className: "cls-214",
    d: "M-106.569,34.727l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.492 -31.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    className: "cls-214",
    d: "M-106.563,34.718l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.493 -31.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    className: "cls-213",
    d: "M-106.557,34.708l-1.817-.444.007-.012,1.817.444-.007.012",
    transform: "translate(109.495 -31.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    className: "cls-213",
    d: "M-106.551,34.7l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.496 -31.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    className: "cls-212",
    d: "M-106.545,34.689l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.498 -31.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    className: "cls-212",
    d: "M-106.54,34.679l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.499 -31.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    className: "cls-212",
    d: "M-106.533,34.67l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.501 -31.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    className: "cls-212",
    d: "M-106.527,34.66l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.502 -31.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    className: "cls-211",
    d: "M-106.521,34.651l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.504 -31.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    className: "cls-210",
    d: "M-106.515,34.641l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.505 -31.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    className: "cls-210",
    d: "M-106.509,34.632l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.507 -31.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    className: "cls-210",
    d: "M-106.5,34.622l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.508 -31.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    className: "cls-209",
    d: "M-106.5,34.613l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.51 -31.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    className: "cls-208",
    d: "M-106.49,34.6l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.511 -31.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    className: "cls-208",
    d: "M-106.484,34.594l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.513 -31.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    className: "cls-208",
    d: "M-106.478,34.584l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.515 -31.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    className: "cls-207",
    d: "M-106.472,34.575l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.516 -31.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    className: "cls-227",
    d: "M-106.465,34.565l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.518 -31.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    className: "cls-228",
    d: "M-106.459,34.556l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.52 -31.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    className: "cls-229",
    d: "M-106.453,34.546l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.521 -31.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    className: "cls-230",
    d: "M-106.446,34.537l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.523 -31.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    className: "cls-231",
    d: "M-106.44,34.527l-1.817-.444.008-.012,1.817.444-.008.012",
    transform: "translate(109.524 -31.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    className: "cls-232",
    d: "M-106.433,34.518l-1.817-.444.009-.013,1.817.444-.009.013",
    transform: "translate(109.526 -31.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    className: "cls-233",
    d: "M-106.425,34.508l-1.818-.445.011-.016,1.818.444-.011.018",
    transform: "translate(109.528 -31.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    className: "cls-234",
    d: "M-106.416,34.494l-1.818-.444.013-.018,1.816.444-.011.018",
    transform: "translate(109.53 -31.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    className: "cls-235",
    d: "M-106.408,34.48l-1.816-.444.013-.018,1.816.445-.013.016",
    transform: "translate(109.533 -31.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    className: "cls-236",
    d: "M-106.4,34.467l-1.816-.445.011-.016,1.818.444-.013.018",
    transform: "translate(109.535 -31.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    className: "cls-237",
    d: "M-106.388,34.453l-1.818-.444.013-.018,1.816.444-.011.018",
    transform: "translate(109.537 -31.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    className: "cls-238",
    d: "M-106.379,34.439-108.2,34l.013-.018,1.816.445-.013.016",
    transform: "translate(109.54 -31.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    className: "cls-239",
    d: "M-106.369,34.426l-1.816-.445.011-.016,1.818.444-.013.018",
    transform: "translate(109.543 -31.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    className: "cls-240",
    d: "M-106.358,34.412l-1.818-.444.013-.018,1.818.445-.013.016",
    transform: "translate(109.545 -31.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    className: "cls-241",
    d: "M-106.348,34.4l-1.818-.445.013-.016,1.818.444-.013.018",
    transform: "translate(109.547 -31.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    className: "cls-242",
    d: "M-106.338,34.385l-1.818-.444.013-.018,1.818.444-.013.018",
    transform: "translate(109.55 -31.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    className: "cls-243",
    d: "M-106.328,34.371l-1.818-.444.013-.018,1.818.445-.013.016",
    transform: "translate(109.552 -31.622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    className: "cls-244",
    d: "M-106.318,34.358l-1.818-.445.013-.016,1.818.444-.013.018",
    transform: "translate(109.555 -31.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    className: "cls-245",
    d: "M-106.308,34.344l-1.818-.444.013-.018,1.818.445-.013.016",
    transform: "translate(109.557 -31.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    className: "cls-246",
    d: "M-106.3,34.331l-1.818-.445.013-.016,1.818.444-.013.018",
    transform: "translate(109.56 -31.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    className: "cls-247",
    d: "M-106.289,34.317l-1.818-.444.014-.018,1.816.444-.013.018",
    transform: "translate(109.563 -31.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    className: "cls-248",
    d: "M-106.279,34.3l-1.816-.444.013-.016,1.818.444-.014.016",
    transform: "translate(109.565 -31.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    className: "cls-249",
    d: "M-106.268,34.29l-1.818-.444.013-.018,1.818.444-.013.018",
    transform: "translate(109.568 -31.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    className: "cls-249",
    d: "M-106.257,34.276l-1.818-.444.014-.016,1.816.444-.013.016",
    transform: "translate(109.57 -31.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    className: "cls-250",
    d: "M-106.248,34.263l-1.816-.444.013-.018,1.818.444-.014.018",
    transform: "translate(109.573 -31.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    className: "cls-251",
    d: "M-106.237,34.249l-1.818-.444.014-.016,1.816.444-.013.016",
    transform: "translate(109.576 -31.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    className: "cls-252",
    d: "M-106.227,34.236l-1.816-.444.014-.018,1.816.445-.014.016",
    transform: "translate(109.579 -31.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    className: "cls-253",
    d: "M-106.216,34.223l-1.816-.445.013-.016,1.818.444-.014.018",
    transform: "translate(109.581 -31.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    className: "cls-254",
    d: "M-106.2,34.209l-1.818-.444.014-.018,1.816.445-.013.016",
    transform: "translate(109.584 -31.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    className: "cls-255",
    d: "M-106.195,34.2l-1.816-.445.014-.016,1.816.444-.014.018",
    transform: "translate(109.587 -31.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    className: "cls-138",
    d: "M-106.184,34.182-108,33.739l.014-.018,1.816.445-.014.016",
    transform: "translate(109.589 -31.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    className: "cls-256",
    d: "M-106.173,34.169l-1.816-.445.013-.016,1.818.444-.014.018",
    transform: "translate(109.592 -31.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    className: "cls-257",
    d: "M-106.161,34.155l-1.818-.444.014-.016,1.818.444-.014.016",
    transform: "translate(109.595 -31.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    className: "cls-257",
    d: "M-106.15,34.144l-1.818-.444.021-.025,1.818.444-.021.025",
    transform: "translate(109.598 -31.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    className: "cls-258",
    d: "M-106.133,34.126l-1.818-.444.029-.035,1.818.444-.029.035",
    transform: "translate(109.602 -31.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    className: "cls-259",
    d: "M-106.111,34.1l-1.818-.444.03-.035,1.816.445-.029.034",
    transform: "translate(109.608 -31.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    className: "cls-260",
    d: "M-106.088,34.071l-1.816-.445.029-.034,1.818.444-.03.035",
    transform: "translate(109.614 -31.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    className: "cls-261",
    d: "M-106.063,34.043l-1.818-.444.03-.035,1.818.445-.03.034",
    transform: "translate(109.62 -31.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    className: "cls-262",
    d: "M-106.039,34.016l-1.818-.445.031-.034,1.816.444-.03.035",
    transform: "translate(109.626 -31.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    className: "cls-263",
    d: "M-106.016,33.988l-1.816-.444.03-.034,1.818.444-.031.034",
    transform: "translate(109.632 -31.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    className: "cls-264",
    d: "M-105.99,33.961l-1.818-.444.031-.034,1.816.444-.03.034",
    transform: "translate(109.638 -31.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    className: "cls-265",
    d: "M-105.967,33.934l-1.816-.444.031-.035,1.816.445-.031.034",
    transform: "translate(109.644 -31.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    className: "cls-266",
    d: "M-105.942,33.907l-1.816-.445.031-.034,1.818.445-.033.034",
    transform: "translate(109.651 -31.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    className: "cls-267",
    d: "M-105.916,33.88l-1.818-.445.033-.034,1.816.445-.031.034",
    transform: "translate(109.657 -31.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    className: "cls-268",
    d: "M-105.891,33.853l-1.816-.445.033-.033,1.816.444-.033.034",
    transform: "translate(109.664 -31.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    className: "cls-269",
    d: "M-105.865,33.826l-1.816-.444.033-.034,1.818.444-.034.034",
    transform: "translate(109.67 -31.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    className: "cls-270",
    d: "M-105.837,33.824l-1.818-.444c.053-.054.107-.107.162-.159l1.818.444c-.055.053-.109.107-.162.159",
    transform: "translate(109.677 -31.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    className: "cls-271",
    d: "M-105.709,33.728l-1.818-.444c.113-.107.231-.211.355-.312l1.816.444c-.124.1-.242.207-.353.312",
    transform: "translate(109.71 -31.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    className: "cls-270",
    d: "M-105.427,33.422l-1.816-.444.035-.03,1.818.445-.036.029",
    transform: "translate(109.781 -31.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    className: "cls-269",
    d: "M-105.4,33.4l-1.818-.445.036-.029,1.818.444-.036.03",
    transform: "translate(109.788 -31.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    className: "cls-268",
    d: "M-105.368,33.375l-1.818-.444.038-.029,1.816.444-.036.029",
    transform: "translate(109.796 -31.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    className: "cls-267",
    d: "M-105.34,33.352l-1.816-.444.036-.029,1.818.444-.038.029",
    transform: "translate(109.803 -31.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    className: "cls-266",
    d: "M-105.31,33.329l-1.818-.444.038-.029,1.816.444-.036.029",
    transform: "translate(109.811 -31.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    className: "cls-265",
    d: "M-105.281,33.306l-1.816-.444.038-.029,1.816.444-.038.029",
    transform: "translate(109.818 -31.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    className: "cls-264",
    d: "M-105.251,33.283l-1.816-.444.038-.029,1.818.444-.039.029",
    transform: "translate(109.826 -31.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    className: "cls-263",
    d: "M-105.22,33.26l-1.818-.444.039-.029,1.816.445-.038.028",
    transform: "translate(109.834 -31.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    className: "cls-262",
    d: "M-105.19,33.238l-1.816-.445.039-.028,1.816.444-.039.029",
    transform: "translate(109.841 -31.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    className: "cls-261",
    d: "M-105.159,33.215l-1.816-.444.039-.029,1.816.445-.039.028",
    transform: "translate(109.849 -31.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    className: "cls-260",
    d: "M-105.128,33.193l-1.816-.445.039-.028,1.818.444-.04.029",
    transform: "translate(109.857 -31.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    className: "cls-259",
    d: "M-105.1,33.169l-1.818-.444.04-.028,1.816.444-.039.028",
    transform: "translate(109.865 -31.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    className: "cls-258",
    d: "M-105.065,33.147l-1.816-.444.04-.028,1.816.444-.04.028",
    transform: "translate(109.873 -31.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    className: "cls-257",
    d: "M-105.033,33.125l-1.816-.444.04-.028,1.818.444-.041.028",
    transform: "translate(109.881 -31.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    className: "cls-257",
    d: "M-105,33.1l-1.818-.444.053-.035,1.816.444L-105,33.1",
    transform: "translate(109.889 -31.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    className: "cls-256",
    d: "M-104.959,33.077l-1.816-.444.054-.036,1.818.445-.055.035",
    transform: "translate(109.9 -31.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    className: "cls-138",
    d: "M-104.914,33.049l-1.818-.445.055-.035,1.818.444-.055.036",
    transform: "translate(109.911 -31.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    className: "cls-255",
    d: "M-104.87,33.02l-1.818-.444.056-.035,1.816.444-.055.035",
    transform: "translate(109.922 -31.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    className: "cls-254",
    d: "M-104.827,32.992l-1.816-.444.056-.035,1.818.444-.058.035",
    transform: "translate(109.933 -31.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    className: "cls-253",
    d: "M-104.78,32.964l-1.818-.444.058-.035,1.816.445-.056.034",
    transform: "translate(109.945 -31.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    className: "cls-252",
    d: "M-104.736,32.937l-1.816-.445.058-.034,1.816.445-.058.034",
    transform: "translate(109.956 -31.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    className: "cls-251",
    d: "M-104.69,32.91l-1.816-.445.058-.034,1.818.444-.059.035",
    transform: "translate(109.968 -31.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    className: "cls-250",
    d: "M-104.643,32.882l-1.818-.444.059-.034,1.818.445-.059.033",
    transform: "translate(109.98 -32.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    className: "cls-249",
    d: "M-104.6,32.856l-1.818-.445.06-.033,1.816.444-.059.034",
    transform: "translate(109.992 -32.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    className: "cls-249",
    d: "M-104.549,32.829l-1.816-.444.061-.034,1.816.444-.061.034",
    transform: "translate(110.004 -32.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    className: "cls-248",
    d: "M-104.5,32.8l-1.816-.444.089-.048,1.816.444-.089.048",
    transform: "translate(110.016 -32.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    className: "cls-247",
    d: "M-104.429,32.766l-1.816-.444.09-.046,1.816.444-.09.046",
    transform: "translate(110.034 -32.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    className: "cls-246",
    d: "M-104.357,32.729l-1.816-.444.091-.046,1.818.444-.093.046",
    transform: "translate(110.052 -32.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    className: "cls-245",
    d: "M-104.282,32.692l-1.818-.444.094-.045,1.816.444-.093.045",
    transform: "translate(110.071 -32.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    className: "cls-244",
    d: "M-104.209,32.656l-1.816-.444.094-.045,1.818.445-.1.044",
    transform: "translate(110.09 -32.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    className: "cls-243",
    d: "M-104.132,32.621l-1.818-.445.1-.043,1.816.444-.1.044",
    transform: "translate(110.109 -32.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    className: "cls-242",
    d: "M-104.057,32.586l-1.816-.444.1-.044,1.816.445-.1.043",
    transform: "translate(110.129 -32.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    className: "cls-241",
    d: "M-103.979,32.546-105.8,32.1l.04-.016,1.816.444-.04.018",
    transform: "translate(110.148 -32.085)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(3.287 37.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    className: "cls-202",
    d: "M-109.118,39.968l-1.817-.444-.134-.136,1.817.444Z",
    transform: "translate(111.068 -39.388)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(4.973 38.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    className: "cls-203",
    d: "M-109.592,39.742l.134.136.016,1.947,1.391-.4.126.149-.123.221-1.656.474-.019-2.317Z",
    transform: "translate(109.723 -39.742)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(3.157 38.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M-109.337,42.318l-1.817-.444-.019-2.317,1.817.444Z",
    transform: "translate(111.172 -39.557)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(3.157 37.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M-109.355,40.044l-1.817-.444.131-.212,1.817.444Z",
    transform: "translate(111.172 -39.388)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(4.608 12.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    className: "cls-135",
    d: "M-108.2,19.431l-1.817-.444.123-.221,1.817.444Z",
    transform: "translate(110.015 -18.766)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(4.605 11.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    className: "cls-202",
    d: "M-108.074,19.24l-1.817-.444-.126-.149,1.817.444Z",
    transform: "translate(110.017 -18.647)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(3.101 14.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    className: "cls-143",
    d: "M-109.4,21.469l-1.817-.444.131-.212,1.817.444Z",
    transform: "translate(111.216 -20.813)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(2.968 14.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M-109.372,21.454l-1.817-.444-.134-.136,1.817.444Z",
    transform: "translate(111.323 -20.873)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(3.217 12.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    className: "cls-13",
    d: "M-109.307,19.784l-1.817-.444,1.391-.4,1.817.444Z",
    transform: "translate(111.124 -18.942)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(3.217 12.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    className: "cls-44",
    d: "M-109.292,21.651l-1.817-.444-.016-1.947,1.817.444Z",
    transform: "translate(111.124 -19.26)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(2.949 11.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M-109.521,19.565l-1.817-.444,1.656-.474,1.817.444Z",
    transform: "translate(111.338 -18.647)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(2.949 12.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M-109.5,21.786l-1.817-.444-.019-2.317,1.817.444Z",
    transform: "translate(111.338 -19.025)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(1.817 0.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    className: "cls-160",
    d: "M-87.742,9.507c.746-.214,1.366.459,1.375,1.514L-86,55.966l-25.874,7.409-.362-44.946a2.372,2.372,0,0,1,1.345-2.293Zm-10.77,11.141c-2.7.775-4.39,4.342-4.36,8.139s1.781,8.44,4.486,7.666,4.382-6.4,4.351-10.2-1.765-6.385-4.477-5.608m.325,23.865a31.425,31.425,0,0,0,8.205-3.576c-.534-5.364-4.733-4.813-4.954-4.785a6.162,6.162,0,0,1-3.423,3.126,4.334,4.334,0,0,1-3.946-1.017,7.311,7.311,0,0,0-4.365,7.453,30.008,30.008,0,0,0,8.482-1.2m10.682-.742-.019-2.316-.125-.139-.132.212.016,1.948-1.391.4-.13.222.133.148,1.648-.473m-19.905,5.7.123-.221-.125-.149-1.391.4-.016-1.947-.133-.137-.132.212.019,2.316,1.656-.474m19.7-31.435-.019-2.318-1.648.473-.13.222.134.148,1.39-.4.016,1.947.134.137.123-.209m-19.921,3.752.123-.221-.125-.149-1.656.474.019,2.318.133.135.132-.212-.016-1.947,1.391-.4",
    transform: "translate(112.241 -9.467)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(24.549 6.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    className: "cls-203",
    d: "M-92.328,14.454l.019,2.317-.123.21-.134-.136-.016-1.947-1.391.4-.134-.147.131-.223Z",
    transform: "translate(94.106 -14.454)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(4.766 12.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    className: "cls-203",
    d: "M-108.233,19l.126.149-.123.221-1.391.4.016,1.947-.131.212-.134-.136-.019-2.317Z",
    transform: "translate(109.888 -19.001)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(1.345 0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    className: "cls-13",
    d: "M-110.8,16.218l-1.817-.444,23.154-6.63,1.817.444Z",
    transform: "translate(112.618 -9.145)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 8.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    className: "cls-44",
    d: "M-111.512,61.653l-1.817-.444-.362-44.945,1.817.444Z",
    transform: "translate(113.69 -16.263)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    className: "cls-10",
    transform: "translate(0 6.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    className: "cls-356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    className: "cls-10",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    className: "cls-43",
    d: "M-111.874,16.708l-1.817-.444v0l1.817.444v0",
    transform: "translate(113.691 -13.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    className: "cls-46",
    d: "M-111.873,16.708l-1.817-.444V16.25l1.817.444v.014",
    transform: "translate(113.69 -13.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    className: "cls-47",
    d: "M-111.874,16.7l-1.817-.444v-.014l1.817.444V16.7",
    transform: "translate(113.69 -13.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    className: "cls-47",
    d: "M-111.874,16.686l-1.817-.444v-.014l1.817.444v.014",
    transform: "translate(113.69 -13.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    className: "cls-47",
    d: "M-111.874,16.675l-1.817-.444v-.014l1.817.444v.014",
    transform: "translate(113.69 -13.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    className: "cls-48",
    d: "M-111.873,16.664l-1.817-.444v-.014l1.817.444v.014",
    transform: "translate(113.691 -13.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    className: "cls-49",
    d: "M-111.873,16.653l-1.817-.444v-.014l1.817.444v.014",
    transform: "translate(113.691 -13.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    className: "cls-49",
    d: "M-111.873,16.642l-1.817-.444v-.014l1.817.444v.014",
    transform: "translate(113.691 -13.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    className: "cls-49",
    d: "M-111.873,16.631l-1.817-.444v-.014l1.817.444v.014",
    transform: "translate(113.691 -13.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    className: "cls-50",
    d: "M-111.872,16.62l-1.817-.444v-.014l1.817.444v.014",
    transform: "translate(113.691 -13.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    className: "cls-51",
    d: "M-111.872,16.608l-1.817-.444V16.15l1.817.444v.014",
    transform: "translate(113.691 -13.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    className: "cls-51",
    d: "M-111.872,16.6l-1.817-.444v-.014l1.817.444V16.6",
    transform: "translate(113.691 -14.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    className: "cls-51",
    d: "M-111.871,16.586l-1.817-.444v-.011l1.817.444v.011",
    transform: "translate(113.691 -14.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    className: "cls-52",
    d: "M-111.871,16.577l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.691 -14.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    className: "cls-52",
    d: "M-111.87,16.569l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.691 -14.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    className: "cls-53",
    d: "M-111.87,16.561l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.691 -14.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    className: "cls-53",
    d: "M-111.869,16.553l-1.817-.444V16.1l1.817.444v.01",
    transform: "translate(113.692 -14.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    className: "cls-54",
    d: "M-111.869,16.545l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.692 -14.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    className: "cls-54",
    d: "M-111.868,16.537l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.692 -14.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    className: "cls-55",
    d: "M-111.868,16.529l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.692 -14.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    className: "cls-56",
    d: "M-111.867,16.521l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.692 -14.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    className: "cls-57",
    d: "M-111.866,16.513l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.692 -14.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    className: "cls-57",
    d: "M-111.866,16.505l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.693 -14.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    className: "cls-57",
    d: "M-111.865,16.5l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.693 -14.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    className: "cls-58",
    d: "M-111.864,16.489l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.693 -14.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    className: "cls-58",
    d: "M-111.863,16.481l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.693 -14.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    className: "cls-58",
    d: "M-111.863,16.473l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.693 -14.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    className: "cls-59",
    d: "M-111.862,16.465l-1.817-.444v-.01l1.817.444v.01",
    transform: "translate(113.693 -14.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    className: "cls-60",
    d: "M-111.861,16.457l-1.817-.444V16l1.817.444v.008",
    transform: "translate(113.694 -14.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    className: "cls-61",
    d: "M-111.86,16.451l-1.817-.444V16l1.817.444v.008",
    transform: "translate(113.694 -14.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    className: "cls-61",
    d: "M-111.86,16.444-113.677,16v-.008l1.817.444v.008",
    transform: "translate(113.694 -14.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    className: "cls-61",
    d: "M-111.859,16.437l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.694 -14.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    className: "cls-62",
    d: "M-111.858,16.43l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.694 -14.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    className: "cls-63",
    d: "M-111.857,16.424l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.695 -14.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    className: "cls-63",
    d: "M-111.857,16.417l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.695 -14.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    className: "cls-64",
    d: "M-111.856,16.41l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.695 -14.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    className: "cls-64",
    d: "M-111.855,16.4l-1.817-.444v-.008l1.817.444V16.4",
    transform: "translate(113.695 -14.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    className: "cls-64",
    d: "M-111.854,16.4l-1.817-.444v-.008l1.817.444V16.4",
    transform: "translate(113.695 -14.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    className: "cls-65",
    d: "M-111.853,16.39l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.696 -14.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    className: "cls-66",
    d: "M-111.852,16.383l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.696 -14.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    className: "cls-67",
    d: "M-111.851,16.377l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.696 -14.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    className: "cls-67",
    d: "M-111.85,16.37l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.696 -14.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    className: "cls-67",
    d: "M-111.849,16.363l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.697 -14.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    className: "cls-68",
    d: "M-111.848,16.357l-1.817-.444V15.9l1.817.444v.008",
    transform: "translate(113.697 -14.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    className: "cls-68",
    d: "M-111.847,16.35l-1.817-.444V15.9l1.817.444v.008",
    transform: "translate(113.697 -14.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    className: "cls-68",
    d: "M-111.846,16.343l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.698 -14.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    className: "cls-69",
    d: "M-111.845,16.337l-1.817-.444v-.008l1.817.444v.008",
    transform: "translate(113.698 -14.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    className: "cls-70",
    d: "M-111.844,16.33l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.698 -14.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    className: "cls-70",
    d: "M-111.843,16.325l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.698 -14.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    className: "cls-70",
    d: "M-111.842,16.319l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.699 -14.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    className: "cls-71",
    d: "M-111.841,16.313l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.699 -14.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    className: "cls-71",
    d: "M-111.84,16.308l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.699 -14.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    className: "cls-72",
    d: "M-111.839,16.3l-1.817-.444v-.007l1.817.444V16.3",
    transform: "translate(113.699 -14.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    className: "cls-72",
    d: "M-111.838,16.3l-1.817-.444v-.007l1.817.444V16.3",
    transform: "translate(113.699 -14.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    className: "cls-73",
    d: "M-111.838,16.291l-1.817-.444V15.84l1.817.444v.007",
    transform: "translate(113.7 -14.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    className: "cls-73",
    d: "M-111.836,16.285l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.7 -14.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    className: "cls-74",
    d: "M-111.835,16.28l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.7 -14.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    className: "cls-74",
    d: "M-111.834,16.274l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.7 -14.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    className: "cls-75",
    d: "M-111.833,16.268l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.701 -14.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    className: "cls-75",
    d: "M-111.832,16.263l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.701 -14.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    className: "cls-75",
    d: "M-111.831,16.257l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.701 -14.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    className: "cls-76",
    d: "M-111.83,16.252l-1.817-.444V15.8l1.817.444v.007",
    transform: "translate(113.702 -14.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    className: "cls-76",
    d: "M-111.829,16.246l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.702 -14.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    className: "cls-76",
    d: "M-111.828,16.24l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.702 -14.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    className: "cls-77",
    d: "M-111.827,16.235l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.702 -14.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    className: "cls-78",
    d: "M-111.826,16.229l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.703 -14.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    className: "cls-79",
    d: "M-111.824,16.224l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.703 -14.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    className: "cls-79",
    d: "M-111.823,16.218l-1.817-.444v-.007l1.817.444v.007",
    transform: "translate(113.703 -14.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    className: "cls-79",
    d: "M-111.822,16.212l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.704 -14.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    className: "cls-80",
    d: "M-111.821,16.207l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.704 -14.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    className: "cls-81",
    d: "M-111.82,16.2l-1.817-.444v-.006l1.817.444V16.2",
    transform: "translate(113.704 -14.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    className: "cls-82",
    d: "M-111.819,16.2l-1.817-.444v-.006l1.817.444V16.2",
    transform: "translate(113.704 -14.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    className: "cls-82",
    d: "M-111.818,16.193l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.705 -14.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    className: "cls-83",
    d: "M-111.817,16.188l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.705 -14.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    className: "cls-83",
    d: "M-111.815,16.183l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.705 -14.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    className: "cls-84",
    d: "M-111.814,16.178l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.706 -14.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    className: "cls-85",
    d: "M-111.813,16.174l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.706 -14.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    className: "cls-86",
    d: "M-111.812,16.169l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.706 -14.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    className: "cls-86",
    d: "M-111.811,16.164l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.706 -14.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    className: "cls-86",
    d: "M-111.81,16.159l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.707 -14.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    className: "cls-87",
    d: "M-111.809,16.154l-1.817-.444V15.7l1.817.444v.006",
    transform: "translate(113.707 -14.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    className: "cls-87",
    d: "M-111.807,16.15l-1.817-.444V15.7l1.817.444v.006",
    transform: "translate(113.707 -14.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    className: "cls-87",
    d: "M-111.806,16.145l-1.817-.444v-.006l1.817.444v.006",
    transform: "translate(113.708 -14.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    className: "cls-88",
    d: "M-111.805,16.14l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.708 -14.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    className: "cls-89",
    d: "M-111.8,16.135l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.708 -14.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    className: "cls-89",
    d: "M-111.8,16.131l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.708 -14.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    className: "cls-89",
    d: "M-111.8,16.126l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.709 -14.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    className: "cls-89",
    d: "M-111.8,16.121l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.709 -14.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    className: "cls-90",
    d: "M-111.8,16.116l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.709 -14.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    className: "cls-91",
    d: "M-111.8,16.111l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.71 -14.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    className: "cls-91",
    d: "M-111.8,16.107l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.71 -14.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    className: "cls-92",
    d: "M-111.8,16.1l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.71 -14.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    className: "cls-92",
    d: "M-111.794,16.1l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.711 -14.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    className: "cls-92",
    d: "M-111.793,16.092l-1.817-.444v-.005l1.817.444v.005",
    transform: "translate(113.711 -14.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    className: "cls-93",
    d: "M-111.792,16.088l-1.817-.444v-.005l1.817.444v.005",
    transform: "translate(113.711 -14.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    className: "cls-94",
    d: "M-111.79,16.084l-1.817-.444v-.005l1.817.444v.005",
    transform: "translate(113.712 -14.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    className: "cls-94",
    d: "M-111.789,16.08l-1.817-.444V15.63l1.817.444v.005",
    transform: "translate(113.712 -14.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    className: "cls-94",
    d: "M-111.788,16.075l-1.817-.444v-.005l1.817.444v.005",
    transform: "translate(113.712 -14.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    className: "cls-95",
    d: "M-111.787,16.071l-1.817-.444,0-.005,1.817.444v.005",
    transform: "translate(113.713 -14.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    className: "cls-96",
    d: "M-111.786,16.067l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.713 -14.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    className: "cls-96",
    d: "M-111.785,16.063l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.713 -14.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    className: "cls-96",
    d: "M-111.783,16.058l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.713 -14.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    className: "cls-97",
    d: "M-111.782,16.054l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.714 -14.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    className: "cls-98",
    d: "M-111.781,16.05l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.714 -14.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    className: "cls-98",
    d: "M-111.78,16.046-113.6,15.6l0-.005,1.817.444,0,.005",
    transform: "translate(113.714 -14.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    className: "cls-98",
    d: "M-111.778,16.042-113.6,15.6l0-.005,1.817.444,0,.005",
    transform: "translate(113.715 -14.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    className: "cls-99",
    d: "M-111.777,16.038l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.715 -14.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    className: "cls-100",
    d: "M-111.776,16.033l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.715 -14.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    className: "cls-101",
    d: "M-111.775,16.029l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.716 -14.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    className: "cls-101",
    d: "M-111.773,16.025l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.716 -14.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    className: "cls-102",
    d: "M-111.772,16.021l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.716 -14.145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    className: "cls-102",
    d: "M-111.771,16.017l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.717 -14.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    className: "cls-103",
    d: "M-111.77,16.013l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.717 -14.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    className: "cls-103",
    d: "M-111.768,16.008l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.717 -14.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    className: "cls-104",
    d: "M-111.767,16l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.718 -14.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    className: "cls-104",
    d: "M-111.766,16l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.718 -14.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    className: "cls-104",
    d: "M-111.764,16l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.718 -14.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    className: "cls-105",
    d: "M-111.763,15.992l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.719 -14.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    className: "cls-105",
    d: "M-111.762,15.988l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.719 -14.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    className: "cls-105",
    d: "M-111.76,15.983l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.719 -14.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    className: "cls-106",
    d: "M-111.759,15.979l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.72 -14.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    className: "cls-107",
    d: "M-111.758,15.975l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.72 -14.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    className: "cls-107",
    d: "M-111.756,15.971l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.72 -14.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    className: "cls-107",
    d: "M-111.755,15.967l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.721 -14.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    className: "cls-107",
    d: "M-111.754,15.964l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.721 -14.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    className: "cls-108",
    d: "M-111.753,15.96l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.721 -14.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    className: "cls-109",
    d: "M-111.751,15.956l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.722 -14.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    className: "cls-109",
    d: "M-111.75,15.952l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.722 -14.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    className: "cls-109",
    d: "M-111.749,15.949l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.722 -14.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    className: "cls-110",
    d: "M-111.748,15.945l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.723 -14.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    className: "cls-110",
    d: "M-111.746,15.941l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.723 -14.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    className: "cls-111",
    d: "M-111.745,15.937l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.723 -14.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    className: "cls-112",
    d: "M-111.744,15.934l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.724 -14.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    className: "cls-113",
    d: "M-111.742,15.93l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.724 -14.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    className: "cls-113",
    d: "M-111.741,15.926l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.724 -14.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    className: "cls-114",
    d: "M-111.74,15.922l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.724 -14.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    className: "cls-115",
    d: "M-111.738,15.919l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.725 -14.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    className: "cls-115",
    d: "M-111.737,15.915l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.725 -14.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    className: "cls-115",
    d: "M-111.736,15.911l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.725 -14.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    className: "cls-116",
    d: "M-111.734,15.907l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.726 -14.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    className: "cls-117",
    d: "M-111.733,15.9l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.726 -14.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    className: "cls-117",
    d: "M-111.732,15.9l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.727 -14.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    className: "cls-117",
    d: "M-111.73,15.9l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.727 -14.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    className: "cls-117",
    d: "M-111.729,15.892l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.727 -14.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    className: "cls-118",
    d: "M-111.727,15.889l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.728 -14.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    className: "cls-119",
    d: "M-111.726,15.885l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.728 -14.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    className: "cls-119",
    d: "M-111.725,15.881l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.728 -14.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    className: "cls-120",
    d: "M-111.723,15.878l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.729 -14.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    className: "cls-120",
    d: "M-111.722,15.874l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.729 -14.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    className: "cls-121",
    d: "M-111.72,15.87l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.729 -14.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    className: "cls-121",
    d: "M-111.719,15.867l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.73 -14.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    className: "cls-122",
    d: "M-111.718,15.863l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.73 -14.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    className: "cls-122",
    d: "M-111.716,15.859l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.73 -14.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    className: "cls-122",
    d: "M-111.715,15.856l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.731 -14.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    className: "cls-123",
    d: "M-111.713,15.852l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.731 -14.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    className: "cls-124",
    d: "M-111.712,15.849l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.732 -14.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    className: "cls-124",
    d: "M-111.711,15.845l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.732 -14.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    className: "cls-125",
    d: "M-111.709,15.842l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.732 -14.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    className: "cls-126",
    d: "M-111.708,15.838l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.732 -14.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    className: "cls-127",
    d: "M-111.707,15.835l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.733 -14.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    className: "cls-127",
    d: "M-111.705,15.831l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.733 -14.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    className: "cls-127",
    d: "M-111.7,15.828l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.734 -14.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    className: "cls-128",
    d: "M-111.7,15.824l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.734 -14.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    className: "cls-129",
    d: "M-111.7,15.821l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.734 -14.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    className: "cls-130",
    d: "M-111.7,15.817l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.735 -14.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    className: "cls-130",
    d: "M-111.7,15.814l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.735 -14.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    className: "cls-131",
    d: "M-111.7,15.811l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.735 -14.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    className: "cls-131",
    d: "M-111.7,15.807l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.736 -14.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    className: "cls-132",
    d: "M-111.694,15.8l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.736 -14.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    className: "cls-132",
    d: "M-111.692,15.8l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.737 -14.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    className: "cls-133",
    d: "M-111.691,15.8l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.737 -14.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    className: "cls-133",
    d: "M-111.689,15.793l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.737 -14.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    className: "cls-134",
    d: "M-111.688,15.79l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.738 -14.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    className: "cls-135",
    d: "M-111.686,15.786l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.738 -14.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    className: "cls-135",
    d: "M-111.685,15.783l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.738 -14.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    className: "cls-135",
    d: "M-111.683,15.78l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.739 -14.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    className: "cls-136",
    d: "M-111.682,15.776l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.739 -14.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    className: "cls-137",
    d: "M-111.681,15.773l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.739 -14.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    className: "cls-137",
    d: "M-111.679,15.769l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.74 -14.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    className: "cls-137",
    d: "M-111.678,15.766l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.74 -14.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    className: "cls-137",
    d: "M-111.676,15.763l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.741 -14.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    className: "cls-138",
    d: "M-111.675,15.759l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.741 -14.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    className: "cls-139",
    d: "M-111.673,15.756l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.741 -14.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    className: "cls-139",
    d: "M-111.672,15.752l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.742 -14.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    className: "cls-139",
    d: "M-111.67,15.749l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.742 -14.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    className: "cls-140",
    d: "M-111.668,15.746l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.742 -14.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    className: "cls-141",
    d: "M-111.667,15.742l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.743 -14.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    className: "cls-141",
    d: "M-111.665,15.739l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.743 -14.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    className: "cls-142",
    d: "M-111.664,15.736l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.744 -14.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    className: "cls-142",
    d: "M-111.662,15.732l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.744 -14.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    className: "cls-142",
    d: "M-111.661,15.729l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.744 -14.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    className: "cls-143",
    d: "M-111.659,15.726l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.745 -14.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    className: "cls-144",
    d: "M-111.658,15.722l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.745 -14.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    className: "cls-144",
    d: "M-111.656,15.719l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.746 -14.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    className: "cls-144",
    d: "M-111.655,15.716l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.746 -14.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    className: "cls-145",
    d: "M-111.653,15.712l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.746 -14.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    className: "cls-146",
    d: "M-111.651,15.709l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.747 -14.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    className: "cls-146",
    d: "M-111.65,15.706l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.747 -14.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    className: "cls-146",
    d: "M-111.648,15.7l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.748 -14.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    className: "cls-147",
    d: "M-111.647,15.7l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.748 -14.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    className: "cls-148",
    d: "M-111.645,15.7l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.748 -14.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    className: "cls-149",
    d: "M-111.644,15.692l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.749 -14.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    className: "cls-149",
    d: "M-111.642,15.689l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.749 -14.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    className: "cls-150",
    d: "M-111.64,15.686l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.75 -14.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    className: "cls-150",
    d: "M-111.639,15.682l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.75 -14.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    className: "cls-151",
    d: "M-111.637,15.679l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.75 -14.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    className: "cls-151",
    d: "M-111.635,15.676l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.751 -14.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    className: "cls-152",
    d: "M-111.634,15.673l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.751 -14.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    className: "cls-152",
    d: "M-111.632,15.669l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.752 -14.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    className: "cls-152",
    d: "M-111.631,15.666l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.752 -14.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    className: "cls-153",
    d: "M-111.629,15.663l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.753 -14.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    className: "cls-154",
    d: "M-111.627,15.66l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.753 -14.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    className: "cls-154",
    d: "M-111.626,15.656l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.753 -14.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    className: "cls-155",
    d: "M-111.624,15.653l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.754 -14.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    className: "cls-156",
    d: "M-111.622,15.65l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.754 -14.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    className: "cls-156",
    d: "M-111.621,15.647l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.755 -14.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    className: "cls-156",
    d: "M-111.619,15.643l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.755 -14.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    className: "cls-156",
    d: "M-111.617,15.64l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.756 -14.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    className: "cls-157",
    d: "M-111.615,15.637l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.756 -14.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    className: "cls-158",
    d: "M-111.614,15.633l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.756 -14.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    className: "cls-158",
    d: "M-111.612,15.63l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.757 -14.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    className: "cls-158",
    d: "M-111.61,15.627l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.757 -14.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    className: "cls-159",
    d: "M-111.608,15.623l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.758 -14.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    className: "cls-160",
    d: "M-111.607,15.62l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.758 -14.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    className: "cls-160",
    d: "M-111.6,15.616l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.759 -14.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    className: "cls-160",
    d: "M-111.6,15.613l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.759 -14.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    className: "cls-36",
    d: "M-111.6,15.61l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.76 -14.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    className: "cls-36",
    d: "M-111.6,15.606l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.76 -14.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    className: "cls-35",
    d: "M-111.6,15.6l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.76 -14.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    className: "cls-34",
    d: "M-111.6,15.6l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.761 -14.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    className: "cls-34",
    d: "M-111.594,15.6l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.761 -14.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    className: "cls-34",
    d: "M-111.592,15.593l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.762 -14.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    className: "cls-33",
    d: "M-111.59,15.59l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.762 -14.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    className: "cls-32",
    d: "M-111.589,15.586l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.763 -14.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    className: "cls-32",
    d: "M-111.587,15.583l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.763 -14.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    className: "cls-32",
    d: "M-111.585,15.58l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.764 -14.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    className: "cls-32",
    d: "M-111.583,15.577l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.764 -14.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    className: "cls-31",
    d: "M-111.581,15.573l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.765 -14.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    className: "cls-30",
    d: "M-111.579,15.57l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.765 -14.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    className: "cls-30",
    d: "M-111.577,15.567l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.766 -14.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    className: "cls-30",
    d: "M-111.576,15.563l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.766 -14.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    className: "cls-29",
    d: "M-111.574,15.56l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.767 -14.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    className: "cls-28",
    d: "M-111.572,15.557l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.767 -14.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    className: "cls-28",
    d: "M-111.57,15.554l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.767 -14.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    className: "cls-27",
    d: "M-111.568,15.55l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.768 -14.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    className: "cls-27",
    d: "M-111.566,15.547l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.768 -14.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    className: "cls-27",
    d: "M-111.564,15.544l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.769 -14.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    className: "cls-26",
    d: "M-111.562,15.541l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.769 -14.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    className: "cls-25",
    d: "M-111.56,15.537l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.77 -14.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    className: "cls-25",
    d: "M-111.558,15.533l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.771 -14.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    className: "cls-25",
    d: "M-111.556,15.53l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.771 -14.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    className: "cls-24",
    d: "M-111.554,15.526l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.772 -14.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    className: "cls-23",
    d: "M-111.551,15.522l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.772 -14.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    className: "cls-23",
    d: "M-111.549,15.519l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.773 -14.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    className: "cls-23",
    d: "M-111.547,15.515l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.773 -14.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    className: "cls-22",
    d: "M-111.545,15.512l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.774 -14.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    className: "cls-21",
    d: "M-111.543,15.508l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.774 -14.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    className: "cls-20",
    d: "M-111.54,15.5l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.775 -14.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    className: "cls-20",
    d: "M-111.538,15.5l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.776 -14.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    className: "cls-19",
    d: "M-111.536,15.5l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.776 -14.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    className: "cls-19",
    d: "M-111.534,15.494l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.777 -14.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    className: "cls-18",
    d: "M-111.531,15.49l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.777 -14.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    className: "cls-18",
    d: "M-111.529,15.487l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.778 -14.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    className: "cls-17",
    d: "M-111.527,15.483l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.778 -14.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    className: "cls-17",
    d: "M-111.525,15.479l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.779 -14.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    className: "cls-16",
    d: "M-111.523,15.476l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.78 -14.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    className: "cls-16",
    d: "M-111.52,15.472l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.78 -14.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    className: "cls-15",
    d: "M-111.518,15.469l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.781 -14.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    className: "cls-15",
    d: "M-111.516,15.465l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.781 -14.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    className: "cls-14",
    d: "M-111.513,15.462l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.782 -14.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    className: "cls-13",
    d: "M-111.511,15.458l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.782 -14.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    className: "cls-13",
    d: "M-111.509,15.455l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.783 -14.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    className: "cls-12",
    d: "M-111.506,15.451l-1.817-.444,0,0,1.817.444,0,0",
    transform: "translate(113.784 -14.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    className: "cls-161",
    d: "M-111.5,15.448-113.321,15l0,0,1.817.444,0,0",
    transform: "translate(113.784 -14.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    className: "cls-162",
    d: "M-111.5,15.444-113.319,15l0-.005,1.817.444,0,.005",
    transform: "translate(113.785 -14.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    className: "cls-163",
    d: "M-111.5,15.44-113.316,15l0-.005,1.817.444,0,.005",
    transform: "translate(113.786 -14.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    className: "cls-164",
    d: "M-111.5,15.436l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.786 -14.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    className: "cls-165",
    d: "M-111.493,15.431l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.787 -14.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    className: "cls-166",
    d: "M-111.49,15.427l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.788 -14.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    className: "cls-167",
    d: "M-111.487,15.423l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.788 -14.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    className: "cls-168",
    d: "M-111.484,15.418l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.789 -14.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    className: "cls-169",
    d: "M-111.481,15.414l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.79 -14.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    className: "cls-170",
    d: "M-111.478,15.41l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.791 -14.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    className: "cls-171",
    d: "M-111.475,15.406l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.792 -14.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    className: "cls-172",
    d: "M-111.472,15.4l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.792 -14.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    className: "cls-173",
    d: "M-111.469,15.4l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.793 -14.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    className: "cls-174",
    d: "M-111.466,15.393l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.794 -14.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    className: "cls-175",
    d: "M-111.463,15.389l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.795 -14.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    className: "cls-176",
    d: "M-111.46,15.385l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.795 -14.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    className: "cls-177",
    d: "M-111.457,15.38l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.796 -14.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    className: "cls-178",
    d: "M-111.454,15.376l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.797 -14.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    className: "cls-178",
    d: "M-111.451,15.372l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.798 -14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    className: "cls-179",
    d: "M-111.448,15.368l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.798 -14.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    className: "cls-180",
    d: "M-111.445,15.364l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.799 -14.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    className: "cls-181",
    d: "M-111.442,15.36l-1.817-.444,0-.005,1.817.444,0,.005",
    transform: "translate(113.8 -14.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    className: "cls-182",
    d: "M-111.439,15.356l-1.817-.444,0-.006,1.817.444,0,.006",
    transform: "translate(113.801 -14.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    className: "cls-183",
    d: "M-111.435,15.351l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.802 -14.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    className: "cls-184",
    d: "M-111.43,15.345l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.803 -14.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    className: "cls-185",
    d: "M-111.426,15.339l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.804 -14.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    className: "cls-185",
    d: "M-111.421,15.334l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.805 -14.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    className: "cls-186",
    d: "M-111.417,15.328l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.806 -14.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    className: "cls-187",
    d: "M-111.412,15.322l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.807 -14.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    className: "cls-188",
    d: "M-111.408,15.317l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.809 -14.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    className: "cls-189",
    d: "M-111.4,15.311l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.81 -14.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    className: "cls-190",
    d: "M-111.4,15.305l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.811 -14.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    className: "cls-190",
    d: "M-111.395,15.3l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.812 -14.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    className: "cls-191",
    d: "M-111.39,15.294l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.813 -14.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    className: "cls-191",
    d: "M-111.385,15.289l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.814 -14.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    className: "cls-192",
    d: "M-111.381,15.283l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.815 -14.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    className: "cls-192",
    d: "M-111.376,15.278l-1.817-.444.006-.007,1.817.444-.006.007",
    transform: "translate(113.817 -14.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    className: "cls-192",
    d: "M-111.371,15.273l-1.817-.444.007-.009,1.817.444-.007.009",
    transform: "translate(113.818 -14.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    className: "cls-193",
    d: "M-111.365,15.266l-1.817-.444.01-.012,1.817.444-.01.012",
    transform: "translate(113.819 -14.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    className: "cls-194",
    d: "M-111.358,15.257l-1.817-.444.01-.011,1.817.444-.01.011",
    transform: "translate(113.821 -14.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    className: "cls-195",
    d: "M-111.349,15.248l-1.817-.444.01-.011,1.817.444-.01.011",
    transform: "translate(113.823 -14.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    className: "cls-196",
    d: "M-111.341,15.239l-1.817-.444.01-.011,1.817.444-.01.011",
    transform: "translate(113.825 -14.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    className: "cls-197",
    d: "M-111.333,15.23l-1.817-.444.01-.011,1.817.444-.01.011",
    transform: "translate(113.828 -14.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    className: "cls-198",
    d: "M-111.325,15.221l-1.817-.444.01-.011,1.817.444-.01.011",
    transform: "translate(113.83 -14.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    className: "cls-199",
    d: "M-111.317,15.212l-1.817-.444.01-.011,1.817.444-.01.011",
    transform: "translate(113.832 -14.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    className: "cls-199",
    d: "M-111.308,15.2l-1.817-.444.01-.011,1.817.444-.01.011",
    transform: "translate(113.834 -14.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    className: "cls-199",
    d: "M-111.3,15.2l-1.818-.445.023-.021,1.816.444-.021.023",
    transform: "translate(113.836 -14.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    className: "cls-200",
    d: "M-111.283,15.181l-1.816-.444.031-.03,1.816.444-.031.03",
    transform: "translate(113.841 -14.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    className: "cls-200",
    d: "M-111.258,15.157l-1.816-.444.031-.029,1.816.444-.031.029",
    transform: "translate(113.847 -14.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    className: "cls-201",
    d: "M-111.233,15.132l-1.816-.444.02-.019,1.816.445-.02.018",
    transform: "translate(113.853 -14.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    className: "cls-200",
    d: "M-111.216,15.115l-1.817-.444.011-.009,1.817.444-.011.009",
    transform: "translate(113.857 -14.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    className: "cls-200",
    d: "M-111.208,15.108l-1.817-.444.011-.009,1.817.444-.011.009",
    transform: "translate(113.859 -14.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    className: "cls-199",
    d: "M-111.2,15.1l-1.817-.444.011-.009,1.817.444-.011.009",
    transform: "translate(113.861 -14.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    className: "cls-199",
    d: "M-111.19,15.093l-1.817-.444.011-.009,1.817.444-.011.009",
    transform: "translate(113.864 -14.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    className: "cls-199",
    d: "M-111.182,15.086-113,14.642l.011-.009,1.817.444-.011.009",
    transform: "translate(113.866 -14.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    className: "cls-198",
    d: "M-111.173,15.079l-1.817-.444.011-.009,1.817.444-.011.009",
    transform: "translate(113.868 -14.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    className: "cls-197",
    d: "M-111.164,15.072l-1.817-.444.011-.009,1.817.444-.011.009",
    transform: "translate(113.87 -14.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    className: "cls-196",
    d: "M-111.155,15.065l-1.817-.444.011-.009,1.817.444-.011.009",
    transform: "translate(113.873 -14.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    className: "cls-195",
    d: "M-111.147,15.058l-1.817-.444.01-.008,1.817.444-.01.008",
    transform: "translate(113.875 -14.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    className: "cls-194",
    d: "M-111.139,15.052l-1.817-.444.009-.007,1.817.444-.009.007",
    transform: "translate(113.877 -14.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    className: "cls-193",
    d: "M-111.131,15.046l-1.817-.444.009-.007,1.817.444-.009.007",
    transform: "translate(113.879 -14.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    className: "cls-192",
    d: "M-111.124,15.041l-1.817-.444.009-.007,1.817.444-.009.007",
    transform: "translate(113.88 -14.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    className: "cls-192",
    d: "M-111.117,15.036l-1.817-.444.009-.007,1.817.444-.009.007",
    transform: "translate(113.882 -14.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    className: "cls-192",
    d: "M-111.109,15.031l-1.817-.444.009-.006,1.817.444-.009.006",
    transform: "translate(113.884 -14.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    className: "cls-191",
    d: "M-111.1,15.025l-1.817-.444.009-.006,1.817.444-.009.006",
    transform: "translate(113.886 -14.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    className: "cls-191",
    d: "M-111.094,15.02l-1.817-.444.009-.006,1.817.444-.009.006",
    transform: "translate(113.888 -14.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    className: "cls-190",
    d: "M-111.087,15.015l-1.817-.444.009-.006,1.817.444-.009.006",
    transform: "translate(113.89 -14.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    className: "cls-190",
    d: "M-111.08,15.01l-1.817-.444.009-.006,1.817.444-.009.006",
    transform: "translate(113.892 -14.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    className: "cls-189",
    d: "M-111.072,15.005l-1.817-.444.009-.006,1.817.444-.009.006",
    transform: "translate(113.894 -14.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    className: "cls-188",
    d: "M-111.065,15l-1.817-.444.01-.006,1.817.444-.01.006",
    transform: "translate(113.896 -14.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    className: "cls-187",
    d: "M-111.057,15l-1.817-.444.011-.007,1.817.444-.011.007",
    transform: "translate(113.898 -14.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    className: "cls-186",
    d: "M-111.048,14.99l-1.817-.444.011-.007,1.817.444-.011.007",
    transform: "translate(113.9 -14.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    className: "cls-185",
    d: "M-111.039,14.984l-1.817-.444.011-.007,1.817.444-.011.007",
    transform: "translate(113.902 -14.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    className: "cls-185",
    d: "M-111.029,14.979l-1.817-.444.012-.007,1.817.444-.012.007",
    transform: "translate(113.904 -14.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    className: "cls-184",
    d: "M-111.02,14.974l-1.817-.444.012-.007,1.817.444-.012.007",
    transform: "translate(113.907 -14.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    className: "cls-183",
    d: "M-111.011,14.968l-1.817-.444.012-.006,1.817.444-.012.006",
    transform: "translate(113.909 -14.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    className: "cls-182",
    d: "M-111,14.963l-1.817-.444.012-.006,1.817.444-.012.006",
    transform: "translate(113.911 -14.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    className: "cls-181",
    d: "M-110.993,14.958l-1.817-.444.012-.006,1.817.444-.012.006",
    transform: "translate(113.914 -14.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    className: "cls-180",
    d: "M-110.983,14.953l-1.817-.444.012-.006,1.817.444-.012.006",
    transform: "translate(113.916 -14.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    className: "cls-179",
    d: "M-110.974,14.949l-1.816-.445.015-.008,1.816.445-.015.008",
    transform: "translate(113.919 -14.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    className: "cls-178",
    d: "M-110.962,14.943l-1.816-.445.015-.008,1.818.445-.016.008",
    transform: "translate(113.922 -14.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    className: "cls-178",
    d: "M-110.949,14.936l-1.818-.445.015-.006,1.818.444-.015.008",
    transform: "translate(113.925 -14.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    className: "cls-177",
    d: "M-110.936,14.93l-1.818-.444.016-.008,1.816.444-.015.008",
    transform: "translate(113.928 -14.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    className: "cls-176",
    d: "M-110.925,14.924l-1.816-.444.015-.008,1.818.445-.016.006",
    transform: "translate(113.931 -14.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    className: "cls-175",
    d: "M-110.912,14.919l-1.818-.445.016-.006,1.816.445-.015.006",
    transform: "translate(113.934 -14.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    className: "cls-174",
    d: "M-110.9,14.914l-1.817-.444.014-.006,1.817.444-.014.006",
    transform: "translate(113.937 -14.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    className: "cls-173",
    d: "M-110.888,14.908l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.94 -14.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    className: "cls-172",
    d: "M-110.882,14.906l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.942 -14.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    className: "cls-171",
    d: "M-110.875,14.9l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.944 -14.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    className: "cls-170",
    d: "M-110.868,14.9l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.945 -14.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    className: "cls-169",
    d: "M-110.862,14.9l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.947 -14.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    className: "cls-168",
    d: "M-110.855,14.9l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.949 -14.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    className: "cls-167",
    d: "M-110.849,14.894l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.95 -14.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    className: "cls-166",
    d: "M-110.842,14.891l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.952 -14.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    className: "cls-165",
    d: "M-110.836,14.889l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.954 -14.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    className: "cls-164",
    d: "M-110.829,14.887l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.955 -14.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    className: "cls-163",
    d: "M-110.823,14.885l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.957 -14.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    className: "cls-162",
    d: "M-110.816,14.883l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.959 -14.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    className: "cls-161",
    d: "M-110.809,14.881l-1.817-.444.008,0,1.817.444-.008,0",
    transform: "translate(113.96 -14.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    className: "cls-12",
    d: "M-110.8,14.879l-1.817-.444h0l1.817.444h0",
    transform: "translate(113.962 -14.434)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(8.335 10.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    className: "cls-10",
    transform: "translate(0 16.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    className: "cls-10",
    transform: "translate(13.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    className: "cls-357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    className: "cls-10",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    className: "cls-351",
    d: "M-75.47,38.734l-.82-.255.074-.008.82.255-.074.008",
    transform: "translate(76.29 -38.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    className: "cls-348",
    d: "M-75.407,38.727l-.82-.255.155-.011.82.254-.155.011",
    transform: "translate(76.301 -38.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    className: "cls-346",
    d: "M-75.275,38.717l-.82-.255c.056,0,.123,0,.2-.006l.82.256c-.074,0-.141,0-.2,0",
    transform: "translate(76.324 -38.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    className: "cls-344",
    d: "M-75.107,38.713l-.82-.256c.069,0,.144,0,.226,0l.82.255c-.082,0-.157,0-.226,0",
    transform: "translate(76.353 -38.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    className: "cls-342",
    d: "M-74.914,38.715l-.82-.254c.077,0,.161.007.249.014l.82.255c-.088-.007-.171-.012-.249-.014",
    transform: "translate(76.386 -38.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    className: "cls-340",
    d: "M-74.7,38.727l-.82-.255c.083.007.171.016.263.028l.82.255c-.091-.012-.179-.021-.263-.028",
    transform: "translate(76.423 -38.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    className: "cls-338",
    d: "M-74.478,38.751l-.82-.255c.089.012.181.026.276.043l.82.255c-.1-.018-.186-.032-.276-.043",
    transform: "translate(76.461 -38.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    className: "cls-335",
    d: "M-74.243,38.788l-.82-.255c.094.018.19.038.289.062l.82.255c-.1-.023-.195-.045-.289-.062",
    transform: "translate(76.502 -38.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    className: "cls-332",
    d: "M-74,38.841l-.82-.255c.094.023.189.049.285.079l.82.256c-.1-.03-.191-.056-.285-.08",
    transform: "translate(76.545 -38.435)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    className: "cls-10",
    transform: "translate(6.91 0.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    className: "cls-358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    className: "cls-332",
    d: "M-80.81,41.452l-.82-.255c.087.027.177.052.269.074l.82.256c-.091-.023-.182-.048-.269-.075",
    transform: "translate(81.63 -38.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    className: "cls-335",
    d: "M-80.581,41.516l-.82-.256c.084.021.17.04.259.056l.819.255c-.088-.016-.174-.035-.258-.055",
    transform: "translate(81.67 -37.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    className: "cls-338",
    d: "M-80.361,41.563l-.819-.255c.076.014.155.027.236.038l.819.255c-.08-.011-.158-.022-.236-.038",
    transform: "translate(81.708 -37.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    className: "cls-340",
    d: "M-80.16,41.595l-.819-.255c.068.009.138.016.209.022l.82.255c-.07,0-.141-.013-.21-.022",
    transform: "translate(81.743 -37.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    className: "cls-342",
    d: "M-79.981,41.614l-.82-.255c.066.006.131.009.2.012l.82.255c-.067,0-.131-.006-.2-.012",
    transform: "translate(81.773 -37.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    className: "cls-344",
    d: "M-79.813,41.624l-.82-.254c.063,0,.126,0,.19,0l.82.255q-.1,0-.19,0",
    transform: "translate(81.802 -37.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    className: "cls-346",
    d: "M-79.651,41.627l-.82-.255c.056,0,.114,0,.171-.006l.82.256-.171,0",
    transform: "translate(81.83 -37.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    className: "cls-348",
    d: "M-79.505,41.624l-.82-.256c.057,0,.114-.006.172-.012l.82.256-.172.012",
    transform: "translate(81.856 -37.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    className: "cls-351",
    d: "M-79.358,41.615l-.82-.256c.052,0,.1-.009.156-.016l.82.255c-.053.007-.1.013-.156.018",
    transform: "translate(81.881 -37.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    className: "cls-353",
    d: "M-79.225,41.6l-.82-.255.158-.022.82.255c-.053.008-.106.016-.158.022",
    transform: "translate(81.904 -37.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    className: "cls-354",
    d: "M-79.09,41.583l-.82-.255c.049-.008.1-.018.149-.028l.82.256-.149.027",
    transform: "translate(81.927 -37.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    className: "cls-223",
    d: "M-78.963,41.56l-.82-.256c.048-.009.1-.02.147-.032l.82.256-.147.032",
    transform: "translate(81.949 -37.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    className: "cls-220",
    d: "M-78.838,41.534l-.82-.256.106-.026.038-.011.82.256-.038.009-.106.027",
    transform: "translate(81.971 -38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    className: "cls-218",
    d: "M-78.716,41.5l-.82-.256.134-.038.82.255c-.045.014-.089.026-.134.039",
    transform: "translate(81.992 -38.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    className: "cls-216",
    d: "M-78.6,41.471l-.82-.255c.042-.014.086-.027.129-.042l.82.254c-.043.015-.087.029-.129.042",
    transform: "translate(82.012 -38.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    className: "cls-214",
    d: "M-78.492,41.435l-.82-.255c.043-.014.086-.029.128-.046l.82.255c-.042.016-.086.032-.128.046",
    transform: "translate(82.031 -38.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    className: "cls-210",
    d: "M-78.383,41.4l-.82-.255c.043-.015.086-.033.129-.05l.819.256c-.042.018-.084.034-.128.049",
    transform: "translate(82.05 -38.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    className: "cls-208",
    d: "M-78.274,41.359l-.819-.256c.057-.023.115-.048.174-.075l.82.256c-.059.026-.116.052-.175.075",
    transform: "translate(82.069 -38.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    className: "cls-359",
    d: "M-78.125,41.383l-.82-.256a5.388,5.388,0,0,0,1.1-.677l.82.256a5.493,5.493,0,0,1-1.1.677",
    transform: "translate(82.094 -38.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    className: "cls-360",
    d: "M-77.189,40.748l-.82-.256c.113-.088.224-.182.337-.283l.82.254c-.113.1-.225.2-.337.284",
    transform: "translate(82.256 -38.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    className: "cls-257",
    d: "M-76.9,40.5l-.82-.255c.076-.068.152-.14.229-.213l.82.254c-.076.074-.152.145-.229.213",
    transform: "translate(82.305 -38.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    className: "cls-268",
    d: "M-76.707,40.31l-.82-.255c.062-.06.123-.122.184-.185l.82.255c-.061.063-.123.125-.184.185",
    transform: "translate(82.339 -38.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    className: "cls-361",
    d: "M-76.55,40.15l-.82-.255c.053-.055.106-.111.158-.17l.82.255c-.053.059-.106.115-.158.17",
    transform: "translate(82.366 -38.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    className: "cls-362",
    d: "M-76.415,40l-.82-.255q.072-.079.144-.162l.819.256c-.047.055-.1.109-.143.161",
    transform: "translate(82.39 -38.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    className: "cls-363",
    d: "M-76.293,39.866l-.819-.256c.043-.05.088-.1.131-.156l.82.255c-.043.054-.088.106-.133.157",
    transform: "translate(82.411 -38.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    className: "cls-364",
    d: "M-76.18,39.732l-.82-.255c.042-.05.084-.1.127-.156l.82.256q-.063.079-.127.155",
    transform: "translate(82.43 -38.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    className: "cls-365",
    d: "M-76.072,39.6l-.82-.256c.041-.05.082-.1.123-.157l.82.255q-.062.081-.123.158",
    transform: "translate(82.449 -38.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    className: "cls-366",
    d: "M-75.967,39.465l-.82-.255c.041-.053.082-.107.122-.162l.82.254c-.041.055-.081.109-.122.162",
    transform: "translate(82.467 -38.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    className: "cls-367",
    d: "M-75.863,39.329l-.82-.255c.041-.055.082-.113.123-.17l.82.255c-.041.059-.082.115-.123.17",
    transform: "translate(82.485 -38.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    className: "cls-368",
    d: "M-75.758,39.185l-.82-.255c.042-.059.084-.12.125-.181l.82.255c-.042.062-.083.122-.125.181",
    transform: "translate(82.503 -38.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    className: "cls-369",
    d: "M-75.651,39.033l-.82-.255q.065-.1.13-.194l.82.254q-.065.1-.13.194",
    transform: "translate(82.522 -38.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    className: "cls-370",
    d: "M-75.54,38.858l-.82-.255c.027-.042.055-.083.082-.126l.82.255-.082.125",
    transform: "translate(82.541 -38.478)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    className: "cls-10",
    transform: "translate(0 2.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    className: "cls-371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    className: "cls-10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    className: "cls-214",
    d: "M-86.689,47.216l-.82-.255,0-.035.82.255,0,.035",
    transform: "translate(87.523 -39.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    className: "cls-210",
    d: "M-86.69,47.193l-.82-.255,0-.082.82.255,0,.082",
    transform: "translate(87.522 -39.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    className: "cls-208",
    d: "M-86.695,47.124l-.82-.255,0-.089.82.255,0,.089",
    transform: "translate(87.521 -39.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    className: "cls-359",
    d: "M-86.7,47.055l-.82-.255c0-.042,0-.088,0-.141l.82.256c0,.052,0,.1,0,.14",
    transform: "translate(87.521 -39.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    className: "cls-360",
    d: "M-86.7,46.951l-.82-.256c0-.069,0-.149,0-.237l.82.254c0,.088,0,.168,0,.238",
    transform: "translate(87.521 -39.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    className: "cls-257",
    d: "M-86.7,46.755l-.82-.255c0-.088.006-.185.012-.291l.82.256c-.006.1-.009.2-.012.29",
    transform: "translate(87.521 -39.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    className: "cls-268",
    d: "M-86.69,46.5l-.82-.256c0-.076.009-.158.018-.243l.82.255c-.008.086-.013.167-.018.244",
    transform: "translate(87.523 -39.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    className: "cls-361",
    d: "M-86.675,46.288l-.82-.255c0-.067.012-.135.02-.206l.82.255c-.008.072-.015.141-.02.206",
    transform: "translate(87.525 -39.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    className: "cls-362",
    d: "M-86.658,46.108l-.82-.255c.006-.059.013-.12.021-.182l.82.255c-.008.062-.015.123-.021.182",
    transform: "translate(87.528 -39.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    className: "cls-363",
    d: "M-86.64,45.951l-.82-.255c.007-.055.015-.11.023-.168l.82.255c-.008.057-.016.113-.023.168",
    transform: "translate(87.532 -39.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    className: "cls-364",
    d: "M-86.62,45.808l-.82-.255c.008-.054.018-.11.027-.167l.82.255c-.009.056-.019.113-.027.167",
    transform: "translate(87.535 -39.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    className: "cls-365",
    d: "M-86.6,45.663l-.82-.255c.008-.047.016-.1.026-.143l.82.256c-.009.048-.018.1-.026.142",
    transform: "translate(87.539 -39.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    className: "cls-366",
    d: "M-86.575,45.542l-.82-.256c.008-.048.019-.1.028-.145l.82.255c-.011.049-.02.1-.028.147",
    transform: "translate(87.543 -39.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    className: "cls-367",
    d: "M-86.551,45.417l-.82-.255.032-.148.82.255q-.018.076-.032.148",
    transform: "translate(87.547 -39.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    className: "cls-368",
    d: "M-86.524,45.29l-.82-.255c.011-.047.021-.094.033-.142l.82.256c-.012.047-.022.094-.033.141",
    transform: "translate(87.552 -39.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    className: "cls-369",
    d: "M-86.5,45.171l-.82-.256c.012-.047.023-.1.036-.143l.819.255-.035.144",
    transform: "translate(87.556 -39.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    className: "cls-370",
    d: "M-86.466,45.048l-.819-.255c.012-.048.025-.1.039-.145l.82.255c-.014.048-.027.1-.04.145",
    transform: "translate(87.562 -39.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    className: "cls-372",
    d: "M-86.432,44.928l-.82-.255c.015-.057.032-.114.049-.171l.82.256c-.018.056-.034.114-.049.17",
    transform: "translate(87.567 -39.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    className: "cls-373",
    d: "M-86.39,44.783l-.82-.256c.018-.057.036-.116.055-.175l.82.255c-.02.059-.038.117-.055.176",
    transform: "translate(87.575 -39.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    className: "cls-374",
    d: "M-86.343,44.637l-.82-.255c.021-.066.043-.131.067-.2l.82.255c-.023.067-.046.133-.067.2",
    transform: "translate(87.583 -39.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    className: "cls-375",
    d: "M-86.286,44.492l-.82-.255q.065-.181.141-.366l.82.254q-.076.185-.141.366",
    transform: "translate(87.593 -39.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    className: "cls-376",
    d: "M-86.166,44.166l-.82-.254c.036-.089.075-.177.115-.266l.82.254c-.041.089-.079.178-.115.266",
    transform: "translate(87.613 -39.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    className: "cls-375",
    d: "M-86.068,43.961l-.82-.255c.063-.138.131-.278.206-.418l.82.256c-.075.138-.143.278-.206.416",
    transform: "translate(87.63 -39.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    className: "cls-374",
    d: "M-85.892,43.568l-.82-.256c.028-.053.057-.107.088-.16l.819.255c-.029.053-.059.107-.087.161",
    transform: "translate(87.661 -39.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    className: "cls-373",
    d: "M-85.818,43.431l-.819-.255c.029-.054.061-.107.093-.161l.82.256c-.032.053-.063.106-.094.16",
    transform: "translate(87.674 -39.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    className: "cls-372",
    d: "M-85.738,43.293l-.82-.256c.028-.048.059-.1.088-.144l.82.255c-.03.048-.06.1-.088.145",
    transform: "translate(87.687 -39.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    className: "cls-370",
    d: "M-85.663,43.164l-.82-.255.072-.11.82.256c-.025.036-.048.073-.072.109",
    transform: "translate(87.7 -39.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    className: "cls-369",
    d: "M-85.6,43.071l-.82-.256c.023-.036.048-.073.073-.109l.82.255c-.025.036-.049.073-.073.11",
    transform: "translate(87.711 -39.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    className: "cls-368",
    d: "M-85.54,42.977l-.82-.255c.025-.036.05-.073.076-.109l.82.255c-.026.036-.052.073-.076.109",
    transform: "translate(87.722 -39.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    className: "cls-367",
    d: "M-85.475,42.884l-.82-.255c.026-.036.052-.073.079-.109l.82.255c-.027.036-.053.073-.079.109",
    transform: "translate(87.733 -39.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    className: "cls-366",
    d: "M-85.408,42.791l-.82-.255.084-.113.82.255-.084.113",
    transform: "translate(87.745 -39.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    className: "cls-365",
    d: "M-85.336,42.7l-.82-.255c.029-.038.059-.075.089-.113l.82.254-.089.113",
    transform: "translate(87.757 -39.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    className: "cls-364",
    d: "M-85.26,42.6l-.82-.255.092-.114.82.256-.091.113",
    transform: "translate(87.77 -39.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    className: "cls-363",
    d: "M-85.182,42.5l-.82-.256.1-.111.82.255-.1.113",
    transform: "translate(87.784 -39.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    className: "cls-362",
    d: "M-85.1,42.409l-.82-.255c.036-.042.075-.084.113-.127l.82.255q-.058.063-.113.127",
    transform: "translate(87.798 -39.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    className: "cls-361",
    d: "M-85,42.307l-.82-.255c.05-.055.1-.109.154-.163l.82.255c-.053.054-.1.108-.154.163",
    transform: "translate(87.814 -40.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    className: "cls-268",
    d: "M-84.873,42.167l-.82-.255c.053-.054.107-.108.162-.161l.819.255c-.054.053-.108.107-.161.161",
    transform: "translate(87.837 -40.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    className: "cls-257",
    d: "M-84.736,42.038l-.819-.255c.073-.072.149-.142.228-.212l.82.255c-.079.07-.155.141-.229.212",
    transform: "translate(87.861 -40.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    className: "cls-360",
    d: "M-84.541,41.87l-.82-.255c.117-.1.239-.205.367-.3l.82.255c-.128.1-.25.2-.367.3",
    transform: "translate(87.894 -40.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    className: "cls-359",
    d: "M-84.228,41.694l-.82-.255a8.111,8.111,0,0,1,1.393-.871l.82.254a8.183,8.183,0,0,0-1.393.871",
    transform: "translate(87.948 -40.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    className: "cls-208",
    d: "M-83.04,40.857l-.82-.255q.248-.123.516-.237l.82.256q-.267.113-.516.236",
    transform: "translate(88.154 -40.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    className: "cls-210",
    d: "M-82.6,40.635l-.82-.256.218-.089.82.254c-.074.029-.147.06-.218.09",
    transform: "translate(88.23 -40.29)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0.82 0.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2504-2",
    "data-name": "Path 2504",
    className: "cls-9",
    d: "M-73.65,38.7c.243-.028,4.876-.549,5.3,5.127a35.691,35.691,0,0,1-9.11,3.666,34.248,34.248,0,0,1-9.344,1.151,7.8,7.8,0,0,1,5.014-7.818,4.819,4.819,0,0,0,4.3,1.127A6.821,6.821,0,0,0-73.65,38.7Z",
    transform: "translate(86.822 -38.674)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    className: "cls-10",
    transform: "translate(4.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    className: "cls-10",
    transform: "translate(5.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    className: "cls-377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    className: "cls-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    className: "cls-220",
    d: "M-78.41,24.689l-.819-.255.1-.026.82.255-.1.026",
    transform: "translate(79.229 -24.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    className: "cls-223",
    d: "M-78.321,24.668l-.82-.255c.048-.012.1-.022.143-.032l.82.255c-.047.009-.095.02-.143.032",
    transform: "translate(79.244 -24.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    className: "cls-354",
    d: "M-78.2,24.64l-.82-.255.142-.026.82.255-.142.026",
    transform: "translate(79.265 -24.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    className: "cls-353",
    d: "M-78.078,24.618l-.82-.255c.048-.008.1-.014.142-.021l.82.256-.142.02",
    transform: "translate(79.286 -24.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    className: "cls-351",
    d: "M-77.957,24.6l-.82-.256.142-.015.82.256c-.047,0-.094.008-.142.015",
    transform: "translate(79.307 -24.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    className: "cls-348",
    d: "M-77.836,24.586l-.82-.256.141-.009.82.255q-.07,0-.141.011",
    transform: "translate(79.328 -24.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    className: "cls-346",
    d: "M-77.716,24.576l-.82-.255q.072,0,.144,0l.82.255q-.072,0-.144,0",
    transform: "translate(79.349 -24.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    className: "cls-344",
    d: "M-77.593,24.573l-.82-.255c.049,0,.1,0,.147,0l.82.255c-.049,0-.1,0-.147,0",
    transform: "translate(79.37 -24.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    className: "cls-342",
    d: "M-77.468,24.575l-.82-.255c.048,0,.1,0,.143.008l.82.255c-.047,0-.1-.007-.143-.008",
    transform: "translate(79.392 -24.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    className: "cls-340",
    d: "M-77.346,24.582l-.82-.255c.054,0,.107.009.16.016l.819.255-.158-.016",
    transform: "translate(79.413 -24.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    className: "cls-338",
    d: "M-77.211,24.6l-.819-.255c.053.007.106.015.157.026l.82.255-.158-.026",
    transform: "translate(79.436 -24.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    className: "cls-335",
    d: "M-77.076,24.618l-.82-.255c.057.011.114.022.169.036l.82.255c-.056-.013-.113-.026-.169-.036",
    transform: "translate(79.459 -24.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    className: "cls-332",
    d: "M-76.932,24.649l-.82-.255c.055.014.11.029.164.046l.82.255c-.054-.016-.109-.032-.164-.046",
    transform: "translate(79.484 -24.304)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    className: "cls-10",
    transform: "translate(0 0.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    className: "cls-378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    className: "cls-10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    className: "cls-315",
    d: "M-79.69,38.993l-.82-.255a2.577,2.577,0,0,1-.707-.353l.819.255a2.518,2.518,0,0,0,.708.353",
    transform: "translate(83.925 -22.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    className: "cls-318",
    d: "M-80.353,38.675l-.819-.255a3.282,3.282,0,0,1-.307-.243l.82.254a3.225,3.225,0,0,0,.306.243",
    transform: "translate(83.879 -22.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    className: "cls-321",
    d: "M-80.622,38.469l-.82-.255q-.128-.116-.25-.246l.819.255c.082.088.165.17.251.246",
    transform: "translate(83.843 -22.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    className: "cls-323",
    d: "M-80.84,38.261l-.819-.255c-.077-.082-.151-.169-.224-.259l.819.255c.074.09.148.177.224.259",
    transform: "translate(83.81 -22.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    className: "cls-325",
    d: "M-81.034,38.042l-.819-.254c-.07-.088-.14-.181-.206-.276l.82.254c.067.1.136.188.205.276",
    transform: "translate(83.779 -22.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    className: "cls-327",
    d: "M-81.211,37.81l-.82-.255c-.066-.094-.13-.192-.192-.293l.82.255c.062.1.127.2.192.293",
    transform: "translate(83.751 -22.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    className: "cls-329",
    d: "M-81.376,37.563l-.82-.254c-.062-.1-.123-.206-.182-.314l.82.255c.059.108.12.213.182.314",
    transform: "translate(83.724 -22.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    className: "cls-332",
    d: "M-81.533,37.3l-.82-.255c-.059-.107-.115-.216-.17-.328l.82.255c.055.113.111.222.17.328",
    transform: "translate(83.699 -22.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    className: "cls-335",
    d: "M-81.681,37.016l-.82-.255c-.05-.107-.1-.215-.149-.325l.82.255c.048.11.1.219.149.325",
    transform: "translate(83.677 -22.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    className: "cls-338",
    d: "M-81.81,36.74l-.82-.255c-.047-.107-.093-.217-.136-.327l.82.255c.043.111.089.221.136.327",
    transform: "translate(83.657 -22.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    className: "cls-340",
    d: "M-81.928,36.461l-.82-.255c-.043-.109-.084-.219-.124-.332l.82.255c.04.113.081.223.124.332",
    transform: "translate(83.639 -22.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    className: "cls-342",
    d: "M-82.036,36.178l-.82-.255c-.039-.108-.075-.217-.111-.327l.82.254c.036.11.073.219.111.327",
    transform: "translate(83.622 -22.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    className: "cls-344",
    d: "M-82.132,35.9l-.82-.255c-.035-.11-.069-.222-.1-.333l.819.255c.033.113.067.223.1.333",
    transform: "translate(83.607 -22.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    className: "cls-346",
    d: "M-82.221,35.615l-.819-.255c-.033-.109-.062-.219-.091-.331l.82.255c.028.111.059.222.09.331",
    transform: "translate(83.594 -22.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    className: "cls-348",
    d: "M-82.3,35.333l-.82-.255c-.029-.109-.056-.219-.082-.331l.82.255c.026.111.053.222.082.331",
    transform: "translate(83.582 -22.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    className: "cls-351",
    d: "M-82.371,35.051l-.82-.255c-.026-.108-.049-.217-.073-.327l.82.255c.022.11.047.219.073.327",
    transform: "translate(83.571 -22.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    className: "cls-353",
    d: "M-82.434,34.771l-.82-.255c-.022-.107-.043-.213-.063-.321l.82.256q.03.16.063.32",
    transform: "translate(83.562 -22.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    className: "cls-354",
    d: "M-82.489,34.5l-.82-.256c-.02-.1-.038-.21-.055-.317l.82.254c.018.107.035.212.055.318",
    transform: "translate(83.554 -22.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    className: "cls-223",
    d: "M-82.537,34.224l-.82-.255q-.025-.151-.046-.3l.82.255q.021.151.046.3",
    transform: "translate(83.547 -22.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    className: "cls-220",
    d: "M-82.578,33.965l-.82-.255c-.014-.1-.027-.2-.039-.3l.82.255c.012.1.025.2.039.3",
    transform: "translate(83.541 -22.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    className: "cls-218",
    d: "M-82.612,33.71l-.82-.254c-.012-.094-.022-.186-.032-.28l.82.256c.009.093.02.185.032.279",
    transform: "translate(83.536 -22.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    className: "cls-216",
    d: "M-82.64,33.47l-.82-.256-.025-.265.82.255c.008.088.016.177.025.266",
    transform: "translate(83.533 -22.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    className: "cls-214",
    d: "M-82.661,33.242l-.82-.255c-.007-.087-.013-.172-.019-.258l.82.256c.006.086.012.171.019.257",
    transform: "translate(83.53 -22.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    className: "cls-210",
    d: "M-82.678,33.018l-.82-.256c0-.076-.009-.151-.013-.228l.82.255c0,.076.008.152.013.229",
    transform: "translate(83.528 -23.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    className: "cls-208",
    d: "M-82.69,32.823l-.82-.255c0-.075-.007-.151-.009-.226l.82.255c0,.075.006.151.009.226",
    transform: "translate(83.527 -23.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    className: "cls-359",
    d: "M-82.7,32.645l-.82-.255c0-.109-.006-.218-.007-.326l.82.255c0,.108,0,.217.007.326",
    transform: "translate(83.526 -23.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    className: "cls-360",
    d: "M-82.705,32.381l-.82-.255c0-.133,0-.264,0-.394v-.027l.82.256v.026c0,.13,0,.262,0,.394",
    transform: "translate(83.526 -23.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    className: "cls-257",
    d: "M-82.7,32.027l-.82-.256c0-.15.009-.3.018-.452l.82.255c-.008.15-.014.3-.018.453",
    transform: "translate(83.526 -23.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    className: "cls-268",
    d: "M-82.688,31.627l-.82-.255c.007-.12.015-.238.026-.358l.82.255c-.011.12-.019.238-.026.358",
    transform: "translate(83.529 -23.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    className: "cls-361",
    d: "M-82.666,31.317l-.82-.255c.009-.107.02-.215.032-.321l.819.255c-.012.107-.021.215-.03.321",
    transform: "translate(83.533 -23.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    className: "cls-362",
    d: "M-82.64,31.033l-.819-.255c.009-.086.019-.171.03-.257l.82.255c-.012.086-.021.171-.032.257",
    transform: "translate(83.537 -23.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    className: "cls-363",
    d: "M-82.613,30.813l-.82-.255q.016-.123.035-.246l.819.255c-.012.082-.023.164-.034.246",
    transform: "translate(83.542 -23.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    className: "cls-364",
    d: "M-82.584,30.6l-.819-.255c.011-.077.023-.154.036-.23l.82.255c-.013.076-.026.154-.038.23",
    transform: "translate(83.547 -23.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    className: "cls-365",
    d: "M-82.552,30.4l-.82-.255c.012-.072.025-.143.038-.213l.82.255c-.013.072-.026.142-.038.213",
    transform: "translate(83.552 -23.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    className: "cls-366",
    d: "M-82.52,30.22l-.82-.255c.014-.07.027-.142.042-.212l.82.256c-.015.07-.028.141-.042.211",
    transform: "translate(83.558 -23.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    className: "cls-367",
    d: "M-82.484,30.039l-.82-.256c.014-.068.028-.136.043-.2l.82.255c-.015.068-.029.136-.043.205",
    transform: "translate(83.564 -23.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    className: "cls-368",
    d: "M-82.447,29.863l-.82-.255c.015-.067.03-.134.047-.2l.82.255c-.016.067-.032.134-.047.2",
    transform: "translate(83.57 -23.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    className: "cls-369",
    d: "M-82.407,29.692l-.82-.255c.015-.067.033-.134.049-.2l.82.255c-.016.067-.034.133-.049.2",
    transform: "translate(83.577 -23.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    className: "cls-370",
    d: "M-82.365,29.525l-.82-.255c.019-.074.039-.147.06-.219l.82.255c-.021.073-.041.147-.06.219",
    transform: "translate(83.584 -23.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    className: "cls-372",
    d: "M-82.314,29.338l-.82-.255q.03-.109.063-.218l.819.255c-.021.073-.042.145-.062.218",
    transform: "translate(83.593 -23.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    className: "cls-373",
    d: "M-82.261,29.156l-.819-.255c.025-.083.05-.165.076-.247l.82.256c-.026.081-.052.164-.077.246",
    transform: "translate(83.603 -23.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    className: "cls-374",
    d: "M-82.2,28.951l-.82-.256c.032-.094.063-.188.1-.281l.82.256c-.033.093-.065.186-.1.281",
    transform: "translate(83.614 -23.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    className: "cls-375",
    d: "M-82.113,28.74l-.82-.256c.057-.161.117-.319.181-.474l.82.255c-.063.156-.123.314-.181.475",
    transform: "translate(83.628 -23.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    className: "cls-376",
    d: "M-81.959,28.34l-.82-.255q.107-.262.225-.511l.82.255c-.079.167-.154.338-.225.511",
    transform: "translate(83.655 -23.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    className: "cls-375",
    d: "M-81.767,27.887l-.82-.255c.065-.135.13-.266.2-.4l.82.256c-.068.129-.135.26-.2.394",
    transform: "translate(83.688 -23.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    className: "cls-374",
    d: "M-81.6,27.53l-.82-.256c.046-.084.093-.169.14-.252l.82.255c-.048.083-.094.168-.14.253",
    transform: "translate(83.717 -23.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    className: "cls-373",
    d: "M-81.479,27.3l-.82-.255c.03-.053.061-.106.093-.157l.819.255-.091.157",
    transform: "translate(83.738 -24.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    className: "cls-372",
    d: "M-81.4,27.165l-.819-.255c.031-.053.062-.1.094-.155l.82.255-.1.155",
    transform: "translate(83.751 -24.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    className: "cls-370",
    d: "M-81.32,27.032l-.82-.255.093-.144.82.256c-.032.047-.062.095-.093.143",
    transform: "translate(83.765 -24.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    className: "cls-369",
    d: "M-81.241,26.907l-.82-.256.082-.122.82.256c-.028.04-.055.081-.082.122",
    transform: "translate(83.779 -24.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    className: "cls-368",
    d: "M-81.171,26.8l-.82-.256c.027-.04.055-.08.083-.12l.82.255c-.028.04-.056.08-.083.121",
    transform: "translate(83.791 -24.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    className: "cls-367",
    d: "M-81.1,26.7l-.82-.255.084-.117.82.255-.084.117",
    transform: "translate(83.803 -24.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    className: "cls-366",
    d: "M-81.028,26.6l-.82-.255.088-.117.82.255-.088.117",
    transform: "translate(83.816 -24.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    className: "cls-365",
    d: "M-80.953,26.5l-.82-.255.091-.115.819.255c-.031.038-.06.076-.09.115",
    transform: "translate(83.829 -24.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    className: "cls-364",
    d: "M-80.876,26.4l-.819-.255c.029-.039.061-.076.091-.114l.82.255c-.03.038-.062.075-.093.114",
    transform: "translate(83.842 -24.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    className: "cls-363",
    d: "M-80.8,26.3l-.82-.255c.033-.04.067-.079.1-.117l.82.255c-.034.039-.067.077-.1.117",
    transform: "translate(83.856 -24.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    className: "cls-362",
    d: "M-80.712,26.206l-.82-.255.118-.134.82.256c-.04.043-.08.088-.118.133",
    transform: "translate(83.87 -24.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    className: "cls-361",
    d: "M-80.611,26.093l-.82-.256c.04-.043.081-.086.121-.128l.82.255c-.04.042-.081.084-.121.129",
    transform: "translate(83.888 -24.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    className: "cls-268",
    d: "M-80.508,25.986l-.82-.255c.052-.054.1-.106.156-.156l.82.255c-.053.05-.1.1-.156.156",
    transform: "translate(83.906 -24.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    className: "cls-257",
    d: "M-80.375,25.857l-.82-.255c.063-.062.128-.122.194-.181l.82.255c-.066.059-.13.118-.194.181",
    transform: "translate(83.929 -24.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    className: "cls-360",
    d: "M-80.21,25.715l-.82-.255c.1-.09.205-.177.312-.259l.819.255c-.106.082-.21.169-.311.259",
    transform: "translate(83.957 -24.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    className: "cls-359",
    d: "M-79.945,25.542l-.819-.255a5.251,5.251,0,0,1,.944-.588l.82.255a5.261,5.261,0,0,0-.945.588",
    transform: "translate(84.003 -24.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    className: "cls-208",
    d: "M-79.139,24.968l-.82-.255c.065-.032.13-.061.2-.089l.82.255c-.067.028-.131.057-.2.089",
    transform: "translate(84.142 -24.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    className: "cls-210",
    d: "M-78.972,24.89l-.82-.255c.066-.028.133-.055.2-.081l.82.256c-.068.025-.134.052-.2.08",
    transform: "translate(84.171 -24.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    className: "cls-214",
    d: "M-78.8,24.818l-.82-.256.142-.05.82.255-.142.052",
    transform: "translate(84.2 -24.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    className: "cls-216",
    d: "M-78.681,24.773l-.82-.255.138-.045.82.255-.138.045",
    transform: "translate(84.221 -24.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    className: "cls-218",
    d: "M-78.563,24.734l-.82-.255.141-.04.82.255-.141.04",
    transform: "translate(84.242 -24.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    className: "cls-220",
    d: "M-78.443,24.7l-.82-.255.04-.011.819.255-.039.011",
    transform: "translate(84.262 -24.431)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0.819 0.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    className: "cls-9",
    d: "M-77.788,24.668c3-.782,4.818,1.982,4.738,6.007s-2.076,9.948-5.073,10.73-4.782-4.165-4.7-8.179S-80.792,25.452-77.788,24.668Z",
    transform: "translate(82.827 -24.535)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(25.365 21.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117-2",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108-2",
    "data-name": "Group 108",
    className: "cls-10",
    transform: "translate(0 20.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100-2",
    "data-name": "Group 100",
    className: "cls-10",
    transform: "translate(16.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99-2",
    "data-name": "Group 99",
    className: "cls-379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98-2",
    "data-name": "Group 98",
    className: "cls-10",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2418-2",
    "data-name": "Path 2418",
    className: "cls-351",
    d: "M-75.292,38.791l-1-.31c.016,0,.046-.006.09-.01l1,.31-.09.01",
    transform: "translate(76.29 -38.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419-2",
    "data-name": "Path 2419",
    className: "cls-348",
    d: "M-75.229,38.785l-1-.31c.047,0,.111-.009.188-.013l1,.31q-.118.006-.188.013",
    transform: "translate(76.317 -38.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420-2",
    "data-name": "Path 2420",
    className: "cls-346",
    d: "M-75.1,38.774l-1-.31c.069,0,.15-.006.24-.007l1,.311c-.09,0-.171,0-.24.006",
    transform: "translate(76.373 -38.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421-2",
    "data-name": "Path 2421",
    className: "cls-344",
    d: "M-74.929,38.768l-1-.311c.084,0,.176,0,.276,0l1,.31c-.1,0-.191,0-.275,0",
    transform: "translate(76.445 -38.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422-2",
    "data-name": "Path 2422",
    className: "cls-342",
    d: "M-74.736,38.77l-1-.31c.094,0,.2.009.3.017l1,.31c-.107-.009-.208-.014-.3-.017",
    transform: "translate(76.528 -38.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423-2",
    "data-name": "Path 2423",
    className: "cls-340",
    d: "M-74.524,38.782l-1-.31c.1.009.208.02.32.034l1,.31c-.111-.014-.218-.026-.32-.034",
    transform: "translate(76.618 -38.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424-2",
    "data-name": "Path 2424",
    className: "cls-338",
    d: "M-74.3,38.806l-1-.31c.108.014.22.031.335.053l1,.31c-.116-.021-.227-.039-.335-.053",
    transform: "translate(76.714 -38.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425-2",
    "data-name": "Path 2425",
    className: "cls-335",
    d: "M-74.065,38.843l-1-.31c.114.021.231.046.351.076l1,.31c-.12-.029-.237-.054-.351-.076",
    transform: "translate(76.814 -38.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426-2",
    "data-name": "Path 2426",
    className: "cls-332",
    d: "M-73.819,38.9l-1-.31c.114.029.23.06.347.1l1,.311c-.117-.037-.233-.069-.347-.1",
    transform: "translate(76.92 -38.402)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103-2",
    "data-name": "Group 103",
    className: "cls-10",
    transform: "translate(8.409 0.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102-2",
    "data-name": "Group 102",
    className: "cls-380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101-2",
    "data-name": "Group 101",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2428-2",
    "data-name": "Path 2428",
    className: "cls-332",
    d: "M-80.632,41.507l-1-.31c.106.033.216.063.327.09l1,.311c-.111-.029-.221-.059-.327-.091",
    transform: "translate(81.63 -37.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429-2",
    "data-name": "Path 2429",
    className: "cls-335",
    d: "M-80.4,41.571l-1-.311c.1.026.207.049.315.069l1,.31c-.107-.02-.211-.043-.314-.067",
    transform: "translate(81.728 -37.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430-2",
    "data-name": "Path 2430",
    className: "cls-338",
    d: "M-80.184,41.618l-1-.31c.093.017.188.033.287.046l1,.31c-.1-.013-.193-.027-.287-.046",
    transform: "translate(81.822 -37.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431-2",
    "data-name": "Path 2431",
    className: "cls-340",
    d: "M-79.983,41.65l-1-.31c.083.011.168.02.254.027l1,.31c-.086-.006-.171-.016-.256-.027",
    transform: "translate(81.908 -37.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432-2",
    "data-name": "Path 2432",
    className: "cls-342",
    d: "M-79.8,41.669l-1-.31c.08.007.16.011.24.014l1,.31c-.081,0-.16-.007-.24-.014",
    transform: "translate(81.984 -37.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433-2",
    "data-name": "Path 2433",
    className: "cls-344",
    d: "M-79.635,41.679l-1-.31c.077,0,.153,0,.231,0l1,.31q-.118,0-.231,0",
    transform: "translate(82.056 -37.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434-2",
    "data-name": "Path 2434",
    className: "cls-346",
    d: "M-79.473,41.684l-1-.31c.069,0,.138,0,.208-.007l1,.311-.208.006",
    transform: "translate(82.125 -37.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435-2",
    "data-name": "Path 2435",
    className: "cls-348",
    d: "M-79.327,41.682l-1-.311c.07,0,.138-.007.21-.014l1,.311-.21.014",
    transform: "translate(82.188 -37.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436-2",
    "data-name": "Path 2436",
    className: "cls-351",
    d: "M-79.18,41.674l-1-.311c.063-.006.127-.011.19-.02l1,.31c-.064.009-.127.016-.19.021",
    transform: "translate(82.251 -37.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437-2",
    "data-name": "Path 2437",
    className: "cls-353",
    d: "M-79.047,41.661l-1-.31.193-.027,1,.31c-.064.01-.128.02-.193.027",
    transform: "translate(82.307 -37.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438-2",
    "data-name": "Path 2438",
    className: "cls-354",
    d: "M-78.912,41.644l-1-.31c.06-.01.12-.021.181-.034l1,.311-.181.033",
    transform: "translate(82.365 -37.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439-2",
    "data-name": "Path 2439",
    className: "cls-223",
    d: "M-78.785,41.623l-1-.311c.059-.011.118-.024.178-.039l1,.311-.178.039",
    transform: "translate(82.419 -37.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440-2",
    "data-name": "Path 2440",
    className: "cls-220",
    d: "M-78.66,41.6l-1-.311.128-.031.046-.013,1,.311-.046.011-.128.033",
    transform: "translate(82.473 -37.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441-2",
    "data-name": "Path 2441",
    className: "cls-218",
    d: "M-78.538,41.567l-1-.311.163-.046,1,.31c-.054.017-.108.031-.163.047",
    transform: "translate(82.525 -37.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442-2",
    "data-name": "Path 2442",
    className: "cls-216",
    d: "M-78.424,41.535l-1-.31c.051-.017.1-.033.157-.051l1,.31c-.053.019-.106.036-.157.051",
    transform: "translate(82.574 -37.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443-2",
    "data-name": "Path 2443",
    className: "cls-214",
    d: "M-78.314,41.5l-1-.31c.053-.017.1-.036.156-.056l1,.31c-.051.02-.1.039-.156.056",
    transform: "translate(82.621 -37.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444-2",
    "data-name": "Path 2444",
    className: "cls-210",
    d: "M-78.205,41.463l-1-.31c.053-.019.1-.04.157-.061l1,.311c-.051.021-.1.041-.156.06",
    transform: "translate(82.667 -37.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445-2",
    "data-name": "Path 2445",
    className: "cls-208",
    d: "M-78.1,41.431l-1-.311c.07-.029.14-.059.211-.091l1,.311c-.071.031-.141.063-.213.091",
    transform: "translate(82.714 -37.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446-2",
    "data-name": "Path 2446",
    className: "cls-359",
    d: "M-77.947,41.586l-1-.311a6.557,6.557,0,0,0,1.336-.824l1,.311a6.686,6.686,0,0,1-1.336.824",
    transform: "translate(82.778 -37.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447-2",
    "data-name": "Path 2447",
    className: "cls-360",
    d: "M-77.011,40.865l-1-.311c.137-.107.273-.221.41-.344l1,.31c-.137.123-.274.238-.41.345",
    transform: "translate(83.178 -37.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448-2",
    "data-name": "Path 2448",
    className: "cls-257",
    d: "M-76.724,40.6l-1-.31c.093-.083.186-.17.278-.26l1,.31c-.093.09-.186.177-.278.26",
    transform: "translate(83.3 -37.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449-2",
    "data-name": "Path 2449",
    className: "cls-268",
    d: "M-76.529,40.405l-1-.31c.076-.073.15-.148.224-.226l1,.31c-.074.077-.15.153-.224.226",
    transform: "translate(83.384 -37.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450-2",
    "data-name": "Path 2450",
    className: "cls-361",
    d: "M-76.372,40.242l-1-.31c.064-.067.128-.136.193-.207l1,.31c-.064.071-.128.14-.193.207",
    transform: "translate(83.451 -37.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451-2",
    "data-name": "Path 2451",
    className: "cls-362",
    d: "M-76.237,40.094l-1-.31q.088-.1.176-.2l1,.311c-.057.067-.116.133-.174.2",
    transform: "translate(83.508 -38.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452-2",
    "data-name": "Path 2452",
    className: "cls-363",
    d: "M-76.116,39.955l-1-.311c.053-.061.107-.124.16-.19l1,.31c-.053.066-.107.128-.161.191",
    transform: "translate(83.561 -38.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453-2",
    "data-name": "Path 2453",
    className: "cls-364",
    d: "M-76,39.821l-1-.31c.051-.061.1-.124.154-.19l1,.311q-.077.1-.154.188",
    transform: "translate(83.609 -38.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454-2",
    "data-name": "Path 2454",
    className: "cls-365",
    d: "M-75.894,39.689l-1-.311c.05-.061.1-.126.15-.191l1,.31q-.075.1-.15.193",
    transform: "translate(83.655 -38.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455-2",
    "data-name": "Path 2455",
    className: "cls-366",
    d: "M-75.789,39.556l-1-.31c.05-.064.1-.13.148-.2l1,.31c-.05.067-.1.133-.148.2",
    transform: "translate(83.7 -38.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456-2",
    "data-name": "Path 2456",
    className: "cls-367",
    d: "M-75.685,39.421l-1-.31c.05-.067.1-.137.15-.207l1,.31c-.05.071-.1.14-.15.207",
    transform: "translate(83.744 -38.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457-2",
    "data-name": "Path 2457",
    className: "cls-368",
    d: "M-75.58,39.28l-1-.31c.051-.071.1-.146.153-.22l1,.31c-.051.076-.1.148-.153.22",
    transform: "translate(83.789 -38.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458-2",
    "data-name": "Path 2458",
    className: "cls-369",
    d: "M-75.473,39.13l-1-.31q.079-.116.158-.236l1,.31q-.079.12-.158.236",
    transform: "translate(83.835 -38.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459-2",
    "data-name": "Path 2459",
    className: "cls-370",
    d: "M-75.362,38.94l-1-.31c.033-.051.067-.1.1-.153l1,.31-.1.153",
    transform: "translate(83.882 -38.478)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106-2",
    "data-name": "Group 106",
    className: "cls-10",
    transform: "translate(0 2.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105-2",
    "data-name": "Group 105",
    className: "cls-381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104-2",
    "data-name": "Group 104",
    className: "cls-10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2461-2",
    "data-name": "Path 2461",
    className: "cls-214",
    d: "M-86.51,47.279l-1-.31,0-.043,1,.31,0,.043",
    transform: "translate(87.525 -37.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462-2",
    "data-name": "Path 2462",
    className: "cls-210",
    d: "M-86.512,47.266l-1-.31-.006-.1,1,.31.006.1",
    transform: "translate(87.524 -37.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463-2",
    "data-name": "Path 2463",
    className: "cls-208",
    d: "M-86.516,47.2l-1-.31,0-.108,1,.31,0,.108",
    transform: "translate(87.522 -37.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464-2",
    "data-name": "Path 2464",
    className: "cls-359",
    d: "M-86.519,47.141l-1-.31c0-.051,0-.107,0-.171l1,.311c0,.063,0,.12,0,.17",
    transform: "translate(87.521 -37.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465-2",
    "data-name": "Path 2465",
    className: "cls-360",
    d: "M-86.523,47.058l-1-.311c0-.084,0-.181,0-.288l1,.31c0,.107,0,.2,0,.29",
    transform: "translate(87.521 -37.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466-2",
    "data-name": "Path 2466",
    className: "cls-257",
    d: "M-86.522,46.874l-1-.31c0-.107.007-.226.014-.354l1,.311c-.007.127-.011.246-.014.353",
    transform: "translate(87.521 -37.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467-2",
    "data-name": "Path 2467",
    className: "cls-268",
    d: "M-86.512,46.61l-1-.311c.006-.093.011-.193.021-.3l1,.31c-.01.1-.016.2-.021.3",
    transform: "translate(87.526 -37.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468-2",
    "data-name": "Path 2468",
    className: "cls-361",
    d: "M-86.5,46.388l-1-.31c.006-.081.014-.164.024-.251l1,.31c-.01.087-.019.171-.024.251",
    transform: "translate(87.532 -37.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469-2",
    "data-name": "Path 2469",
    className: "cls-362",
    d: "M-86.48,46.2l-1-.31c.007-.071.016-.146.026-.221l1,.31c-.01.076-.019.15-.026.221",
    transform: "translate(87.539 -37.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470-2",
    "data-name": "Path 2470",
    className: "cls-363",
    d: "M-86.462,46.043l-1-.31c.009-.067.019-.134.029-.2l1,.31c-.01.07-.02.137-.029.2",
    transform: "translate(87.547 -38.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471-2",
    "data-name": "Path 2471",
    className: "cls-364",
    d: "M-86.442,45.9l-1-.31c.01-.066.021-.134.033-.2l1,.31c-.011.069-.023.137-.033.2",
    transform: "translate(87.556 -38.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472-2",
    "data-name": "Path 2472",
    className: "cls-365",
    d: "M-86.419,45.749l-1-.31c.01-.057.02-.116.031-.174l1,.311c-.011.059-.021.116-.031.173",
    transform: "translate(87.565 -38.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473-2",
    "data-name": "Path 2473",
    className: "cls-366",
    d: "M-86.4,45.629l-1-.311c.01-.059.023-.117.034-.177l1,.31c-.013.06-.024.12-.034.178",
    transform: "translate(87.575 -38.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474-2",
    "data-name": "Path 2474",
    className: "cls-367",
    d: "M-86.373,45.5l-1-.31.039-.18,1,.31q-.021.092-.039.18",
    transform: "translate(87.585 -38.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475-2",
    "data-name": "Path 2475",
    className: "cls-368",
    d: "M-86.346,45.376l-1-.31c.013-.057.026-.114.04-.173l1,.311c-.014.057-.027.114-.04.171",
    transform: "translate(87.597 -38.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476-2",
    "data-name": "Path 2476",
    className: "cls-369",
    d: "M-86.318,45.257l-1-.311c.014-.057.029-.116.044-.174l1,.31-.043.176",
    transform: "translate(87.609 -38.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477-2",
    "data-name": "Path 2477",
    className: "cls-370",
    d: "M-86.289,45.135l-1-.31c.014-.059.03-.118.047-.177l1,.31c-.017.059-.033.118-.049.177",
    transform: "translate(87.622 -38.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478-2",
    "data-name": "Path 2478",
    className: "cls-372",
    d: "M-86.254,45.02l-1-.31c.019-.07.039-.138.06-.208l1,.311c-.021.069-.041.138-.06.207",
    transform: "translate(87.636 -38.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479-2",
    "data-name": "Path 2479",
    className: "cls-373",
    d: "M-86.212,44.877l-1-.311c.021-.07.044-.141.067-.213l1,.31c-.024.071-.046.143-.067.214",
    transform: "translate(87.654 -38.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480-2",
    "data-name": "Path 2480",
    className: "cls-374",
    d: "M-86.165,44.735l-1-.31c.026-.08.053-.16.081-.241l1,.31c-.029.081-.056.161-.081.241",
    transform: "translate(87.674 -38.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481-2",
    "data-name": "Path 2481",
    className: "cls-375",
    d: "M-86.108,44.627l-1-.31q.079-.221.171-.445l1,.31q-.092.225-.171.445",
    transform: "translate(87.698 -38.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482-2",
    "data-name": "Path 2482",
    className: "cls-376",
    d: "M-85.988,44.279l-1-.31c.044-.108.091-.216.14-.324l1,.31c-.05.108-.1.217-.14.324",
    transform: "translate(87.75 -38.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483-2",
    "data-name": "Path 2483",
    className: "cls-375",
    d: "M-85.89,44.107l-1-.31c.077-.168.16-.338.251-.508l1,.311c-.091.168-.174.338-.251.507",
    transform: "translate(87.792 -39.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484-2",
    "data-name": "Path 2484",
    className: "cls-374",
    d: "M-85.714,43.658l-1-.311c.034-.064.07-.13.107-.194l1,.31c-.036.064-.071.13-.106.2",
    transform: "translate(87.867 -39.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485-2",
    "data-name": "Path 2485",
    className: "cls-373",
    d: "M-85.641,43.521l-1-.31c.036-.066.074-.13.113-.2l1,.311c-.039.064-.077.128-.114.194",
    transform: "translate(87.899 -39.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486-2",
    "data-name": "Path 2486",
    className: "cls-372",
    d: "M-85.56,43.38l-1-.311c.034-.059.071-.117.107-.176l1,.31c-.037.059-.073.117-.107.177",
    transform: "translate(87.933 -39.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487-2",
    "data-name": "Path 2487",
    className: "cls-370",
    d: "M-85.485,43.243l-1-.31.087-.134,1,.311c-.03.044-.059.089-.087.133",
    transform: "translate(87.965 -39.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488-2",
    "data-name": "Path 2488",
    className: "cls-369",
    d: "M-85.424,43.15l-1-.311c.029-.044.059-.089.089-.133l1,.31c-.03.044-.06.089-.088.134",
    transform: "translate(87.991 -39.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489-2",
    "data-name": "Path 2489",
    className: "cls-368",
    d: "M-85.362,43.055l-1-.31c.03-.044.061-.088.093-.133l1,.31c-.031.044-.063.089-.093.133",
    transform: "translate(88.017 -39.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490-2",
    "data-name": "Path 2490",
    className: "cls-367",
    d: "M-85.3,42.963l-1-.31c.031-.044.063-.089.1-.133l1,.31c-.033.044-.064.089-.1.133",
    transform: "translate(88.045 -39.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491-2",
    "data-name": "Path 2491",
    className: "cls-366",
    d: "M-85.23,42.871l-1-.31.1-.137,1,.31-.1.137",
    transform: "translate(88.074 -39.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492-2",
    "data-name": "Path 2492",
    className: "cls-365",
    d: "M-85.158,42.775l-1-.31c.036-.046.071-.091.108-.137l1,.31c-.037.046-.073.091-.109.137",
    transform: "translate(88.104 -39.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493-2",
    "data-name": "Path 2493",
    className: "cls-364",
    d: "M-85.082,42.679l-1-.31.111-.138,1,.311-.111.137",
    transform: "translate(88.137 -39.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494-2",
    "data-name": "Path 2494",
    className: "cls-363",
    d: "M-85,42.583l-1-.311.117-.136,1,.31c-.04.046-.079.091-.117.137",
    transform: "translate(88.17 -39.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495-2",
    "data-name": "Path 2495",
    className: "cls-362",
    d: "M-84.922,42.492l-1-.31c.044-.051.091-.1.137-.154l1,.31q-.071.077-.137.154",
    transform: "translate(88.205 -39.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496-2",
    "data-name": "Path 2496",
    className: "cls-361",
    d: "M-84.826,42.4l-1-.31c.061-.067.123-.133.187-.2l1,.31c-.064.066-.126.131-.187.2",
    transform: "translate(88.246 -39.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497-2",
    "data-name": "Path 2497",
    className: "cls-268",
    d: "M-84.7,42.257l-1-.31c.064-.066.13-.131.2-.2l1,.31c-.066.064-.131.13-.2.2",
    transform: "translate(88.302 -39.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498-2",
    "data-name": "Path 2498",
    className: "cls-257",
    d: "M-84.559,42.139l-1-.31c.089-.087.181-.173.277-.258l1,.31c-.1.086-.188.171-.278.258",
    transform: "translate(88.361 -39.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499-2",
    "data-name": "Path 2499",
    className: "cls-360",
    d: "M-84.363,41.992l-1-.31c.143-.126.291-.25.447-.371l1,.31c-.156.121-.3.246-.447.371",
    transform: "translate(88.444 -39.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500-2",
    "data-name": "Path 2500",
    className: "cls-359",
    d: "M-84.05,41.938l-1-.31a9.872,9.872,0,0,1,1.7-1.061l1,.31a9.96,9.96,0,0,0-1.7,1.061",
    transform: "translate(88.578 -40.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501-2",
    "data-name": "Path 2501",
    className: "cls-208",
    d: "M-82.862,40.964l-1-.31q.3-.15.628-.288l1,.311q-.325.137-.628.287",
    transform: "translate(89.086 -40.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502-2",
    "data-name": "Path 2502",
    className: "cls-210",
    d: "M-82.422,40.71l-1-.311c.087-.036.176-.073.266-.108l1,.31c-.09.036-.178.073-.265.11",
    transform: "translate(89.274 -40.29)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107-2",
    "data-name": "Group 107",
    transform: "translate(0.998 0.31)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-384",
    transform: "matrix(1, 0, 0, 1, -49.67, -45.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2504-3",
    "data-name": "Path 2504",
    className: "cls-9",
    d: "M-70.791,38.7c.3-.034,5.934-.668,6.445,6.239a43.436,43.436,0,0,1-11.087,4.462,41.681,41.681,0,0,1-11.372,1.4,9.492,9.492,0,0,1,6.1-9.515,5.865,5.865,0,0,0,5.233,1.372C-74,42.278-72.372,41.17-70.791,38.7Z",
    transform: "translate(136.49 6.74)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116-2",
    "data-name": "Group 116",
    className: "cls-10",
    transform: "translate(5.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111-2",
    "data-name": "Group 111",
    className: "cls-10",
    transform: "translate(6.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110-2",
    "data-name": "Group 110",
    className: "cls-382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109-2",
    "data-name": "Group 109",
    className: "cls-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2505-2",
    "data-name": "Path 2505",
    className: "cls-220",
    d: "M-78.233,24.75l-1-.31c.041-.011.084-.021.126-.031l1,.31-.127.031",
    transform: "translate(79.229 -24.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506-2",
    "data-name": "Path 2506",
    className: "cls-223",
    d: "M-78.143,24.73l-1-.31c.059-.014.117-.027.174-.039l1,.31c-.057.011-.116.024-.174.039",
    transform: "translate(79.267 -24.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507-2",
    "data-name": "Path 2507",
    className: "cls-354",
    d: "M-78.021,24.7l-1-.31.173-.031,1,.31-.173.031",
    transform: "translate(79.319 -24.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508-2",
    "data-name": "Path 2508",
    className: "cls-353",
    d: "M-77.9,24.677l-1-.31c.059-.01.116-.017.173-.026l1,.311-.173.024",
    transform: "translate(79.37 -24.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509-2",
    "data-name": "Path 2509",
    className: "cls-351",
    d: "M-77.779,24.659l-1-.311.173-.019,1,.311c-.057,0-.114.01-.173.019",
    transform: "translate(79.422 -24.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510-2",
    "data-name": "Path 2510",
    className: "cls-348",
    d: "M-77.658,24.644l-1-.311.171-.011,1,.31q-.086,0-.171.013",
    transform: "translate(79.474 -24.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511-2",
    "data-name": "Path 2511",
    className: "cls-346",
    d: "M-77.538,24.632l-1-.31q.088,0,.176,0l1,.31q-.088,0-.176,0",
    transform: "translate(79.525 -24.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512-2",
    "data-name": "Path 2512",
    className: "cls-344",
    d: "M-77.415,24.628l-1-.31c.06,0,.12,0,.178,0l1,.31c-.06,0-.118,0-.178,0",
    transform: "translate(79.578 -24.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513-2",
    "data-name": "Path 2513",
    className: "cls-342",
    d: "M-77.29,24.63l-1-.31c.058,0,.117,0,.174.01l1,.31c-.057,0-.116-.009-.174-.01",
    transform: "translate(79.631 -24.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514-2",
    "data-name": "Path 2514",
    className: "cls-340",
    d: "M-77.168,24.637l-1-.31c.066,0,.13.011.194.02l1,.31c-.063-.007-.127-.014-.193-.02",
    transform: "translate(79.683 -24.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515-2",
    "data-name": "Path 2515",
    className: "cls-338",
    d: "M-77.034,24.651l-1-.31c.064.009.128.019.191.031l1,.31-.193-.031",
    transform: "translate(79.741 -24.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516-2",
    "data-name": "Path 2516",
    className: "cls-335",
    d: "M-76.9,24.673l-1-.31c.07.013.138.027.206.044l1,.31c-.068-.016-.137-.031-.206-.044",
    transform: "translate(79.799 -24.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517-2",
    "data-name": "Path 2517",
    className: "cls-332",
    d: "M-76.754,24.7l-1-.31c.067.017.134.036.2.056l1,.31c-.066-.02-.133-.039-.2-.056",
    transform: "translate(79.86 -24.285)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114-2",
    "data-name": "Group 114",
    className: "cls-10",
    transform: "translate(0 0.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113-2",
    "data-name": "Group 113",
    className: "cls-383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-2",
    "data-name": "Group 112",
    className: "cls-10",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2519-2",
    "data-name": "Path 2519",
    className: "cls-315",
    d: "M-79.359,39.124l-1-.31a3.136,3.136,0,0,1-.861-.43l1,.31a3.065,3.065,0,0,0,.862.43",
    transform: "translate(84.512 -18.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520-2",
    "data-name": "Path 2520",
    className: "cls-318",
    d: "M-80.109,38.783l-1-.31a4,4,0,0,1-.374-.3l1,.31a3.926,3.926,0,0,0,.373.3",
    transform: "translate(84.4 -18.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521-2",
    "data-name": "Path 2521",
    className: "cls-321",
    d: "M-80.39,38.578l-1-.31q-.156-.141-.3-.3l1,.31c.1.107.2.207.305.3",
    transform: "translate(84.309 -18.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-2",
    "data-name": "Path 2522",
    className: "cls-323",
    d: "M-80.614,38.372l-1-.31c-.094-.1-.184-.206-.273-.315l1,.31c.09.11.18.216.273.315",
    transform: "translate(84.228 -18.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-2",
    "data-name": "Path 2523",
    className: "cls-325",
    d: "M-80.812,38.157l-1-.31c-.086-.107-.17-.22-.251-.335l1,.31c.081.117.166.228.25.335",
    transform: "translate(84.152 -18.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-2",
    "data-name": "Path 2524",
    className: "cls-327",
    d: "M-80.991,37.929l-1-.31c-.08-.114-.158-.234-.234-.357l1,.31c.076.123.154.243.234.357",
    transform: "translate(84.082 -18.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-2",
    "data-name": "Path 2525",
    className: "cls-329",
    d: "M-81.159,37.686l-1-.31c-.076-.124-.15-.251-.221-.383l1,.31c.071.131.146.26.221.383",
    transform: "translate(84.016 -19.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-2",
    "data-name": "Path 2526",
    className: "cls-332",
    d: "M-81.318,37.423l-1-.31c-.071-.13-.14-.263-.207-.4l1,.31c.067.137.136.27.207.4",
    transform: "translate(83.954 -19.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-2",
    "data-name": "Path 2527",
    className: "cls-335",
    d: "M-81.471,37.142l-1-.31c-.061-.13-.123-.261-.181-.4l1,.31c.059.134.118.267.181.4",
    transform: "translate(83.9 -19.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-2",
    "data-name": "Path 2528",
    className: "cls-338",
    d: "M-81.6,36.866l-1-.31c-.057-.13-.113-.264-.166-.4l1,.31c.053.136.108.268.166.4",
    transform: "translate(83.85 -19.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-2",
    "data-name": "Path 2529",
    className: "cls-340",
    d: "M-81.723,36.589l-1-.31c-.053-.133-.1-.267-.151-.4l1,.31c.049.137.1.271.151.4",
    transform: "translate(83.805 -19.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-2",
    "data-name": "Path 2530",
    className: "cls-342",
    d: "M-81.834,36.3l-1-.31c-.047-.131-.091-.264-.136-.4l1,.31c.044.134.089.267.136.4",
    transform: "translate(83.764 -19.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-2",
    "data-name": "Path 2531",
    className: "cls-344",
    d: "M-81.932,36.027l-1-.31c-.043-.134-.084-.27-.123-.405l1,.31c.04.137.081.271.124.405",
    transform: "translate(83.728 -19.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-2",
    "data-name": "Path 2532",
    className: "cls-346",
    d: "M-82.023,35.742l-1-.31c-.04-.133-.076-.267-.111-.4l1,.31c.034.136.071.27.11.4",
    transform: "translate(83.694 -19.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-2",
    "data-name": "Path 2533",
    className: "cls-348",
    d: "M-82.1,35.46l-1-.31c-.036-.133-.069-.267-.1-.4l1,.31c.031.136.064.27.1.4",
    transform: "translate(83.664 -20.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-2",
    "data-name": "Path 2534",
    className: "cls-351",
    d: "M-82.177,35.177l-1-.31c-.031-.131-.06-.264-.089-.4l1,.31c.027.134.057.267.089.4",
    transform: "translate(83.638 -20.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-2",
    "data-name": "Path 2535",
    className: "cls-353",
    d: "M-82.242,34.9l-1-.31c-.027-.13-.053-.26-.077-.391l1,.311q.036.195.077.39",
    transform: "translate(83.615 -20.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-2",
    "data-name": "Path 2536",
    className: "cls-354",
    d: "M-82.3,34.622l-1-.311c-.024-.127-.046-.256-.067-.385l1,.31c.021.13.043.258.067.387",
    transform: "translate(83.595 -20.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-2",
    "data-name": "Path 2537",
    className: "cls-223",
    d: "M-82.35,34.345l-1-.31q-.03-.184-.056-.368l1,.31q.026.184.056.368",
    transform: "translate(83.578 -20.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-2",
    "data-name": "Path 2538",
    className: "cls-220",
    d: "M-82.391,34.085l-1-.31c-.017-.121-.033-.241-.047-.361l1,.31c.014.12.03.241.047.361",
    transform: "translate(83.564 -20.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-2",
    "data-name": "Path 2539",
    className: "cls-218",
    d: "M-82.427,33.826l-1-.31c-.014-.114-.027-.227-.039-.341l1,.311c.011.113.024.226.039.34",
    transform: "translate(83.552 -20.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540-2",
    "data-name": "Path 2540",
    className: "cls-216",
    d: "M-82.456,33.583l-1-.311-.03-.323,1,.31c.01.107.02.216.03.324",
    transform: "translate(83.543 -20.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-2",
    "data-name": "Path 2541",
    className: "cls-214",
    d: "M-82.479,33.353l-1-.31c-.009-.106-.016-.21-.023-.314l1,.311c.007.1.014.208.023.313",
    transform: "translate(83.537 -20.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-2",
    "data-name": "Path 2542",
    className: "cls-210",
    d: "M-82.5,33.123l-1-.311c-.006-.093-.011-.184-.016-.277l1,.31c0,.093.01.186.016.278",
    transform: "translate(83.532 -20.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543-2",
    "data-name": "Path 2543",
    className: "cls-208",
    d: "M-82.51,32.927l-1-.31c0-.091-.009-.184-.011-.275l1,.31c0,.091.007.184.011.275",
    transform: "translate(83.528 -21.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544-2",
    "data-name": "Path 2544",
    className: "cls-359",
    d: "M-82.519,32.771l-1-.31c0-.133-.007-.265-.009-.4l1,.31c0,.131,0,.264.009.4",
    transform: "translate(83.526 -21.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545-2",
    "data-name": "Path 2545",
    className: "cls-360",
    d: "M-82.527,32.527l-1-.31c0-.161,0-.321,0-.48v-.033l1,.311v.031c0,.158,0,.318,0,.48",
    transform: "translate(83.526 -21.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546-2",
    "data-name": "Path 2546",
    className: "cls-257",
    d: "M-82.525,32.181l-1-.311c0-.183.011-.367.021-.55l1,.31c-.01.183-.017.367-.021.551",
    transform: "translate(83.527 -21.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547-2",
    "data-name": "Path 2547",
    className: "cls-268",
    d: "M-82.51,31.76l-1-.31c.009-.146.019-.29.031-.435l1,.31c-.013.146-.023.29-.031.435",
    transform: "translate(83.533 -21.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548-2",
    "data-name": "Path 2548",
    className: "cls-361",
    d: "M-82.488,31.442l-1-.31c.011-.13.024-.261.039-.391l1,.31c-.014.13-.026.261-.037.391",
    transform: "translate(83.543 -21.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549-2",
    "data-name": "Path 2549",
    className: "cls-362",
    d: "M-82.463,31.144l-1-.31c.011-.1.023-.208.037-.313l1,.31c-.014.1-.026.208-.039.313",
    transform: "translate(83.554 -21.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550-2",
    "data-name": "Path 2550",
    className: "cls-363",
    d: "M-82.435,30.922l-1-.31q.019-.15.043-.3l1,.31c-.014.1-.029.2-.041.3",
    transform: "translate(83.565 -21.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551-2",
    "data-name": "Path 2551",
    className: "cls-364",
    d: "M-82.407,30.706l-1-.31c.013-.094.029-.187.044-.28l1,.31c-.016.093-.031.187-.046.28",
    transform: "translate(83.578 -22.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552-2",
    "data-name": "Path 2552",
    className: "cls-365",
    d: "M-82.374,30.5l-1-.31c.014-.087.03-.174.046-.26l1,.31c-.016.087-.031.173-.046.26",
    transform: "translate(83.591 -22.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553-2",
    "data-name": "Path 2553",
    className: "cls-366",
    d: "M-82.342,30.321l-1-.31c.017-.086.033-.173.051-.258l1,.311c-.019.086-.034.171-.051.257",
    transform: "translate(83.605 -22.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554-2",
    "data-name": "Path 2554",
    className: "cls-367",
    d: "M-82.306,30.139l-1-.311c.017-.083.034-.166.053-.248l1,.31c-.019.083-.036.166-.053.25",
    transform: "translate(83.62 -22.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555-2",
    "data-name": "Path 2555",
    className: "cls-368",
    d: "M-82.269,29.962l-1-.31c.019-.081.037-.163.057-.244l1,.31c-.02.081-.039.163-.057.244",
    transform: "translate(83.636 -22.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556-2",
    "data-name": "Path 2556",
    className: "cls-369",
    d: "M-82.229,29.79l-1-.31c.019-.081.04-.163.06-.243l1,.31c-.02.081-.041.161-.06.243",
    transform: "translate(83.653 -22.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557-2",
    "data-name": "Path 2557",
    className: "cls-370",
    d: "M-82.187,29.628l-1-.31c.023-.09.047-.178.073-.267l1,.31c-.026.089-.05.178-.073.267",
    transform: "translate(83.671 -22.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558-2",
    "data-name": "Path 2558",
    className: "cls-372",
    d: "M-82.136,29.44l-1-.31q.036-.133.077-.265l1,.31c-.026.089-.051.177-.076.265",
    transform: "translate(83.693 -22.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559-2",
    "data-name": "Path 2559",
    className: "cls-373",
    d: "M-82.084,29.265l-1-.31c.03-.1.061-.2.093-.3l1,.311c-.031.1-.063.2-.094.3",
    transform: "translate(83.716 -22.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560-2",
    "data-name": "Path 2560",
    className: "cls-374",
    d: "M-82.017,29.068l-1-.311c.039-.114.077-.228.117-.343l1,.311c-.04.113-.079.227-.117.343",
    transform: "translate(83.744 -22.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561-2",
    "data-name": "Path 2561",
    className: "cls-375",
    d: "M-81.935,28.9l-1-.311c.07-.2.143-.388.22-.577l1,.31c-.077.19-.15.383-.22.578",
    transform: "translate(83.779 -22.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562-2",
    "data-name": "Path 2562",
    className: "cls-376",
    d: "M-81.781,28.506l-1-.31q.131-.319.274-.622l1,.31c-.1.2-.187.411-.274.622",
    transform: "translate(83.845 -23.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563-2",
    "data-name": "Path 2563",
    className: "cls-375",
    d: "M-81.589,28.028l-1-.31c.079-.164.158-.324.241-.481l1,.311c-.083.157-.164.317-.241.48",
    transform: "translate(83.927 -23.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564-2",
    "data-name": "Path 2564",
    className: "cls-374",
    d: "M-81.42,27.64l-1-.311c.056-.1.113-.206.17-.307l1,.31c-.059.1-.114.2-.17.308",
    transform: "translate(83.999 -23.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565-2",
    "data-name": "Path 2565",
    className: "cls-373",
    d: "M-81.3,27.389l-1-.31c.037-.064.074-.128.113-.191l1,.31-.111.191",
    transform: "translate(84.05 -23.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566-2",
    "data-name": "Path 2566",
    className: "cls-372",
    d: "M-81.224,27.254l-1-.31c.037-.064.076-.126.114-.188l1,.31-.116.188",
    transform: "translate(84.084 -23.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567-2",
    "data-name": "Path 2567",
    className: "cls-370",
    d: "M-81.142,27.118l-1-.31.113-.176,1,.311c-.039.057-.076.116-.113.174",
    transform: "translate(84.118 -23.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568-2",
    "data-name": "Path 2568",
    className: "cls-369",
    d: "M-81.063,26.989l-1-.311c.033-.05.066-.1.1-.148l1,.311c-.034.049-.067.1-.1.148",
    transform: "translate(84.152 -23.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569-2",
    "data-name": "Path 2569",
    className: "cls-368",
    d: "M-80.993,26.884l-1-.311c.033-.049.067-.1.1-.146l1,.31c-.034.049-.069.1-.1.147",
    transform: "translate(84.182 -23.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570-2",
    "data-name": "Path 2570",
    className: "cls-367",
    d: "M-80.922,26.78l-1-.31.1-.143,1,.31-.1.143",
    transform: "translate(84.212 -23.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571-2",
    "data-name": "Path 2571",
    className: "cls-366",
    d: "M-80.85,26.68l-1-.31.107-.143,1,.31-.107.143",
    transform: "translate(84.243 -23.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572-2",
    "data-name": "Path 2572",
    className: "cls-365",
    d: "M-80.775,26.579l-1-.31.111-.14,1,.31c-.037.046-.073.093-.11.14",
    transform: "translate(84.275 -23.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573-2",
    "data-name": "Path 2573",
    className: "cls-364",
    d: "M-80.7,26.48l-1-.31c.036-.047.074-.093.111-.138l1,.31c-.037.046-.076.091-.113.138",
    transform: "translate(84.308 -23.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574-2",
    "data-name": "Path 2574",
    className: "cls-363",
    d: "M-80.619,26.385l-1-.31c.04-.049.081-.1.121-.143l1,.31c-.041.047-.081.094-.121.143",
    transform: "translate(84.341 -23.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575-2",
    "data-name": "Path 2575",
    className: "cls-362",
    d: "M-80.534,26.29l-1-.31.144-.163,1,.311c-.049.053-.1.107-.144.161",
    transform: "translate(84.378 -23.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576-2",
    "data-name": "Path 2576",
    className: "cls-361",
    d: "M-80.433,26.176l-1-.311c.049-.053.1-.1.147-.156l1,.31c-.049.051-.1.1-.147.157",
    transform: "translate(84.421 -23.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577-2",
    "data-name": "Path 2577",
    className: "cls-268",
    d: "M-80.33,26.076l-1-.31c.063-.066.126-.128.19-.19l1,.31c-.064.061-.127.126-.19.19",
    transform: "translate(84.465 -23.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578-2",
    "data-name": "Path 2578",
    className: "cls-257",
    d: "M-80.2,25.952l-1-.31c.077-.076.156-.148.236-.22l1,.31c-.08.071-.158.144-.236.22",
    transform: "translate(84.522 -24.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579-2",
    "data-name": "Path 2579",
    className: "cls-360",
    d: "M-80.032,25.826l-1-.31c.123-.11.25-.216.38-.315l1,.31c-.128.1-.256.206-.378.315",
    transform: "translate(84.592 -24.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580-2",
    "data-name": "Path 2580",
    className: "cls-359",
    d: "M-79.768,25.725l-1-.31a6.39,6.39,0,0,1,1.149-.715l1,.31a6.4,6.4,0,0,0-1.15.715",
    transform: "translate(84.706 -24.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581-2",
    "data-name": "Path 2581",
    className: "cls-208",
    d: "M-78.961,25.042l-1-.31c.079-.039.158-.074.238-.108l1,.31c-.081.034-.16.07-.238.108",
    transform: "translate(85.05 -24.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582-2",
    "data-name": "Path 2582",
    className: "cls-210",
    d: "M-78.794,24.963l-1-.31c.08-.034.161-.067.243-.1l1,.311c-.083.03-.163.063-.243.1",
    transform: "translate(85.121 -24.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583-2",
    "data-name": "Path 2583",
    className: "cls-214",
    d: "M-78.624,24.885l-1-.311c.057-.021.116-.041.173-.061l1,.31-.173.063",
    transform: "translate(85.194 -24.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584-2",
    "data-name": "Path 2584",
    className: "cls-216",
    d: "M-78.5,24.838l-1-.31.168-.054,1,.31-.168.054",
    transform: "translate(85.246 -24.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585-2",
    "data-name": "Path 2585",
    className: "cls-218",
    d: "M-78.385,24.8l-1-.31.171-.049,1,.31-.171.049",
    transform: "translate(85.296 -24.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586-2",
    "data-name": "Path 2586",
    className: "cls-220",
    d: "M-78.265,24.754l-1-.31.049-.013,1,.31-.047.013",
    transform: "translate(85.347 -24.431)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115-2",
    "data-name": "Group 115",
    transform: "translate(0.996 0.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2588-2",
    "data-name": "Path 2588",
    className: "cls-9",
    d: "M-76.695,24.7c3.647-.952,5.864,2.412,5.767,7.311S-73.455,44.115-77.1,45.067-82.921,40-82.824,35.112-80.35,25.651-76.695,24.7Z",
    transform: "translate(82.827 -24.535)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMangIcon);
export default __webpack_public_path__ + "static/media/DeviceMangIcon.92ad95d283e6de6f559f3859050aa5bb.svg";
export { ForwardRef as ReactComponent };